// This client was generated by Platformatic from an OpenAPI specification.

import type { Api } from './api-types'
import type * as Types from './api-types'

// The base URL for the API. This can be overridden by calling `setBaseUrl`.
let baseUrl = ''
// The default headers to send within each request. This can be overridden by calling `setDefaultHeaders`.
let defaultHeaders = {}

function sanitizeUrl(url: string) : string {
  if (url.endsWith('/')) { return url.slice(0, -1) } else { return url }
}
export const setBaseUrl = (newUrl: string) : void => { baseUrl = sanitizeUrl(newUrl) }

export const setDefaultHeaders = (headers: Object): void => { defaultHeaders = headers }

type JSON = Record<string, unknown>
/* @ts-ignore */
function headersToJSON(headers: Headers): JSON {
  const output: JSON = {}
  headers.forEach((value, key) => {
    output[key] = value
  })
  return output
}

const _getV1FileUpload = async (url: string, request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  const queryParameters: (keyof Types.GetV1FileUploadRequest)[]  = ['key', 'mimeType', 'partCount']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['file-size'] !== undefined) {
    headers['file-size'] = request['file-size']
    delete request['file-size']
  }

  const response = await fetch(`${url}/v1/file-upload/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FileUpload: Api['getV1FileUpload'] = async (request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  return await _getV1FileUpload(baseUrl, request)
}
const _postV1FileUploadMarkComplete = async (url: string, request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/file-upload/mark-complete`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1FileUploadMarkComplete: Api['postV1FileUploadMarkComplete'] = async (request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  return await _postV1FileUploadMarkComplete(baseUrl, request)
}
const _getV1RentalSettings = async (url: string, request: Types.GetV1RentalSettingsRequest): Promise<Types.GetV1RentalSettingsResponses> => {
  const queryParameters: (keyof Types.GetV1RentalSettingsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-settings/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalSettings: Api['getV1RentalSettings'] = async (request: Types.GetV1RentalSettingsRequest): Promise<Types.GetV1RentalSettingsResponses> => {
  return await _getV1RentalSettings(baseUrl, request)
}
const _patchV1RentalSettingsId = async (url: string, request: Types.PatchV1RentalSettingsIdRequest): Promise<Types.PatchV1RentalSettingsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-settings/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1RentalSettingsId: Api['patchV1RentalSettingsId'] = async (request: Types.PatchV1RentalSettingsIdRequest): Promise<Types.PatchV1RentalSettingsIdResponses> => {
  return await _patchV1RentalSettingsId(baseUrl, request)
}
const _postV1RentalBillingCycles = async (url: string, request: Types.PostV1RentalBillingCyclesRequest): Promise<Types.PostV1RentalBillingCyclesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-billing-cycles/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalBillingCycles: Api['postV1RentalBillingCycles'] = async (request: Types.PostV1RentalBillingCyclesRequest): Promise<Types.PostV1RentalBillingCyclesResponses> => {
  return await _postV1RentalBillingCycles(baseUrl, request)
}
const _getV1RentalBillingCycles = async (url: string, request: Types.GetV1RentalBillingCyclesRequest): Promise<Types.GetV1RentalBillingCyclesResponses> => {
  const queryParameters: (keyof Types.GetV1RentalBillingCyclesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-billing-cycles/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalBillingCycles: Api['getV1RentalBillingCycles'] = async (request: Types.GetV1RentalBillingCyclesRequest): Promise<Types.GetV1RentalBillingCyclesResponses> => {
  return await _getV1RentalBillingCycles(baseUrl, request)
}
const _getV1RentalBillingCyclesId = async (url: string, request: Types.GetV1RentalBillingCyclesIdRequest): Promise<Types.GetV1RentalBillingCyclesIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalBillingCyclesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-billing-cycles/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalBillingCyclesId: Api['getV1RentalBillingCyclesId'] = async (request: Types.GetV1RentalBillingCyclesIdRequest): Promise<Types.GetV1RentalBillingCyclesIdResponses> => {
  return await _getV1RentalBillingCyclesId(baseUrl, request)
}
const _putV1RentalBillingCyclesId = async (url: string, request: Types.PutV1RentalBillingCyclesIdRequest): Promise<Types.PutV1RentalBillingCyclesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-billing-cycles/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalBillingCyclesId: Api['putV1RentalBillingCyclesId'] = async (request: Types.PutV1RentalBillingCyclesIdRequest): Promise<Types.PutV1RentalBillingCyclesIdResponses> => {
  return await _putV1RentalBillingCyclesId(baseUrl, request)
}
const _deleteV1RentalBillingCyclesId = async (url: string, request: Types.DeleteV1RentalBillingCyclesIdRequest): Promise<Types.DeleteV1RentalBillingCyclesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-billing-cycles/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalBillingCyclesId: Api['deleteV1RentalBillingCyclesId'] = async (request: Types.DeleteV1RentalBillingCyclesIdRequest): Promise<Types.DeleteV1RentalBillingCyclesIdResponses> => {
  return await _deleteV1RentalBillingCyclesId(baseUrl, request)
}
const _getV1RentalBillingCyclesGenerateExcel = async (url: string, request: Types.GetV1RentalBillingCyclesGenerateExcelRequest): Promise<Types.GetV1RentalBillingCyclesGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1RentalBillingCyclesGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/rental-billing-cycles/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalBillingCyclesGenerateExcel: Api['getV1RentalBillingCyclesGenerateExcel'] = async (request: Types.GetV1RentalBillingCyclesGenerateExcelRequest): Promise<Types.GetV1RentalBillingCyclesGenerateExcelResponses> => {
  return await _getV1RentalBillingCyclesGenerateExcel(baseUrl, request)
}
const _postV1RentalBillingCyclesImport = async (url: string, request: Types.PostV1RentalBillingCyclesImportRequest): Promise<Types.PostV1RentalBillingCyclesImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-billing-cycles/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalBillingCyclesImport: Api['postV1RentalBillingCyclesImport'] = async (request: Types.PostV1RentalBillingCyclesImportRequest): Promise<Types.PostV1RentalBillingCyclesImportResponses> => {
  return await _postV1RentalBillingCyclesImport(baseUrl, request)
}
const _postV1RentalTermsConditions = async (url: string, request: Types.PostV1RentalTermsConditionsRequest): Promise<Types.PostV1RentalTermsConditionsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-terms-conditions/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalTermsConditions: Api['postV1RentalTermsConditions'] = async (request: Types.PostV1RentalTermsConditionsRequest): Promise<Types.PostV1RentalTermsConditionsResponses> => {
  return await _postV1RentalTermsConditions(baseUrl, request)
}
const _getV1RentalTermsConditions = async (url: string, request: Types.GetV1RentalTermsConditionsRequest): Promise<Types.GetV1RentalTermsConditionsResponses> => {
  const queryParameters: (keyof Types.GetV1RentalTermsConditionsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-terms-conditions/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalTermsConditions: Api['getV1RentalTermsConditions'] = async (request: Types.GetV1RentalTermsConditionsRequest): Promise<Types.GetV1RentalTermsConditionsResponses> => {
  return await _getV1RentalTermsConditions(baseUrl, request)
}
const _getV1RentalTermsConditionsId = async (url: string, request: Types.GetV1RentalTermsConditionsIdRequest): Promise<Types.GetV1RentalTermsConditionsIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalTermsConditionsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-terms-conditions/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalTermsConditionsId: Api['getV1RentalTermsConditionsId'] = async (request: Types.GetV1RentalTermsConditionsIdRequest): Promise<Types.GetV1RentalTermsConditionsIdResponses> => {
  return await _getV1RentalTermsConditionsId(baseUrl, request)
}
const _putV1RentalTermsConditionsId = async (url: string, request: Types.PutV1RentalTermsConditionsIdRequest): Promise<Types.PutV1RentalTermsConditionsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-terms-conditions/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalTermsConditionsId: Api['putV1RentalTermsConditionsId'] = async (request: Types.PutV1RentalTermsConditionsIdRequest): Promise<Types.PutV1RentalTermsConditionsIdResponses> => {
  return await _putV1RentalTermsConditionsId(baseUrl, request)
}
const _deleteV1RentalTermsConditionsId = async (url: string, request: Types.DeleteV1RentalTermsConditionsIdRequest): Promise<Types.DeleteV1RentalTermsConditionsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-terms-conditions/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalTermsConditionsId: Api['deleteV1RentalTermsConditionsId'] = async (request: Types.DeleteV1RentalTermsConditionsIdRequest): Promise<Types.DeleteV1RentalTermsConditionsIdResponses> => {
  return await _deleteV1RentalTermsConditionsId(baseUrl, request)
}
const _patchV1RentalTermsConditionsStatusId = async (url: string, request: Types.PatchV1RentalTermsConditionsStatusIdRequest): Promise<Types.PatchV1RentalTermsConditionsStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-terms-conditions/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1RentalTermsConditionsStatusId: Api['patchV1RentalTermsConditionsStatusId'] = async (request: Types.PatchV1RentalTermsConditionsStatusIdRequest): Promise<Types.PatchV1RentalTermsConditionsStatusIdResponses> => {
  return await _patchV1RentalTermsConditionsStatusId(baseUrl, request)
}
const _getV1RentalTermsConditionsGenerateExcel = async (url: string, request: Types.GetV1RentalTermsConditionsGenerateExcelRequest): Promise<Types.GetV1RentalTermsConditionsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1RentalTermsConditionsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/rental-terms-conditions/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalTermsConditionsGenerateExcel: Api['getV1RentalTermsConditionsGenerateExcel'] = async (request: Types.GetV1RentalTermsConditionsGenerateExcelRequest): Promise<Types.GetV1RentalTermsConditionsGenerateExcelResponses> => {
  return await _getV1RentalTermsConditionsGenerateExcel(baseUrl, request)
}
const _postV1RentalTermsConditionsImport = async (url: string, request: Types.PostV1RentalTermsConditionsImportRequest): Promise<Types.PostV1RentalTermsConditionsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-terms-conditions/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalTermsConditionsImport: Api['postV1RentalTermsConditionsImport'] = async (request: Types.PostV1RentalTermsConditionsImportRequest): Promise<Types.PostV1RentalTermsConditionsImportResponses> => {
  return await _postV1RentalTermsConditionsImport(baseUrl, request)
}
const _getV1RentalLead = async (url: string, request: Types.GetV1RentalLeadRequest): Promise<Types.GetV1RentalLeadResponses> => {
  const queryParameters: (keyof Types.GetV1RentalLeadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalLead: Api['getV1RentalLead'] = async (request: Types.GetV1RentalLeadRequest): Promise<Types.GetV1RentalLeadResponses> => {
  return await _getV1RentalLead(baseUrl, request)
}
const _postV1RentalLead = async (url: string, request: Types.PostV1RentalLeadRequest): Promise<Types.PostV1RentalLeadResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalLead: Api['postV1RentalLead'] = async (request: Types.PostV1RentalLeadRequest): Promise<Types.PostV1RentalLeadResponses> => {
  return await _postV1RentalLead(baseUrl, request)
}
const _postV1RentalLeadSaveAsDraft = async (url: string, request: Types.PostV1RentalLeadSaveAsDraftRequest): Promise<Types.PostV1RentalLeadSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalLeadSaveAsDraft: Api['postV1RentalLeadSaveAsDraft'] = async (request: Types.PostV1RentalLeadSaveAsDraftRequest): Promise<Types.PostV1RentalLeadSaveAsDraftResponses> => {
  return await _postV1RentalLeadSaveAsDraft(baseUrl, request)
}
const _getV1RentalLeadId = async (url: string, request: Types.GetV1RentalLeadIdRequest): Promise<Types.GetV1RentalLeadIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalLeadIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalLeadId: Api['getV1RentalLeadId'] = async (request: Types.GetV1RentalLeadIdRequest): Promise<Types.GetV1RentalLeadIdResponses> => {
  return await _getV1RentalLeadId(baseUrl, request)
}
const _putV1RentalLeadId = async (url: string, request: Types.PutV1RentalLeadIdRequest): Promise<Types.PutV1RentalLeadIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalLeadId: Api['putV1RentalLeadId'] = async (request: Types.PutV1RentalLeadIdRequest): Promise<Types.PutV1RentalLeadIdResponses> => {
  return await _putV1RentalLeadId(baseUrl, request)
}
const _deleteV1RentalLeadId = async (url: string, request: Types.DeleteV1RentalLeadIdRequest): Promise<Types.DeleteV1RentalLeadIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalLeadId: Api['deleteV1RentalLeadId'] = async (request: Types.DeleteV1RentalLeadIdRequest): Promise<Types.DeleteV1RentalLeadIdResponses> => {
  return await _deleteV1RentalLeadId(baseUrl, request)
}
const _patchV1RentalLeadLeadStatusId = async (url: string, request: Types.PatchV1RentalLeadLeadStatusIdRequest): Promise<Types.PatchV1RentalLeadLeadStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/lead-status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1RentalLeadLeadStatusId: Api['patchV1RentalLeadLeadStatusId'] = async (request: Types.PatchV1RentalLeadLeadStatusIdRequest): Promise<Types.PatchV1RentalLeadLeadStatusIdResponses> => {
  return await _patchV1RentalLeadLeadStatusId(baseUrl, request)
}
const _patchV1RentalLeadLeadToOpportunityId = async (url: string, request: Types.PatchV1RentalLeadLeadToOpportunityIdRequest): Promise<Types.PatchV1RentalLeadLeadToOpportunityIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/lead-to-opportunity/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1RentalLeadLeadToOpportunityId: Api['patchV1RentalLeadLeadToOpportunityId'] = async (request: Types.PatchV1RentalLeadLeadToOpportunityIdRequest): Promise<Types.PatchV1RentalLeadLeadToOpportunityIdResponses> => {
  return await _patchV1RentalLeadLeadToOpportunityId(baseUrl, request)
}
const _postV1RentalLeadFollowup = async (url: string, request: Types.PostV1RentalLeadFollowupRequest): Promise<Types.PostV1RentalLeadFollowupResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/followup/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalLeadFollowup: Api['postV1RentalLeadFollowup'] = async (request: Types.PostV1RentalLeadFollowupRequest): Promise<Types.PostV1RentalLeadFollowupResponses> => {
  return await _postV1RentalLeadFollowup(baseUrl, request)
}
const _getV1RentalLeadFollowup = async (url: string, request: Types.GetV1RentalLeadFollowupRequest): Promise<Types.GetV1RentalLeadFollowupResponses> => {
  const queryParameters: (keyof Types.GetV1RentalLeadFollowupRequest)[]  = ['partyId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/followup/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalLeadFollowup: Api['getV1RentalLeadFollowup'] = async (request: Types.GetV1RentalLeadFollowupRequest): Promise<Types.GetV1RentalLeadFollowupResponses> => {
  return await _getV1RentalLeadFollowup(baseUrl, request)
}
const _getV1RentalLeadFollowupId = async (url: string, request: Types.GetV1RentalLeadFollowupIdRequest): Promise<Types.GetV1RentalLeadFollowupIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalLeadFollowupIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/followup/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalLeadFollowupId: Api['getV1RentalLeadFollowupId'] = async (request: Types.GetV1RentalLeadFollowupIdRequest): Promise<Types.GetV1RentalLeadFollowupIdResponses> => {
  return await _getV1RentalLeadFollowupId(baseUrl, request)
}
const _deleteV1RentalLeadFollowupId = async (url: string, request: Types.DeleteV1RentalLeadFollowupIdRequest): Promise<Types.DeleteV1RentalLeadFollowupIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/followup/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalLeadFollowupId: Api['deleteV1RentalLeadFollowupId'] = async (request: Types.DeleteV1RentalLeadFollowupIdRequest): Promise<Types.DeleteV1RentalLeadFollowupIdResponses> => {
  return await _deleteV1RentalLeadFollowupId(baseUrl, request)
}
const _putV1RentalLeadFollowupId = async (url: string, request: Types.PutV1RentalLeadFollowupIdRequest): Promise<Types.PutV1RentalLeadFollowupIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/followup/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalLeadFollowupId: Api['putV1RentalLeadFollowupId'] = async (request: Types.PutV1RentalLeadFollowupIdRequest): Promise<Types.PutV1RentalLeadFollowupIdResponses> => {
  return await _putV1RentalLeadFollowupId(baseUrl, request)
}
const _postV1RentalLeadCommunicationLog = async (url: string, request: Types.PostV1RentalLeadCommunicationLogRequest): Promise<Types.PostV1RentalLeadCommunicationLogResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/communication-log/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalLeadCommunicationLog: Api['postV1RentalLeadCommunicationLog'] = async (request: Types.PostV1RentalLeadCommunicationLogRequest): Promise<Types.PostV1RentalLeadCommunicationLogResponses> => {
  return await _postV1RentalLeadCommunicationLog(baseUrl, request)
}
const _getV1RentalLeadCommunicationLog = async (url: string, request: Types.GetV1RentalLeadCommunicationLogRequest): Promise<Types.GetV1RentalLeadCommunicationLogResponses> => {
  const queryParameters: (keyof Types.GetV1RentalLeadCommunicationLogRequest)[]  = ['partyId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/communication-log/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalLeadCommunicationLog: Api['getV1RentalLeadCommunicationLog'] = async (request: Types.GetV1RentalLeadCommunicationLogRequest): Promise<Types.GetV1RentalLeadCommunicationLogResponses> => {
  return await _getV1RentalLeadCommunicationLog(baseUrl, request)
}
const _getV1RentalLeadCommunicationLogId = async (url: string, request: Types.GetV1RentalLeadCommunicationLogIdRequest): Promise<Types.GetV1RentalLeadCommunicationLogIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalLeadCommunicationLogIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/communication-log/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalLeadCommunicationLogId: Api['getV1RentalLeadCommunicationLogId'] = async (request: Types.GetV1RentalLeadCommunicationLogIdRequest): Promise<Types.GetV1RentalLeadCommunicationLogIdResponses> => {
  return await _getV1RentalLeadCommunicationLogId(baseUrl, request)
}
const _deleteV1RentalLeadCommunicationLogId = async (url: string, request: Types.DeleteV1RentalLeadCommunicationLogIdRequest): Promise<Types.DeleteV1RentalLeadCommunicationLogIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/communication-log/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalLeadCommunicationLogId: Api['deleteV1RentalLeadCommunicationLogId'] = async (request: Types.DeleteV1RentalLeadCommunicationLogIdRequest): Promise<Types.DeleteV1RentalLeadCommunicationLogIdResponses> => {
  return await _deleteV1RentalLeadCommunicationLogId(baseUrl, request)
}
const _putV1RentalLeadCommunicationLogId = async (url: string, request: Types.PutV1RentalLeadCommunicationLogIdRequest): Promise<Types.PutV1RentalLeadCommunicationLogIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/communication-log/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalLeadCommunicationLogId: Api['putV1RentalLeadCommunicationLogId'] = async (request: Types.PutV1RentalLeadCommunicationLogIdRequest): Promise<Types.PutV1RentalLeadCommunicationLogIdResponses> => {
  return await _putV1RentalLeadCommunicationLogId(baseUrl, request)
}
const _postV1RentalLeadAddress = async (url: string, request: Types.PostV1RentalLeadAddressRequest): Promise<Types.PostV1RentalLeadAddressResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/address/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalLeadAddress: Api['postV1RentalLeadAddress'] = async (request: Types.PostV1RentalLeadAddressRequest): Promise<Types.PostV1RentalLeadAddressResponses> => {
  return await _postV1RentalLeadAddress(baseUrl, request)
}
const _getV1RentalLeadAddress = async (url: string, request: Types.GetV1RentalLeadAddressRequest): Promise<Types.GetV1RentalLeadAddressResponses> => {
  const queryParameters: (keyof Types.GetV1RentalLeadAddressRequest)[]  = ['leadId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/address/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalLeadAddress: Api['getV1RentalLeadAddress'] = async (request: Types.GetV1RentalLeadAddressRequest): Promise<Types.GetV1RentalLeadAddressResponses> => {
  return await _getV1RentalLeadAddress(baseUrl, request)
}
const _getV1RentalLeadAddressId = async (url: string, request: Types.GetV1RentalLeadAddressIdRequest): Promise<Types.GetV1RentalLeadAddressIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalLeadAddressIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/address/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalLeadAddressId: Api['getV1RentalLeadAddressId'] = async (request: Types.GetV1RentalLeadAddressIdRequest): Promise<Types.GetV1RentalLeadAddressIdResponses> => {
  return await _getV1RentalLeadAddressId(baseUrl, request)
}
const _deleteV1RentalLeadAddressId = async (url: string, request: Types.DeleteV1RentalLeadAddressIdRequest): Promise<Types.DeleteV1RentalLeadAddressIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/address/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalLeadAddressId: Api['deleteV1RentalLeadAddressId'] = async (request: Types.DeleteV1RentalLeadAddressIdRequest): Promise<Types.DeleteV1RentalLeadAddressIdResponses> => {
  return await _deleteV1RentalLeadAddressId(baseUrl, request)
}
const _putV1RentalLeadAddressId = async (url: string, request: Types.PutV1RentalLeadAddressIdRequest): Promise<Types.PutV1RentalLeadAddressIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/address/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalLeadAddressId: Api['putV1RentalLeadAddressId'] = async (request: Types.PutV1RentalLeadAddressIdRequest): Promise<Types.PutV1RentalLeadAddressIdResponses> => {
  return await _putV1RentalLeadAddressId(baseUrl, request)
}
const _postV1RentalLeadContact = async (url: string, request: Types.PostV1RentalLeadContactRequest): Promise<Types.PostV1RentalLeadContactResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/contact/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalLeadContact: Api['postV1RentalLeadContact'] = async (request: Types.PostV1RentalLeadContactRequest): Promise<Types.PostV1RentalLeadContactResponses> => {
  return await _postV1RentalLeadContact(baseUrl, request)
}
const _getV1RentalLeadContact = async (url: string, request: Types.GetV1RentalLeadContactRequest): Promise<Types.GetV1RentalLeadContactResponses> => {
  const queryParameters: (keyof Types.GetV1RentalLeadContactRequest)[]  = ['leadId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/contact/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalLeadContact: Api['getV1RentalLeadContact'] = async (request: Types.GetV1RentalLeadContactRequest): Promise<Types.GetV1RentalLeadContactResponses> => {
  return await _getV1RentalLeadContact(baseUrl, request)
}
const _getV1RentalLeadContactId = async (url: string, request: Types.GetV1RentalLeadContactIdRequest): Promise<Types.GetV1RentalLeadContactIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalLeadContactIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/contact/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalLeadContactId: Api['getV1RentalLeadContactId'] = async (request: Types.GetV1RentalLeadContactIdRequest): Promise<Types.GetV1RentalLeadContactIdResponses> => {
  return await _getV1RentalLeadContactId(baseUrl, request)
}
const _deleteV1RentalLeadContactId = async (url: string, request: Types.DeleteV1RentalLeadContactIdRequest): Promise<Types.DeleteV1RentalLeadContactIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/contact/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalLeadContactId: Api['deleteV1RentalLeadContactId'] = async (request: Types.DeleteV1RentalLeadContactIdRequest): Promise<Types.DeleteV1RentalLeadContactIdResponses> => {
  return await _deleteV1RentalLeadContactId(baseUrl, request)
}
const _putV1RentalLeadContactId = async (url: string, request: Types.PutV1RentalLeadContactIdRequest): Promise<Types.PutV1RentalLeadContactIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/contact/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalLeadContactId: Api['putV1RentalLeadContactId'] = async (request: Types.PutV1RentalLeadContactIdRequest): Promise<Types.PutV1RentalLeadContactIdResponses> => {
  return await _putV1RentalLeadContactId(baseUrl, request)
}
const _getV1RentalLeadIdDownload = async (url: string, request: Types.GetV1RentalLeadIdDownloadRequest): Promise<Types.GetV1RentalLeadIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1RentalLeadIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalLeadIdDownload: Api['getV1RentalLeadIdDownload'] = async (request: Types.GetV1RentalLeadIdDownloadRequest): Promise<Types.GetV1RentalLeadIdDownloadResponses> => {
  return await _getV1RentalLeadIdDownload(baseUrl, request)
}
const _getV1RentalLeadIdSendEmail = async (url: string, request: Types.GetV1RentalLeadIdSendEmailRequest): Promise<Types.GetV1RentalLeadIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1RentalLeadIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalLeadIdSendEmail: Api['getV1RentalLeadIdSendEmail'] = async (request: Types.GetV1RentalLeadIdSendEmailRequest): Promise<Types.GetV1RentalLeadIdSendEmailResponses> => {
  return await _getV1RentalLeadIdSendEmail(baseUrl, request)
}
const _getV1RentalLeadGenerateExcel = async (url: string, request: Types.GetV1RentalLeadGenerateExcelRequest): Promise<Types.GetV1RentalLeadGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1RentalLeadGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalLeadGenerateExcel: Api['getV1RentalLeadGenerateExcel'] = async (request: Types.GetV1RentalLeadGenerateExcelRequest): Promise<Types.GetV1RentalLeadGenerateExcelResponses> => {
  return await _getV1RentalLeadGenerateExcel(baseUrl, request)
}
const _postV1RentalLeadImport = async (url: string, request: Types.PostV1RentalLeadImportRequest): Promise<Types.PostV1RentalLeadImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-lead/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalLeadImport: Api['postV1RentalLeadImport'] = async (request: Types.PostV1RentalLeadImportRequest): Promise<Types.PostV1RentalLeadImportResponses> => {
  return await _postV1RentalLeadImport(baseUrl, request)
}
const _postV1RentalOpportunityPromotionCheck = async (url: string, request: Types.PostV1RentalOpportunityPromotionCheckRequest): Promise<Types.PostV1RentalOpportunityPromotionCheckResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/promotion/check/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOpportunityPromotionCheck: Api['postV1RentalOpportunityPromotionCheck'] = async (request: Types.PostV1RentalOpportunityPromotionCheckRequest): Promise<Types.PostV1RentalOpportunityPromotionCheckResponses> => {
  return await _postV1RentalOpportunityPromotionCheck(baseUrl, request)
}
const _postV1RentalOpportunityPromotionApply = async (url: string, request: Types.PostV1RentalOpportunityPromotionApplyRequest): Promise<Types.PostV1RentalOpportunityPromotionApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/promotion/apply/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOpportunityPromotionApply: Api['postV1RentalOpportunityPromotionApply'] = async (request: Types.PostV1RentalOpportunityPromotionApplyRequest): Promise<Types.PostV1RentalOpportunityPromotionApplyResponses> => {
  return await _postV1RentalOpportunityPromotionApply(baseUrl, request)
}
const _postV1RentalOpportunityPromotionItemApply = async (url: string, request: Types.PostV1RentalOpportunityPromotionItemApplyRequest): Promise<Types.PostV1RentalOpportunityPromotionItemApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/promotion/item/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOpportunityPromotionItemApply: Api['postV1RentalOpportunityPromotionItemApply'] = async (request: Types.PostV1RentalOpportunityPromotionItemApplyRequest): Promise<Types.PostV1RentalOpportunityPromotionItemApplyResponses> => {
  return await _postV1RentalOpportunityPromotionItemApply(baseUrl, request)
}
const _deleteV1RentalOpportunityPromotionId = async (url: string, request: Types.DeleteV1RentalOpportunityPromotionIdRequest): Promise<Types.DeleteV1RentalOpportunityPromotionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/promotion/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalOpportunityPromotionId: Api['deleteV1RentalOpportunityPromotionId'] = async (request: Types.DeleteV1RentalOpportunityPromotionIdRequest): Promise<Types.DeleteV1RentalOpportunityPromotionIdResponses> => {
  return await _deleteV1RentalOpportunityPromotionId(baseUrl, request)
}
const _getV1RentalOpportunity = async (url: string, request: Types.GetV1RentalOpportunityRequest): Promise<Types.GetV1RentalOpportunityResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOpportunityRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOpportunity: Api['getV1RentalOpportunity'] = async (request: Types.GetV1RentalOpportunityRequest): Promise<Types.GetV1RentalOpportunityResponses> => {
  return await _getV1RentalOpportunity(baseUrl, request)
}
const _postV1RentalOpportunity = async (url: string, request: Types.PostV1RentalOpportunityRequest): Promise<Types.PostV1RentalOpportunityResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOpportunity: Api['postV1RentalOpportunity'] = async (request: Types.PostV1RentalOpportunityRequest): Promise<Types.PostV1RentalOpportunityResponses> => {
  return await _postV1RentalOpportunity(baseUrl, request)
}
const _postV1RentalOpportunitySaveAsDraft = async (url: string, request: Types.PostV1RentalOpportunitySaveAsDraftRequest): Promise<Types.PostV1RentalOpportunitySaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOpportunitySaveAsDraft: Api['postV1RentalOpportunitySaveAsDraft'] = async (request: Types.PostV1RentalOpportunitySaveAsDraftRequest): Promise<Types.PostV1RentalOpportunitySaveAsDraftResponses> => {
  return await _postV1RentalOpportunitySaveAsDraft(baseUrl, request)
}
const _getV1RentalOpportunityId = async (url: string, request: Types.GetV1RentalOpportunityIdRequest): Promise<Types.GetV1RentalOpportunityIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOpportunityIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOpportunityId: Api['getV1RentalOpportunityId'] = async (request: Types.GetV1RentalOpportunityIdRequest): Promise<Types.GetV1RentalOpportunityIdResponses> => {
  return await _getV1RentalOpportunityId(baseUrl, request)
}
const _putV1RentalOpportunityId = async (url: string, request: Types.PutV1RentalOpportunityIdRequest): Promise<Types.PutV1RentalOpportunityIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalOpportunityId: Api['putV1RentalOpportunityId'] = async (request: Types.PutV1RentalOpportunityIdRequest): Promise<Types.PutV1RentalOpportunityIdResponses> => {
  return await _putV1RentalOpportunityId(baseUrl, request)
}
const _deleteV1RentalOpportunityId = async (url: string, request: Types.DeleteV1RentalOpportunityIdRequest): Promise<Types.DeleteV1RentalOpportunityIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalOpportunityId: Api['deleteV1RentalOpportunityId'] = async (request: Types.DeleteV1RentalOpportunityIdRequest): Promise<Types.DeleteV1RentalOpportunityIdResponses> => {
  return await _deleteV1RentalOpportunityId(baseUrl, request)
}
const _patchV1RentalOpportunityStageId = async (url: string, request: Types.PatchV1RentalOpportunityStageIdRequest): Promise<Types.PatchV1RentalOpportunityStageIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/stage/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1RentalOpportunityStageId: Api['patchV1RentalOpportunityStageId'] = async (request: Types.PatchV1RentalOpportunityStageIdRequest): Promise<Types.PatchV1RentalOpportunityStageIdResponses> => {
  return await _patchV1RentalOpportunityStageId(baseUrl, request)
}
const _postV1RentalOpportunityFollowup = async (url: string, request: Types.PostV1RentalOpportunityFollowupRequest): Promise<Types.PostV1RentalOpportunityFollowupResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/followup/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOpportunityFollowup: Api['postV1RentalOpportunityFollowup'] = async (request: Types.PostV1RentalOpportunityFollowupRequest): Promise<Types.PostV1RentalOpportunityFollowupResponses> => {
  return await _postV1RentalOpportunityFollowup(baseUrl, request)
}
const _getV1RentalOpportunityFollowup = async (url: string, request: Types.GetV1RentalOpportunityFollowupRequest): Promise<Types.GetV1RentalOpportunityFollowupResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOpportunityFollowupRequest)[]  = ['opportunityId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/followup/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOpportunityFollowup: Api['getV1RentalOpportunityFollowup'] = async (request: Types.GetV1RentalOpportunityFollowupRequest): Promise<Types.GetV1RentalOpportunityFollowupResponses> => {
  return await _getV1RentalOpportunityFollowup(baseUrl, request)
}
const _getV1RentalOpportunityFollowupId = async (url: string, request: Types.GetV1RentalOpportunityFollowupIdRequest): Promise<Types.GetV1RentalOpportunityFollowupIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOpportunityFollowupIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/followup/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOpportunityFollowupId: Api['getV1RentalOpportunityFollowupId'] = async (request: Types.GetV1RentalOpportunityFollowupIdRequest): Promise<Types.GetV1RentalOpportunityFollowupIdResponses> => {
  return await _getV1RentalOpportunityFollowupId(baseUrl, request)
}
const _deleteV1RentalOpportunityFollowupId = async (url: string, request: Types.DeleteV1RentalOpportunityFollowupIdRequest): Promise<Types.DeleteV1RentalOpportunityFollowupIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/followup/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalOpportunityFollowupId: Api['deleteV1RentalOpportunityFollowupId'] = async (request: Types.DeleteV1RentalOpportunityFollowupIdRequest): Promise<Types.DeleteV1RentalOpportunityFollowupIdResponses> => {
  return await _deleteV1RentalOpportunityFollowupId(baseUrl, request)
}
const _putV1RentalOpportunityFollowupId = async (url: string, request: Types.PutV1RentalOpportunityFollowupIdRequest): Promise<Types.PutV1RentalOpportunityFollowupIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/followup/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalOpportunityFollowupId: Api['putV1RentalOpportunityFollowupId'] = async (request: Types.PutV1RentalOpportunityFollowupIdRequest): Promise<Types.PutV1RentalOpportunityFollowupIdResponses> => {
  return await _putV1RentalOpportunityFollowupId(baseUrl, request)
}
const _postV1RentalOpportunityCommunicationLog = async (url: string, request: Types.PostV1RentalOpportunityCommunicationLogRequest): Promise<Types.PostV1RentalOpportunityCommunicationLogResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/communication-log/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOpportunityCommunicationLog: Api['postV1RentalOpportunityCommunicationLog'] = async (request: Types.PostV1RentalOpportunityCommunicationLogRequest): Promise<Types.PostV1RentalOpportunityCommunicationLogResponses> => {
  return await _postV1RentalOpportunityCommunicationLog(baseUrl, request)
}
const _getV1RentalOpportunityCommunicationLog = async (url: string, request: Types.GetV1RentalOpportunityCommunicationLogRequest): Promise<Types.GetV1RentalOpportunityCommunicationLogResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOpportunityCommunicationLogRequest)[]  = ['opportunityId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/communication-log/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOpportunityCommunicationLog: Api['getV1RentalOpportunityCommunicationLog'] = async (request: Types.GetV1RentalOpportunityCommunicationLogRequest): Promise<Types.GetV1RentalOpportunityCommunicationLogResponses> => {
  return await _getV1RentalOpportunityCommunicationLog(baseUrl, request)
}
const _getV1RentalOpportunityCommunicationLogId = async (url: string, request: Types.GetV1RentalOpportunityCommunicationLogIdRequest): Promise<Types.GetV1RentalOpportunityCommunicationLogIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOpportunityCommunicationLogIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/communication-log/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOpportunityCommunicationLogId: Api['getV1RentalOpportunityCommunicationLogId'] = async (request: Types.GetV1RentalOpportunityCommunicationLogIdRequest): Promise<Types.GetV1RentalOpportunityCommunicationLogIdResponses> => {
  return await _getV1RentalOpportunityCommunicationLogId(baseUrl, request)
}
const _deleteV1RentalOpportunityCommunicationLogId = async (url: string, request: Types.DeleteV1RentalOpportunityCommunicationLogIdRequest): Promise<Types.DeleteV1RentalOpportunityCommunicationLogIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/communication-log/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalOpportunityCommunicationLogId: Api['deleteV1RentalOpportunityCommunicationLogId'] = async (request: Types.DeleteV1RentalOpportunityCommunicationLogIdRequest): Promise<Types.DeleteV1RentalOpportunityCommunicationLogIdResponses> => {
  return await _deleteV1RentalOpportunityCommunicationLogId(baseUrl, request)
}
const _putV1RentalOpportunityCommunicationLogId = async (url: string, request: Types.PutV1RentalOpportunityCommunicationLogIdRequest): Promise<Types.PutV1RentalOpportunityCommunicationLogIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/communication-log/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalOpportunityCommunicationLogId: Api['putV1RentalOpportunityCommunicationLogId'] = async (request: Types.PutV1RentalOpportunityCommunicationLogIdRequest): Promise<Types.PutV1RentalOpportunityCommunicationLogIdResponses> => {
  return await _putV1RentalOpportunityCommunicationLogId(baseUrl, request)
}
const _postV1RentalOpportunityAddress = async (url: string, request: Types.PostV1RentalOpportunityAddressRequest): Promise<Types.PostV1RentalOpportunityAddressResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/address/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOpportunityAddress: Api['postV1RentalOpportunityAddress'] = async (request: Types.PostV1RentalOpportunityAddressRequest): Promise<Types.PostV1RentalOpportunityAddressResponses> => {
  return await _postV1RentalOpportunityAddress(baseUrl, request)
}
const _getV1RentalOpportunityAddress = async (url: string, request: Types.GetV1RentalOpportunityAddressRequest): Promise<Types.GetV1RentalOpportunityAddressResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOpportunityAddressRequest)[]  = ['opportunityId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/address/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOpportunityAddress: Api['getV1RentalOpportunityAddress'] = async (request: Types.GetV1RentalOpportunityAddressRequest): Promise<Types.GetV1RentalOpportunityAddressResponses> => {
  return await _getV1RentalOpportunityAddress(baseUrl, request)
}
const _getV1RentalOpportunityAddressId = async (url: string, request: Types.GetV1RentalOpportunityAddressIdRequest): Promise<Types.GetV1RentalOpportunityAddressIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOpportunityAddressIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/address/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOpportunityAddressId: Api['getV1RentalOpportunityAddressId'] = async (request: Types.GetV1RentalOpportunityAddressIdRequest): Promise<Types.GetV1RentalOpportunityAddressIdResponses> => {
  return await _getV1RentalOpportunityAddressId(baseUrl, request)
}
const _deleteV1RentalOpportunityAddressId = async (url: string, request: Types.DeleteV1RentalOpportunityAddressIdRequest): Promise<Types.DeleteV1RentalOpportunityAddressIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/address/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalOpportunityAddressId: Api['deleteV1RentalOpportunityAddressId'] = async (request: Types.DeleteV1RentalOpportunityAddressIdRequest): Promise<Types.DeleteV1RentalOpportunityAddressIdResponses> => {
  return await _deleteV1RentalOpportunityAddressId(baseUrl, request)
}
const _putV1RentalOpportunityAddressId = async (url: string, request: Types.PutV1RentalOpportunityAddressIdRequest): Promise<Types.PutV1RentalOpportunityAddressIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/address/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalOpportunityAddressId: Api['putV1RentalOpportunityAddressId'] = async (request: Types.PutV1RentalOpportunityAddressIdRequest): Promise<Types.PutV1RentalOpportunityAddressIdResponses> => {
  return await _putV1RentalOpportunityAddressId(baseUrl, request)
}
const _postV1RentalOpportunityContact = async (url: string, request: Types.PostV1RentalOpportunityContactRequest): Promise<Types.PostV1RentalOpportunityContactResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/contact/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOpportunityContact: Api['postV1RentalOpportunityContact'] = async (request: Types.PostV1RentalOpportunityContactRequest): Promise<Types.PostV1RentalOpportunityContactResponses> => {
  return await _postV1RentalOpportunityContact(baseUrl, request)
}
const _getV1RentalOpportunityContact = async (url: string, request: Types.GetV1RentalOpportunityContactRequest): Promise<Types.GetV1RentalOpportunityContactResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOpportunityContactRequest)[]  = ['opportunityId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/contact/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOpportunityContact: Api['getV1RentalOpportunityContact'] = async (request: Types.GetV1RentalOpportunityContactRequest): Promise<Types.GetV1RentalOpportunityContactResponses> => {
  return await _getV1RentalOpportunityContact(baseUrl, request)
}
const _getV1RentalOpportunityContactId = async (url: string, request: Types.GetV1RentalOpportunityContactIdRequest): Promise<Types.GetV1RentalOpportunityContactIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOpportunityContactIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/contact/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOpportunityContactId: Api['getV1RentalOpportunityContactId'] = async (request: Types.GetV1RentalOpportunityContactIdRequest): Promise<Types.GetV1RentalOpportunityContactIdResponses> => {
  return await _getV1RentalOpportunityContactId(baseUrl, request)
}
const _deleteV1RentalOpportunityContactId = async (url: string, request: Types.DeleteV1RentalOpportunityContactIdRequest): Promise<Types.DeleteV1RentalOpportunityContactIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/contact/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalOpportunityContactId: Api['deleteV1RentalOpportunityContactId'] = async (request: Types.DeleteV1RentalOpportunityContactIdRequest): Promise<Types.DeleteV1RentalOpportunityContactIdResponses> => {
  return await _deleteV1RentalOpportunityContactId(baseUrl, request)
}
const _putV1RentalOpportunityContactId = async (url: string, request: Types.PutV1RentalOpportunityContactIdRequest): Promise<Types.PutV1RentalOpportunityContactIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/contact/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalOpportunityContactId: Api['putV1RentalOpportunityContactId'] = async (request: Types.PutV1RentalOpportunityContactIdRequest): Promise<Types.PutV1RentalOpportunityContactIdResponses> => {
  return await _putV1RentalOpportunityContactId(baseUrl, request)
}
const _postV1RentalOpportunityItem = async (url: string, request: Types.PostV1RentalOpportunityItemRequest): Promise<Types.PostV1RentalOpportunityItemResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/item/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOpportunityItem: Api['postV1RentalOpportunityItem'] = async (request: Types.PostV1RentalOpportunityItemRequest): Promise<Types.PostV1RentalOpportunityItemResponses> => {
  return await _postV1RentalOpportunityItem(baseUrl, request)
}
const _getV1RentalOpportunityItem = async (url: string, request: Types.GetV1RentalOpportunityItemRequest): Promise<Types.GetV1RentalOpportunityItemResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOpportunityItemRequest)[]  = ['opportunityId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/item/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOpportunityItem: Api['getV1RentalOpportunityItem'] = async (request: Types.GetV1RentalOpportunityItemRequest): Promise<Types.GetV1RentalOpportunityItemResponses> => {
  return await _getV1RentalOpportunityItem(baseUrl, request)
}
const _getV1RentalOpportunityItemId = async (url: string, request: Types.GetV1RentalOpportunityItemIdRequest): Promise<Types.GetV1RentalOpportunityItemIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOpportunityItemIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/item/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOpportunityItemId: Api['getV1RentalOpportunityItemId'] = async (request: Types.GetV1RentalOpportunityItemIdRequest): Promise<Types.GetV1RentalOpportunityItemIdResponses> => {
  return await _getV1RentalOpportunityItemId(baseUrl, request)
}
const _deleteV1RentalOpportunityItemId = async (url: string, request: Types.DeleteV1RentalOpportunityItemIdRequest): Promise<Types.DeleteV1RentalOpportunityItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/item/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalOpportunityItemId: Api['deleteV1RentalOpportunityItemId'] = async (request: Types.DeleteV1RentalOpportunityItemIdRequest): Promise<Types.DeleteV1RentalOpportunityItemIdResponses> => {
  return await _deleteV1RentalOpportunityItemId(baseUrl, request)
}
const _putV1RentalOpportunityItemId = async (url: string, request: Types.PutV1RentalOpportunityItemIdRequest): Promise<Types.PutV1RentalOpportunityItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/item/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalOpportunityItemId: Api['putV1RentalOpportunityItemId'] = async (request: Types.PutV1RentalOpportunityItemIdRequest): Promise<Types.PutV1RentalOpportunityItemIdResponses> => {
  return await _putV1RentalOpportunityItemId(baseUrl, request)
}
const _getV1RentalOpportunitySalesPipeline = async (url: string, request: Types.GetV1RentalOpportunitySalesPipelineRequest): Promise<Types.GetV1RentalOpportunitySalesPipelineResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOpportunitySalesPipelineRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/sales-pipeline?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOpportunitySalesPipeline: Api['getV1RentalOpportunitySalesPipeline'] = async (request: Types.GetV1RentalOpportunitySalesPipelineRequest): Promise<Types.GetV1RentalOpportunitySalesPipelineResponses> => {
  return await _getV1RentalOpportunitySalesPipeline(baseUrl, request)
}
const _getV1RentalOpportunityIdPromotions = async (url: string, request: Types.GetV1RentalOpportunityIdPromotionsRequest): Promise<Types.GetV1RentalOpportunityIdPromotionsResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOpportunityIdPromotionsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/${request['id']}/promotions?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOpportunityIdPromotions: Api['getV1RentalOpportunityIdPromotions'] = async (request: Types.GetV1RentalOpportunityIdPromotionsRequest): Promise<Types.GetV1RentalOpportunityIdPromotionsResponses> => {
  return await _getV1RentalOpportunityIdPromotions(baseUrl, request)
}
const _getV1RentalOpportunityGenerateExcel = async (url: string, request: Types.GetV1RentalOpportunityGenerateExcelRequest): Promise<Types.GetV1RentalOpportunityGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOpportunityGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOpportunityGenerateExcel: Api['getV1RentalOpportunityGenerateExcel'] = async (request: Types.GetV1RentalOpportunityGenerateExcelRequest): Promise<Types.GetV1RentalOpportunityGenerateExcelResponses> => {
  return await _getV1RentalOpportunityGenerateExcel(baseUrl, request)
}
const _postV1RentalOpportunityImport = async (url: string, request: Types.PostV1RentalOpportunityImportRequest): Promise<Types.PostV1RentalOpportunityImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-opportunity/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOpportunityImport: Api['postV1RentalOpportunityImport'] = async (request: Types.PostV1RentalOpportunityImportRequest): Promise<Types.PostV1RentalOpportunityImportResponses> => {
  return await _postV1RentalOpportunityImport(baseUrl, request)
}
const _getV1RentalQuotationsId = async (url: string, request: Types.GetV1RentalQuotationsIdRequest): Promise<Types.GetV1RentalQuotationsIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalQuotationsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalQuotationsId: Api['getV1RentalQuotationsId'] = async (request: Types.GetV1RentalQuotationsIdRequest): Promise<Types.GetV1RentalQuotationsIdResponses> => {
  return await _getV1RentalQuotationsId(baseUrl, request)
}
const _putV1RentalQuotationsId = async (url: string, request: Types.PutV1RentalQuotationsIdRequest): Promise<Types.PutV1RentalQuotationsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalQuotationsId: Api['putV1RentalQuotationsId'] = async (request: Types.PutV1RentalQuotationsIdRequest): Promise<Types.PutV1RentalQuotationsIdResponses> => {
  return await _putV1RentalQuotationsId(baseUrl, request)
}
const _deleteV1RentalQuotationsId = async (url: string, request: Types.DeleteV1RentalQuotationsIdRequest): Promise<Types.DeleteV1RentalQuotationsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalQuotationsId: Api['deleteV1RentalQuotationsId'] = async (request: Types.DeleteV1RentalQuotationsIdRequest): Promise<Types.DeleteV1RentalQuotationsIdResponses> => {
  return await _deleteV1RentalQuotationsId(baseUrl, request)
}
const _getV1RentalQuotations = async (url: string, request: Types.GetV1RentalQuotationsRequest): Promise<Types.GetV1RentalQuotationsResponses> => {
  const queryParameters: (keyof Types.GetV1RentalQuotationsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalQuotations: Api['getV1RentalQuotations'] = async (request: Types.GetV1RentalQuotationsRequest): Promise<Types.GetV1RentalQuotationsResponses> => {
  return await _getV1RentalQuotations(baseUrl, request)
}
const _postV1RentalQuotationsSaveAsDraft = async (url: string, request: Types.PostV1RentalQuotationsSaveAsDraftRequest): Promise<Types.PostV1RentalQuotationsSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalQuotationsSaveAsDraft: Api['postV1RentalQuotationsSaveAsDraft'] = async (request: Types.PostV1RentalQuotationsSaveAsDraftRequest): Promise<Types.PostV1RentalQuotationsSaveAsDraftResponses> => {
  return await _postV1RentalQuotationsSaveAsDraft(baseUrl, request)
}
const _patchV1RentalQuotationsStatusId = async (url: string, request: Types.PatchV1RentalQuotationsStatusIdRequest): Promise<Types.PatchV1RentalQuotationsStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1RentalQuotationsStatusId: Api['patchV1RentalQuotationsStatusId'] = async (request: Types.PatchV1RentalQuotationsStatusIdRequest): Promise<Types.PatchV1RentalQuotationsStatusIdResponses> => {
  return await _patchV1RentalQuotationsStatusId(baseUrl, request)
}
const _postV1RentalQuotationsPromotionCheck = async (url: string, request: Types.PostV1RentalQuotationsPromotionCheckRequest): Promise<Types.PostV1RentalQuotationsPromotionCheckResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/promotion/check`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalQuotationsPromotionCheck: Api['postV1RentalQuotationsPromotionCheck'] = async (request: Types.PostV1RentalQuotationsPromotionCheckRequest): Promise<Types.PostV1RentalQuotationsPromotionCheckResponses> => {
  return await _postV1RentalQuotationsPromotionCheck(baseUrl, request)
}
const _postV1RentalQuotationsPromotionApply = async (url: string, request: Types.PostV1RentalQuotationsPromotionApplyRequest): Promise<Types.PostV1RentalQuotationsPromotionApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/promotion/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalQuotationsPromotionApply: Api['postV1RentalQuotationsPromotionApply'] = async (request: Types.PostV1RentalQuotationsPromotionApplyRequest): Promise<Types.PostV1RentalQuotationsPromotionApplyResponses> => {
  return await _postV1RentalQuotationsPromotionApply(baseUrl, request)
}
const _postV1RentalQuotationsPromotionCouponApply = async (url: string, request: Types.PostV1RentalQuotationsPromotionCouponApplyRequest): Promise<Types.PostV1RentalQuotationsPromotionCouponApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/promotion/coupon/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalQuotationsPromotionCouponApply: Api['postV1RentalQuotationsPromotionCouponApply'] = async (request: Types.PostV1RentalQuotationsPromotionCouponApplyRequest): Promise<Types.PostV1RentalQuotationsPromotionCouponApplyResponses> => {
  return await _postV1RentalQuotationsPromotionCouponApply(baseUrl, request)
}
const _postV1RentalQuotationsPromotionItemApply = async (url: string, request: Types.PostV1RentalQuotationsPromotionItemApplyRequest): Promise<Types.PostV1RentalQuotationsPromotionItemApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/promotion/item/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalQuotationsPromotionItemApply: Api['postV1RentalQuotationsPromotionItemApply'] = async (request: Types.PostV1RentalQuotationsPromotionItemApplyRequest): Promise<Types.PostV1RentalQuotationsPromotionItemApplyResponses> => {
  return await _postV1RentalQuotationsPromotionItemApply(baseUrl, request)
}
const _deleteV1RentalQuotationsPromotionId = async (url: string, request: Types.DeleteV1RentalQuotationsPromotionIdRequest): Promise<Types.DeleteV1RentalQuotationsPromotionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/promotion/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalQuotationsPromotionId: Api['deleteV1RentalQuotationsPromotionId'] = async (request: Types.DeleteV1RentalQuotationsPromotionIdRequest): Promise<Types.DeleteV1RentalQuotationsPromotionIdResponses> => {
  return await _deleteV1RentalQuotationsPromotionId(baseUrl, request)
}
const _postV1RentalQuotationsItem = async (url: string, request: Types.PostV1RentalQuotationsItemRequest): Promise<Types.PostV1RentalQuotationsItemResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/item/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalQuotationsItem: Api['postV1RentalQuotationsItem'] = async (request: Types.PostV1RentalQuotationsItemRequest): Promise<Types.PostV1RentalQuotationsItemResponses> => {
  return await _postV1RentalQuotationsItem(baseUrl, request)
}
const _getV1RentalQuotationsItem = async (url: string, request: Types.GetV1RentalQuotationsItemRequest): Promise<Types.GetV1RentalQuotationsItemResponses> => {
  const queryParameters: (keyof Types.GetV1RentalQuotationsItemRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/item/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalQuotationsItem: Api['getV1RentalQuotationsItem'] = async (request: Types.GetV1RentalQuotationsItemRequest): Promise<Types.GetV1RentalQuotationsItemResponses> => {
  return await _getV1RentalQuotationsItem(baseUrl, request)
}
const _getV1RentalQuotationsItemId = async (url: string, request: Types.GetV1RentalQuotationsItemIdRequest): Promise<Types.GetV1RentalQuotationsItemIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalQuotationsItemIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/item/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalQuotationsItemId: Api['getV1RentalQuotationsItemId'] = async (request: Types.GetV1RentalQuotationsItemIdRequest): Promise<Types.GetV1RentalQuotationsItemIdResponses> => {
  return await _getV1RentalQuotationsItemId(baseUrl, request)
}
const _deleteV1RentalQuotationsItemId = async (url: string, request: Types.DeleteV1RentalQuotationsItemIdRequest): Promise<Types.DeleteV1RentalQuotationsItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/item/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalQuotationsItemId: Api['deleteV1RentalQuotationsItemId'] = async (request: Types.DeleteV1RentalQuotationsItemIdRequest): Promise<Types.DeleteV1RentalQuotationsItemIdResponses> => {
  return await _deleteV1RentalQuotationsItemId(baseUrl, request)
}
const _putV1RentalQuotationsItemId = async (url: string, request: Types.PutV1RentalQuotationsItemIdRequest): Promise<Types.PutV1RentalQuotationsItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/item/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalQuotationsItemId: Api['putV1RentalQuotationsItemId'] = async (request: Types.PutV1RentalQuotationsItemIdRequest): Promise<Types.PutV1RentalQuotationsItemIdResponses> => {
  return await _putV1RentalQuotationsItemId(baseUrl, request)
}
const _getV1RentalQuotationsIdPromotions = async (url: string, request: Types.GetV1RentalQuotationsIdPromotionsRequest): Promise<Types.GetV1RentalQuotationsIdPromotionsResponses> => {
  const queryParameters: (keyof Types.GetV1RentalQuotationsIdPromotionsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/${request['id']}/promotions?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalQuotationsIdPromotions: Api['getV1RentalQuotationsIdPromotions'] = async (request: Types.GetV1RentalQuotationsIdPromotionsRequest): Promise<Types.GetV1RentalQuotationsIdPromotionsResponses> => {
  return await _getV1RentalQuotationsIdPromotions(baseUrl, request)
}
const _getV1RentalQuotationsIdDownload = async (url: string, request: Types.GetV1RentalQuotationsIdDownloadRequest): Promise<Types.GetV1RentalQuotationsIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1RentalQuotationsIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalQuotationsIdDownload: Api['getV1RentalQuotationsIdDownload'] = async (request: Types.GetV1RentalQuotationsIdDownloadRequest): Promise<Types.GetV1RentalQuotationsIdDownloadResponses> => {
  return await _getV1RentalQuotationsIdDownload(baseUrl, request)
}
const _getV1RentalQuotationsIdSendEmail = async (url: string, request: Types.GetV1RentalQuotationsIdSendEmailRequest): Promise<Types.GetV1RentalQuotationsIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1RentalQuotationsIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalQuotationsIdSendEmail: Api['getV1RentalQuotationsIdSendEmail'] = async (request: Types.GetV1RentalQuotationsIdSendEmailRequest): Promise<Types.GetV1RentalQuotationsIdSendEmailResponses> => {
  return await _getV1RentalQuotationsIdSendEmail(baseUrl, request)
}
const _getV1RentalQuotationsGenerateExcel = async (url: string, request: Types.GetV1RentalQuotationsGenerateExcelRequest): Promise<Types.GetV1RentalQuotationsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1RentalQuotationsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalQuotationsGenerateExcel: Api['getV1RentalQuotationsGenerateExcel'] = async (request: Types.GetV1RentalQuotationsGenerateExcelRequest): Promise<Types.GetV1RentalQuotationsGenerateExcelResponses> => {
  return await _getV1RentalQuotationsGenerateExcel(baseUrl, request)
}
const _postV1RentalQuotationsImport = async (url: string, request: Types.PostV1RentalQuotationsImportRequest): Promise<Types.PostV1RentalQuotationsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalQuotationsImport: Api['postV1RentalQuotationsImport'] = async (request: Types.PostV1RentalQuotationsImportRequest): Promise<Types.PostV1RentalQuotationsImportResponses> => {
  return await _postV1RentalQuotationsImport(baseUrl, request)
}
const _getV1RentalQuotationsOpportunityId = async (url: string, request: Types.GetV1RentalQuotationsOpportunityIdRequest): Promise<Types.GetV1RentalQuotationsOpportunityIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalQuotationsOpportunityIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/opportunity/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalQuotationsOpportunityId: Api['getV1RentalQuotationsOpportunityId'] = async (request: Types.GetV1RentalQuotationsOpportunityIdRequest): Promise<Types.GetV1RentalQuotationsOpportunityIdResponses> => {
  return await _getV1RentalQuotationsOpportunityId(baseUrl, request)
}
const _getV1RentalQuotationsFetchItemsPartyId = async (url: string, request: Types.GetV1RentalQuotationsFetchItemsPartyIdRequest): Promise<Types.GetV1RentalQuotationsFetchItemsPartyIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalQuotationsFetchItemsPartyIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-quotations/fetch-items/${request['partyId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalQuotationsFetchItemsPartyId: Api['getV1RentalQuotationsFetchItemsPartyId'] = async (request: Types.GetV1RentalQuotationsFetchItemsPartyIdRequest): Promise<Types.GetV1RentalQuotationsFetchItemsPartyIdResponses> => {
  return await _getV1RentalQuotationsFetchItemsPartyId(baseUrl, request)
}
const _postV1RentalOrders = async (url: string, request: Types.PostV1RentalOrdersRequest): Promise<Types.PostV1RentalOrdersResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOrders: Api['postV1RentalOrders'] = async (request: Types.PostV1RentalOrdersRequest): Promise<Types.PostV1RentalOrdersResponses> => {
  return await _postV1RentalOrders(baseUrl, request)
}
const _getV1RentalOrders = async (url: string, request: Types.GetV1RentalOrdersRequest): Promise<Types.GetV1RentalOrdersResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOrdersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOrders: Api['getV1RentalOrders'] = async (request: Types.GetV1RentalOrdersRequest): Promise<Types.GetV1RentalOrdersResponses> => {
  return await _getV1RentalOrders(baseUrl, request)
}
const _postV1RentalOrdersSaveDraft = async (url: string, request: Types.PostV1RentalOrdersSaveDraftRequest): Promise<Types.PostV1RentalOrdersSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOrdersSaveDraft: Api['postV1RentalOrdersSaveDraft'] = async (request: Types.PostV1RentalOrdersSaveDraftRequest): Promise<Types.PostV1RentalOrdersSaveDraftResponses> => {
  return await _postV1RentalOrdersSaveDraft(baseUrl, request)
}
const _getV1RentalOrdersId = async (url: string, request: Types.GetV1RentalOrdersIdRequest): Promise<Types.GetV1RentalOrdersIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOrdersIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOrdersId: Api['getV1RentalOrdersId'] = async (request: Types.GetV1RentalOrdersIdRequest): Promise<Types.GetV1RentalOrdersIdResponses> => {
  return await _getV1RentalOrdersId(baseUrl, request)
}
const _putV1RentalOrdersId = async (url: string, request: Types.PutV1RentalOrdersIdRequest): Promise<Types.PutV1RentalOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalOrdersId: Api['putV1RentalOrdersId'] = async (request: Types.PutV1RentalOrdersIdRequest): Promise<Types.PutV1RentalOrdersIdResponses> => {
  return await _putV1RentalOrdersId(baseUrl, request)
}
const _deleteV1RentalOrdersId = async (url: string, request: Types.DeleteV1RentalOrdersIdRequest): Promise<Types.DeleteV1RentalOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalOrdersId: Api['deleteV1RentalOrdersId'] = async (request: Types.DeleteV1RentalOrdersIdRequest): Promise<Types.DeleteV1RentalOrdersIdResponses> => {
  return await _deleteV1RentalOrdersId(baseUrl, request)
}
const _patchV1RentalOrdersStatusId = async (url: string, request: Types.PatchV1RentalOrdersStatusIdRequest): Promise<Types.PatchV1RentalOrdersStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1RentalOrdersStatusId: Api['patchV1RentalOrdersStatusId'] = async (request: Types.PatchV1RentalOrdersStatusIdRequest): Promise<Types.PatchV1RentalOrdersStatusIdResponses> => {
  return await _patchV1RentalOrdersStatusId(baseUrl, request)
}
const _postV1RentalOrdersAddApprover = async (url: string, request: Types.PostV1RentalOrdersAddApproverRequest): Promise<Types.PostV1RentalOrdersAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOrdersAddApprover: Api['postV1RentalOrdersAddApprover'] = async (request: Types.PostV1RentalOrdersAddApproverRequest): Promise<Types.PostV1RentalOrdersAddApproverResponses> => {
  return await _postV1RentalOrdersAddApprover(baseUrl, request)
}
const _putV1RentalOrdersApprovalStatusId = async (url: string, request: Types.PutV1RentalOrdersApprovalStatusIdRequest): Promise<Types.PutV1RentalOrdersApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalOrdersApprovalStatusId: Api['putV1RentalOrdersApprovalStatusId'] = async (request: Types.PutV1RentalOrdersApprovalStatusIdRequest): Promise<Types.PutV1RentalOrdersApprovalStatusIdResponses> => {
  return await _putV1RentalOrdersApprovalStatusId(baseUrl, request)
}
const _postV1RentalOrdersItems = async (url: string, request: Types.PostV1RentalOrdersItemsRequest): Promise<Types.PostV1RentalOrdersItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOrdersItems: Api['postV1RentalOrdersItems'] = async (request: Types.PostV1RentalOrdersItemsRequest): Promise<Types.PostV1RentalOrdersItemsResponses> => {
  return await _postV1RentalOrdersItems(baseUrl, request)
}
const _getV1RentalOrdersItemsId = async (url: string, request: Types.GetV1RentalOrdersItemsIdRequest): Promise<Types.GetV1RentalOrdersItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOrdersItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOrdersItemsId: Api['getV1RentalOrdersItemsId'] = async (request: Types.GetV1RentalOrdersItemsIdRequest): Promise<Types.GetV1RentalOrdersItemsIdResponses> => {
  return await _getV1RentalOrdersItemsId(baseUrl, request)
}
const _putV1RentalOrdersItemsId = async (url: string, request: Types.PutV1RentalOrdersItemsIdRequest): Promise<Types.PutV1RentalOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalOrdersItemsId: Api['putV1RentalOrdersItemsId'] = async (request: Types.PutV1RentalOrdersItemsIdRequest): Promise<Types.PutV1RentalOrdersItemsIdResponses> => {
  return await _putV1RentalOrdersItemsId(baseUrl, request)
}
const _deleteV1RentalOrdersItemsId = async (url: string, request: Types.DeleteV1RentalOrdersItemsIdRequest): Promise<Types.DeleteV1RentalOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalOrdersItemsId: Api['deleteV1RentalOrdersItemsId'] = async (request: Types.DeleteV1RentalOrdersItemsIdRequest): Promise<Types.DeleteV1RentalOrdersItemsIdResponses> => {
  return await _deleteV1RentalOrdersItemsId(baseUrl, request)
}
const _postV1RentalOrdersPromotionCheck = async (url: string, request: Types.PostV1RentalOrdersPromotionCheckRequest): Promise<Types.PostV1RentalOrdersPromotionCheckResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/promotion/check`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOrdersPromotionCheck: Api['postV1RentalOrdersPromotionCheck'] = async (request: Types.PostV1RentalOrdersPromotionCheckRequest): Promise<Types.PostV1RentalOrdersPromotionCheckResponses> => {
  return await _postV1RentalOrdersPromotionCheck(baseUrl, request)
}
const _postV1RentalOrdersPromotionApply = async (url: string, request: Types.PostV1RentalOrdersPromotionApplyRequest): Promise<Types.PostV1RentalOrdersPromotionApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/promotion/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOrdersPromotionApply: Api['postV1RentalOrdersPromotionApply'] = async (request: Types.PostV1RentalOrdersPromotionApplyRequest): Promise<Types.PostV1RentalOrdersPromotionApplyResponses> => {
  return await _postV1RentalOrdersPromotionApply(baseUrl, request)
}
const _postV1RentalOrdersPromotionItemApply = async (url: string, request: Types.PostV1RentalOrdersPromotionItemApplyRequest): Promise<Types.PostV1RentalOrdersPromotionItemApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/promotion/item/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOrdersPromotionItemApply: Api['postV1RentalOrdersPromotionItemApply'] = async (request: Types.PostV1RentalOrdersPromotionItemApplyRequest): Promise<Types.PostV1RentalOrdersPromotionItemApplyResponses> => {
  return await _postV1RentalOrdersPromotionItemApply(baseUrl, request)
}
const _deleteV1RentalOrdersPromotionId = async (url: string, request: Types.DeleteV1RentalOrdersPromotionIdRequest): Promise<Types.DeleteV1RentalOrdersPromotionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/promotion/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalOrdersPromotionId: Api['deleteV1RentalOrdersPromotionId'] = async (request: Types.DeleteV1RentalOrdersPromotionIdRequest): Promise<Types.DeleteV1RentalOrdersPromotionIdResponses> => {
  return await _deleteV1RentalOrdersPromotionId(baseUrl, request)
}
const _getV1RentalOrdersIdCreateInvoice = async (url: string, request: Types.GetV1RentalOrdersIdCreateInvoiceRequest): Promise<Types.GetV1RentalOrdersIdCreateInvoiceResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOrdersIdCreateInvoiceRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/${request['id']}/create-invoice?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOrdersIdCreateInvoice: Api['getV1RentalOrdersIdCreateInvoice'] = async (request: Types.GetV1RentalOrdersIdCreateInvoiceRequest): Promise<Types.GetV1RentalOrdersIdCreateInvoiceResponses> => {
  return await _getV1RentalOrdersIdCreateInvoice(baseUrl, request)
}
const _getV1RentalOrdersIdPromotions = async (url: string, request: Types.GetV1RentalOrdersIdPromotionsRequest): Promise<Types.GetV1RentalOrdersIdPromotionsResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOrdersIdPromotionsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/${request['id']}/promotions?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOrdersIdPromotions: Api['getV1RentalOrdersIdPromotions'] = async (request: Types.GetV1RentalOrdersIdPromotionsRequest): Promise<Types.GetV1RentalOrdersIdPromotionsResponses> => {
  return await _getV1RentalOrdersIdPromotions(baseUrl, request)
}
const _getV1RentalOrdersIdDownload = async (url: string, request: Types.GetV1RentalOrdersIdDownloadRequest): Promise<Types.GetV1RentalOrdersIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOrdersIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOrdersIdDownload: Api['getV1RentalOrdersIdDownload'] = async (request: Types.GetV1RentalOrdersIdDownloadRequest): Promise<Types.GetV1RentalOrdersIdDownloadResponses> => {
  return await _getV1RentalOrdersIdDownload(baseUrl, request)
}
const _getV1RentalOrdersIdGeneratePickingList = async (url: string, request: Types.GetV1RentalOrdersIdGeneratePickingListRequest): Promise<Types.GetV1RentalOrdersIdGeneratePickingListResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOrdersIdGeneratePickingListRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/${request['id']}/generate-picking-list?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOrdersIdGeneratePickingList: Api['getV1RentalOrdersIdGeneratePickingList'] = async (request: Types.GetV1RentalOrdersIdGeneratePickingListRequest): Promise<Types.GetV1RentalOrdersIdGeneratePickingListResponses> => {
  return await _getV1RentalOrdersIdGeneratePickingList(baseUrl, request)
}
const _getV1RentalOrdersIdSendEmail = async (url: string, request: Types.GetV1RentalOrdersIdSendEmailRequest): Promise<Types.GetV1RentalOrdersIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOrdersIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOrdersIdSendEmail: Api['getV1RentalOrdersIdSendEmail'] = async (request: Types.GetV1RentalOrdersIdSendEmailRequest): Promise<Types.GetV1RentalOrdersIdSendEmailResponses> => {
  return await _getV1RentalOrdersIdSendEmail(baseUrl, request)
}
const _getV1RentalOrdersTypeId = async (url: string, request: Types.GetV1RentalOrdersTypeIdRequest): Promise<Types.GetV1RentalOrdersTypeIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOrdersTypeIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/${request['type']}/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOrdersTypeId: Api['getV1RentalOrdersTypeId'] = async (request: Types.GetV1RentalOrdersTypeIdRequest): Promise<Types.GetV1RentalOrdersTypeIdResponses> => {
  return await _getV1RentalOrdersTypeId(baseUrl, request)
}
const _getV1RentalOrdersGenerateExcel = async (url: string, request: Types.GetV1RentalOrdersGenerateExcelRequest): Promise<Types.GetV1RentalOrdersGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOrdersGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOrdersGenerateExcel: Api['getV1RentalOrdersGenerateExcel'] = async (request: Types.GetV1RentalOrdersGenerateExcelRequest): Promise<Types.GetV1RentalOrdersGenerateExcelResponses> => {
  return await _getV1RentalOrdersGenerateExcel(baseUrl, request)
}
const _postV1RentalOrdersImport = async (url: string, request: Types.PostV1RentalOrdersImportRequest): Promise<Types.PostV1RentalOrdersImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalOrdersImport: Api['postV1RentalOrdersImport'] = async (request: Types.PostV1RentalOrdersImportRequest): Promise<Types.PostV1RentalOrdersImportResponses> => {
  return await _postV1RentalOrdersImport(baseUrl, request)
}
const _getV1RentalOrdersIdGrn = async (url: string, request: Types.GetV1RentalOrdersIdGrnRequest): Promise<Types.GetV1RentalOrdersIdGrnResponses> => {
  const queryParameters: (keyof Types.GetV1RentalOrdersIdGrnRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-orders/${request['id']}/grn?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalOrdersIdGrn: Api['getV1RentalOrdersIdGrn'] = async (request: Types.GetV1RentalOrdersIdGrnRequest): Promise<Types.GetV1RentalOrdersIdGrnResponses> => {
  return await _getV1RentalOrdersIdGrn(baseUrl, request)
}
const _postV1RentalAgreements = async (url: string, request: Types.PostV1RentalAgreementsRequest): Promise<Types.PostV1RentalAgreementsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-agreements/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalAgreements: Api['postV1RentalAgreements'] = async (request: Types.PostV1RentalAgreementsRequest): Promise<Types.PostV1RentalAgreementsResponses> => {
  return await _postV1RentalAgreements(baseUrl, request)
}
const _getV1RentalAgreements = async (url: string, request: Types.GetV1RentalAgreementsRequest): Promise<Types.GetV1RentalAgreementsResponses> => {
  const queryParameters: (keyof Types.GetV1RentalAgreementsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-agreements/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalAgreements: Api['getV1RentalAgreements'] = async (request: Types.GetV1RentalAgreementsRequest): Promise<Types.GetV1RentalAgreementsResponses> => {
  return await _getV1RentalAgreements(baseUrl, request)
}
const _postV1RentalAgreementsSaveDraft = async (url: string, request: Types.PostV1RentalAgreementsSaveDraftRequest): Promise<Types.PostV1RentalAgreementsSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-agreements/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalAgreementsSaveDraft: Api['postV1RentalAgreementsSaveDraft'] = async (request: Types.PostV1RentalAgreementsSaveDraftRequest): Promise<Types.PostV1RentalAgreementsSaveDraftResponses> => {
  return await _postV1RentalAgreementsSaveDraft(baseUrl, request)
}
const _getV1RentalAgreementsId = async (url: string, request: Types.GetV1RentalAgreementsIdRequest): Promise<Types.GetV1RentalAgreementsIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalAgreementsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-agreements/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalAgreementsId: Api['getV1RentalAgreementsId'] = async (request: Types.GetV1RentalAgreementsIdRequest): Promise<Types.GetV1RentalAgreementsIdResponses> => {
  return await _getV1RentalAgreementsId(baseUrl, request)
}
const _putV1RentalAgreementsId = async (url: string, request: Types.PutV1RentalAgreementsIdRequest): Promise<Types.PutV1RentalAgreementsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-agreements/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalAgreementsId: Api['putV1RentalAgreementsId'] = async (request: Types.PutV1RentalAgreementsIdRequest): Promise<Types.PutV1RentalAgreementsIdResponses> => {
  return await _putV1RentalAgreementsId(baseUrl, request)
}
const _deleteV1RentalAgreementsId = async (url: string, request: Types.DeleteV1RentalAgreementsIdRequest): Promise<Types.DeleteV1RentalAgreementsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-agreements/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalAgreementsId: Api['deleteV1RentalAgreementsId'] = async (request: Types.DeleteV1RentalAgreementsIdRequest): Promise<Types.DeleteV1RentalAgreementsIdResponses> => {
  return await _deleteV1RentalAgreementsId(baseUrl, request)
}
const _patchV1RentalAgreementsStatusId = async (url: string, request: Types.PatchV1RentalAgreementsStatusIdRequest): Promise<Types.PatchV1RentalAgreementsStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-agreements/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1RentalAgreementsStatusId: Api['patchV1RentalAgreementsStatusId'] = async (request: Types.PatchV1RentalAgreementsStatusIdRequest): Promise<Types.PatchV1RentalAgreementsStatusIdResponses> => {
  return await _patchV1RentalAgreementsStatusId(baseUrl, request)
}
const _postV1RentalAgreementsAddApprover = async (url: string, request: Types.PostV1RentalAgreementsAddApproverRequest): Promise<Types.PostV1RentalAgreementsAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-agreements/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalAgreementsAddApprover: Api['postV1RentalAgreementsAddApprover'] = async (request: Types.PostV1RentalAgreementsAddApproverRequest): Promise<Types.PostV1RentalAgreementsAddApproverResponses> => {
  return await _postV1RentalAgreementsAddApprover(baseUrl, request)
}
const _putV1RentalAgreementsApprovalStatusId = async (url: string, request: Types.PutV1RentalAgreementsApprovalStatusIdRequest): Promise<Types.PutV1RentalAgreementsApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-agreements/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalAgreementsApprovalStatusId: Api['putV1RentalAgreementsApprovalStatusId'] = async (request: Types.PutV1RentalAgreementsApprovalStatusIdRequest): Promise<Types.PutV1RentalAgreementsApprovalStatusIdResponses> => {
  return await _putV1RentalAgreementsApprovalStatusId(baseUrl, request)
}
const _postV1RentalAgreementsItems = async (url: string, request: Types.PostV1RentalAgreementsItemsRequest): Promise<Types.PostV1RentalAgreementsItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-agreements/items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalAgreementsItems: Api['postV1RentalAgreementsItems'] = async (request: Types.PostV1RentalAgreementsItemsRequest): Promise<Types.PostV1RentalAgreementsItemsResponses> => {
  return await _postV1RentalAgreementsItems(baseUrl, request)
}
const _getV1RentalAgreementsItemsId = async (url: string, request: Types.GetV1RentalAgreementsItemsIdRequest): Promise<Types.GetV1RentalAgreementsItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalAgreementsItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-agreements/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalAgreementsItemsId: Api['getV1RentalAgreementsItemsId'] = async (request: Types.GetV1RentalAgreementsItemsIdRequest): Promise<Types.GetV1RentalAgreementsItemsIdResponses> => {
  return await _getV1RentalAgreementsItemsId(baseUrl, request)
}
const _putV1RentalAgreementsItemsId = async (url: string, request: Types.PutV1RentalAgreementsItemsIdRequest): Promise<Types.PutV1RentalAgreementsItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-agreements/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalAgreementsItemsId: Api['putV1RentalAgreementsItemsId'] = async (request: Types.PutV1RentalAgreementsItemsIdRequest): Promise<Types.PutV1RentalAgreementsItemsIdResponses> => {
  return await _putV1RentalAgreementsItemsId(baseUrl, request)
}
const _deleteV1RentalAgreementsItemsId = async (url: string, request: Types.DeleteV1RentalAgreementsItemsIdRequest): Promise<Types.DeleteV1RentalAgreementsItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-agreements/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalAgreementsItemsId: Api['deleteV1RentalAgreementsItemsId'] = async (request: Types.DeleteV1RentalAgreementsItemsIdRequest): Promise<Types.DeleteV1RentalAgreementsItemsIdResponses> => {
  return await _deleteV1RentalAgreementsItemsId(baseUrl, request)
}
const _getV1RentalAgreementsGenerateExcel = async (url: string, request: Types.GetV1RentalAgreementsGenerateExcelRequest): Promise<Types.GetV1RentalAgreementsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1RentalAgreementsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-agreements/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalAgreementsGenerateExcel: Api['getV1RentalAgreementsGenerateExcel'] = async (request: Types.GetV1RentalAgreementsGenerateExcelRequest): Promise<Types.GetV1RentalAgreementsGenerateExcelResponses> => {
  return await _getV1RentalAgreementsGenerateExcel(baseUrl, request)
}
const _postV1RentalAgreementsImport = async (url: string, request: Types.PostV1RentalAgreementsImportRequest): Promise<Types.PostV1RentalAgreementsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-agreements/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalAgreementsImport: Api['postV1RentalAgreementsImport'] = async (request: Types.PostV1RentalAgreementsImportRequest): Promise<Types.PostV1RentalAgreementsImportResponses> => {
  return await _postV1RentalAgreementsImport(baseUrl, request)
}
const _postV1RentalDemandPlanningSummary = async (url: string, request: Types.PostV1RentalDemandPlanningSummaryRequest): Promise<Types.PostV1RentalDemandPlanningSummaryResponses> => {
  const queryParameters: (keyof Types.PostV1RentalDemandPlanningSummaryRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-demand-planning/summary?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDemandPlanningSummary: Api['postV1RentalDemandPlanningSummary'] = async (request: Types.PostV1RentalDemandPlanningSummaryRequest): Promise<Types.PostV1RentalDemandPlanningSummaryResponses> => {
  return await _postV1RentalDemandPlanningSummary(baseUrl, request)
}
const _postV1RentalDemandPlanningDetail = async (url: string, request: Types.PostV1RentalDemandPlanningDetailRequest): Promise<Types.PostV1RentalDemandPlanningDetailResponses> => {
  const queryParameters: (keyof Types.PostV1RentalDemandPlanningDetailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-demand-planning/detail?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDemandPlanningDetail: Api['postV1RentalDemandPlanningDetail'] = async (request: Types.PostV1RentalDemandPlanningDetailRequest): Promise<Types.PostV1RentalDemandPlanningDetailResponses> => {
  return await _postV1RentalDemandPlanningDetail(baseUrl, request)
}
const _postV1RentalDemandPlanningDemand = async (url: string, request: Types.PostV1RentalDemandPlanningDemandRequest): Promise<Types.PostV1RentalDemandPlanningDemandResponses> => {
  const queryParameters: (keyof Types.PostV1RentalDemandPlanningDemandRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-demand-planning/demand?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDemandPlanningDemand: Api['postV1RentalDemandPlanningDemand'] = async (request: Types.PostV1RentalDemandPlanningDemandRequest): Promise<Types.PostV1RentalDemandPlanningDemandResponses> => {
  return await _postV1RentalDemandPlanningDemand(baseUrl, request)
}
const _postV1RentalDemandPlanningMaterials = async (url: string, request: Types.PostV1RentalDemandPlanningMaterialsRequest): Promise<Types.PostV1RentalDemandPlanningMaterialsResponses> => {
  const queryParameters: (keyof Types.PostV1RentalDemandPlanningMaterialsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-demand-planning/materials?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDemandPlanningMaterials: Api['postV1RentalDemandPlanningMaterials'] = async (request: Types.PostV1RentalDemandPlanningMaterialsRequest): Promise<Types.PostV1RentalDemandPlanningMaterialsResponses> => {
  return await _postV1RentalDemandPlanningMaterials(baseUrl, request)
}
const _postV1RentalDemandPlanningGenerateExcel = async (url: string, request: Types.PostV1RentalDemandPlanningGenerateExcelRequest): Promise<Types.PostV1RentalDemandPlanningGenerateExcelResponses> => {
  const queryParameters: (keyof Types.PostV1RentalDemandPlanningGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-demand-planning/generate-excel?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDemandPlanningGenerateExcel: Api['postV1RentalDemandPlanningGenerateExcel'] = async (request: Types.PostV1RentalDemandPlanningGenerateExcelRequest): Promise<Types.PostV1RentalDemandPlanningGenerateExcelResponses> => {
  return await _postV1RentalDemandPlanningGenerateExcel(baseUrl, request)
}
const _postV1InvoiceRentalOrders = async (url: string, request: Types.PostV1InvoiceRentalOrdersRequest): Promise<Types.PostV1InvoiceRentalOrdersResponses> => {
  const queryParameters: (keyof Types.PostV1InvoiceRentalOrdersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/invoice-rental-orders/?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1InvoiceRentalOrders: Api['postV1InvoiceRentalOrders'] = async (request: Types.PostV1InvoiceRentalOrdersRequest): Promise<Types.PostV1InvoiceRentalOrdersResponses> => {
  return await _postV1InvoiceRentalOrders(baseUrl, request)
}
const _postV1InvoiceRentalOrdersGenerateInvoice = async (url: string, request: Types.PostV1InvoiceRentalOrdersGenerateInvoiceRequest): Promise<Types.PostV1InvoiceRentalOrdersGenerateInvoiceResponses> => {
  const queryParameters: (keyof Types.PostV1InvoiceRentalOrdersGenerateInvoiceRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/invoice-rental-orders/generate-invoice?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1InvoiceRentalOrdersGenerateInvoice: Api['postV1InvoiceRentalOrdersGenerateInvoice'] = async (request: Types.PostV1InvoiceRentalOrdersGenerateInvoiceRequest): Promise<Types.PostV1InvoiceRentalOrdersGenerateInvoiceResponses> => {
  return await _postV1InvoiceRentalOrdersGenerateInvoice(baseUrl, request)
}
const _postV1InvoiceRentalOrdersAccumulateOrders = async (url: string, request: Types.PostV1InvoiceRentalOrdersAccumulateOrdersRequest): Promise<Types.PostV1InvoiceRentalOrdersAccumulateOrdersResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/invoice-rental-orders/accumulate-orders`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1InvoiceRentalOrdersAccumulateOrders: Api['postV1InvoiceRentalOrdersAccumulateOrders'] = async (request: Types.PostV1InvoiceRentalOrdersAccumulateOrdersRequest): Promise<Types.PostV1InvoiceRentalOrdersAccumulateOrdersResponses> => {
  return await _postV1InvoiceRentalOrdersAccumulateOrders(baseUrl, request)
}
const _postV1RentalDeliveryOrders = async (url: string, request: Types.PostV1RentalDeliveryOrdersRequest): Promise<Types.PostV1RentalDeliveryOrdersResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDeliveryOrders: Api['postV1RentalDeliveryOrders'] = async (request: Types.PostV1RentalDeliveryOrdersRequest): Promise<Types.PostV1RentalDeliveryOrdersResponses> => {
  return await _postV1RentalDeliveryOrders(baseUrl, request)
}
const _getV1RentalDeliveryOrders = async (url: string, request: Types.GetV1RentalDeliveryOrdersRequest): Promise<Types.GetV1RentalDeliveryOrdersResponses> => {
  const queryParameters: (keyof Types.GetV1RentalDeliveryOrdersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalDeliveryOrders: Api['getV1RentalDeliveryOrders'] = async (request: Types.GetV1RentalDeliveryOrdersRequest): Promise<Types.GetV1RentalDeliveryOrdersResponses> => {
  return await _getV1RentalDeliveryOrders(baseUrl, request)
}
const _postV1RentalDeliveryOrdersSaveDraft = async (url: string, request: Types.PostV1RentalDeliveryOrdersSaveDraftRequest): Promise<Types.PostV1RentalDeliveryOrdersSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDeliveryOrdersSaveDraft: Api['postV1RentalDeliveryOrdersSaveDraft'] = async (request: Types.PostV1RentalDeliveryOrdersSaveDraftRequest): Promise<Types.PostV1RentalDeliveryOrdersSaveDraftResponses> => {
  return await _postV1RentalDeliveryOrdersSaveDraft(baseUrl, request)
}
const _getV1RentalDeliveryOrdersId = async (url: string, request: Types.GetV1RentalDeliveryOrdersIdRequest): Promise<Types.GetV1RentalDeliveryOrdersIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalDeliveryOrdersIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalDeliveryOrdersId: Api['getV1RentalDeliveryOrdersId'] = async (request: Types.GetV1RentalDeliveryOrdersIdRequest): Promise<Types.GetV1RentalDeliveryOrdersIdResponses> => {
  return await _getV1RentalDeliveryOrdersId(baseUrl, request)
}
const _deleteV1RentalDeliveryOrdersId = async (url: string, request: Types.DeleteV1RentalDeliveryOrdersIdRequest): Promise<Types.DeleteV1RentalDeliveryOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalDeliveryOrdersId: Api['deleteV1RentalDeliveryOrdersId'] = async (request: Types.DeleteV1RentalDeliveryOrdersIdRequest): Promise<Types.DeleteV1RentalDeliveryOrdersIdResponses> => {
  return await _deleteV1RentalDeliveryOrdersId(baseUrl, request)
}
const _putV1RentalDeliveryOrdersId = async (url: string, request: Types.PutV1RentalDeliveryOrdersIdRequest): Promise<Types.PutV1RentalDeliveryOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalDeliveryOrdersId: Api['putV1RentalDeliveryOrdersId'] = async (request: Types.PutV1RentalDeliveryOrdersIdRequest): Promise<Types.PutV1RentalDeliveryOrdersIdResponses> => {
  return await _putV1RentalDeliveryOrdersId(baseUrl, request)
}
const _patchV1RentalDeliveryOrdersStatusId = async (url: string, request: Types.PatchV1RentalDeliveryOrdersStatusIdRequest): Promise<Types.PatchV1RentalDeliveryOrdersStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1RentalDeliveryOrdersStatusId: Api['patchV1RentalDeliveryOrdersStatusId'] = async (request: Types.PatchV1RentalDeliveryOrdersStatusIdRequest): Promise<Types.PatchV1RentalDeliveryOrdersStatusIdResponses> => {
  return await _patchV1RentalDeliveryOrdersStatusId(baseUrl, request)
}
const _getV1RentalDeliveryOrdersItemsId = async (url: string, request: Types.GetV1RentalDeliveryOrdersItemsIdRequest): Promise<Types.GetV1RentalDeliveryOrdersItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalDeliveryOrdersItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalDeliveryOrdersItemsId: Api['getV1RentalDeliveryOrdersItemsId'] = async (request: Types.GetV1RentalDeliveryOrdersItemsIdRequest): Promise<Types.GetV1RentalDeliveryOrdersItemsIdResponses> => {
  return await _getV1RentalDeliveryOrdersItemsId(baseUrl, request)
}
const _putV1RentalDeliveryOrdersItemsId = async (url: string, request: Types.PutV1RentalDeliveryOrdersItemsIdRequest): Promise<Types.PutV1RentalDeliveryOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalDeliveryOrdersItemsId: Api['putV1RentalDeliveryOrdersItemsId'] = async (request: Types.PutV1RentalDeliveryOrdersItemsIdRequest): Promise<Types.PutV1RentalDeliveryOrdersItemsIdResponses> => {
  return await _putV1RentalDeliveryOrdersItemsId(baseUrl, request)
}
const _deleteV1RentalDeliveryOrdersItemsId = async (url: string, request: Types.DeleteV1RentalDeliveryOrdersItemsIdRequest): Promise<Types.DeleteV1RentalDeliveryOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalDeliveryOrdersItemsId: Api['deleteV1RentalDeliveryOrdersItemsId'] = async (request: Types.DeleteV1RentalDeliveryOrdersItemsIdRequest): Promise<Types.DeleteV1RentalDeliveryOrdersItemsIdResponses> => {
  return await _deleteV1RentalDeliveryOrdersItemsId(baseUrl, request)
}
const _postV1RentalDeliveryOrdersPackages = async (url: string, request: Types.PostV1RentalDeliveryOrdersPackagesRequest): Promise<Types.PostV1RentalDeliveryOrdersPackagesResponses> => {
  const queryParameters: (keyof Types.PostV1RentalDeliveryOrdersPackagesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/packages/?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDeliveryOrdersPackages: Api['postV1RentalDeliveryOrdersPackages'] = async (request: Types.PostV1RentalDeliveryOrdersPackagesRequest): Promise<Types.PostV1RentalDeliveryOrdersPackagesResponses> => {
  return await _postV1RentalDeliveryOrdersPackages(baseUrl, request)
}
const _getV1RentalDeliveryOrdersPackagesId = async (url: string, request: Types.GetV1RentalDeliveryOrdersPackagesIdRequest): Promise<Types.GetV1RentalDeliveryOrdersPackagesIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalDeliveryOrdersPackagesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/packages/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalDeliveryOrdersPackagesId: Api['getV1RentalDeliveryOrdersPackagesId'] = async (request: Types.GetV1RentalDeliveryOrdersPackagesIdRequest): Promise<Types.GetV1RentalDeliveryOrdersPackagesIdResponses> => {
  return await _getV1RentalDeliveryOrdersPackagesId(baseUrl, request)
}
const _putV1RentalDeliveryOrdersPackagesId = async (url: string, request: Types.PutV1RentalDeliveryOrdersPackagesIdRequest): Promise<Types.PutV1RentalDeliveryOrdersPackagesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/packages/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalDeliveryOrdersPackagesId: Api['putV1RentalDeliveryOrdersPackagesId'] = async (request: Types.PutV1RentalDeliveryOrdersPackagesIdRequest): Promise<Types.PutV1RentalDeliveryOrdersPackagesIdResponses> => {
  return await _putV1RentalDeliveryOrdersPackagesId(baseUrl, request)
}
const _deleteV1RentalDeliveryOrdersPackagesId = async (url: string, request: Types.DeleteV1RentalDeliveryOrdersPackagesIdRequest): Promise<Types.DeleteV1RentalDeliveryOrdersPackagesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/packages/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalDeliveryOrdersPackagesId: Api['deleteV1RentalDeliveryOrdersPackagesId'] = async (request: Types.DeleteV1RentalDeliveryOrdersPackagesIdRequest): Promise<Types.DeleteV1RentalDeliveryOrdersPackagesIdResponses> => {
  return await _deleteV1RentalDeliveryOrdersPackagesId(baseUrl, request)
}
const _getV1RentalDeliveryOrdersIdPackages = async (url: string, request: Types.GetV1RentalDeliveryOrdersIdPackagesRequest): Promise<Types.GetV1RentalDeliveryOrdersIdPackagesResponses> => {
  const queryParameters: (keyof Types.GetV1RentalDeliveryOrdersIdPackagesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}/packages/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalDeliveryOrdersIdPackages: Api['getV1RentalDeliveryOrdersIdPackages'] = async (request: Types.GetV1RentalDeliveryOrdersIdPackagesRequest): Promise<Types.GetV1RentalDeliveryOrdersIdPackagesResponses> => {
  return await _getV1RentalDeliveryOrdersIdPackages(baseUrl, request)
}
const _postV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackages = async (url: string, request: Types.PostV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesRequest): Promise<Types.PostV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesResponses> => {
  const queryParameters: (keyof Types.PostV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['deliveryId']}/items/${request['itemId']}/packages/?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackages: Api['postV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackages'] = async (request: Types.PostV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesRequest): Promise<Types.PostV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesResponses> => {
  return await _postV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackages(baseUrl, request)
}
const _getV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackages = async (url: string, request: Types.GetV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesRequest): Promise<Types.GetV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['deliveryId']}/items/${request['itemId']}/packages/`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackages: Api['getV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackages'] = async (request: Types.GetV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesRequest): Promise<Types.GetV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesResponses> => {
  return await _getV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackages(baseUrl, request)
}
const _deleteV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesId = async (url: string, request: Types.DeleteV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesIdRequest): Promise<Types.DeleteV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['deliveryId']}/items/${request['itemId']}/packages/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesId: Api['deleteV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesId'] = async (request: Types.DeleteV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesIdRequest): Promise<Types.DeleteV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesIdResponses> => {
  return await _deleteV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesId(baseUrl, request)
}
const _postV1RentalDeliveryOrdersDeliveryIdItemsItemIdTracking = async (url: string, request: Types.PostV1RentalDeliveryOrdersDeliveryIdItemsItemIdTrackingRequest): Promise<Types.PostV1RentalDeliveryOrdersDeliveryIdItemsItemIdTrackingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['deliveryId']}/items/${request['itemId']}/tracking`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDeliveryOrdersDeliveryIdItemsItemIdTracking: Api['postV1RentalDeliveryOrdersDeliveryIdItemsItemIdTracking'] = async (request: Types.PostV1RentalDeliveryOrdersDeliveryIdItemsItemIdTrackingRequest): Promise<Types.PostV1RentalDeliveryOrdersDeliveryIdItemsItemIdTrackingResponses> => {
  return await _postV1RentalDeliveryOrdersDeliveryIdItemsItemIdTracking(baseUrl, request)
}
const _postV1RentalDeliveryOrdersDeliveryIdInventoryAdjustment = async (url: string, request: Types.PostV1RentalDeliveryOrdersDeliveryIdInventoryAdjustmentRequest): Promise<Types.PostV1RentalDeliveryOrdersDeliveryIdInventoryAdjustmentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['deliveryId']}/inventory-adjustment`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDeliveryOrdersDeliveryIdInventoryAdjustment: Api['postV1RentalDeliveryOrdersDeliveryIdInventoryAdjustment'] = async (request: Types.PostV1RentalDeliveryOrdersDeliveryIdInventoryAdjustmentRequest): Promise<Types.PostV1RentalDeliveryOrdersDeliveryIdInventoryAdjustmentResponses> => {
  return await _postV1RentalDeliveryOrdersDeliveryIdInventoryAdjustment(baseUrl, request)
}
const _getV1RentalDeliveryOrdersIdCreateInvoice = async (url: string, request: Types.GetV1RentalDeliveryOrdersIdCreateInvoiceRequest): Promise<Types.GetV1RentalDeliveryOrdersIdCreateInvoiceResponses> => {
  const queryParameters: (keyof Types.GetV1RentalDeliveryOrdersIdCreateInvoiceRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}/create-invoice?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalDeliveryOrdersIdCreateInvoice: Api['getV1RentalDeliveryOrdersIdCreateInvoice'] = async (request: Types.GetV1RentalDeliveryOrdersIdCreateInvoiceRequest): Promise<Types.GetV1RentalDeliveryOrdersIdCreateInvoiceResponses> => {
  return await _getV1RentalDeliveryOrdersIdCreateInvoice(baseUrl, request)
}
const _getV1RentalDeliveryOrdersIdSendEmail = async (url: string, request: Types.GetV1RentalDeliveryOrdersIdSendEmailRequest): Promise<Types.GetV1RentalDeliveryOrdersIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1RentalDeliveryOrdersIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalDeliveryOrdersIdSendEmail: Api['getV1RentalDeliveryOrdersIdSendEmail'] = async (request: Types.GetV1RentalDeliveryOrdersIdSendEmailRequest): Promise<Types.GetV1RentalDeliveryOrdersIdSendEmailResponses> => {
  return await _getV1RentalDeliveryOrdersIdSendEmail(baseUrl, request)
}
const _getV1RentalDeliveryOrdersIdDownload = async (url: string, request: Types.GetV1RentalDeliveryOrdersIdDownloadRequest): Promise<Types.GetV1RentalDeliveryOrdersIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1RentalDeliveryOrdersIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalDeliveryOrdersIdDownload: Api['getV1RentalDeliveryOrdersIdDownload'] = async (request: Types.GetV1RentalDeliveryOrdersIdDownloadRequest): Promise<Types.GetV1RentalDeliveryOrdersIdDownloadResponses> => {
  return await _getV1RentalDeliveryOrdersIdDownload(baseUrl, request)
}
const _getV1RentalDeliveryOrdersGenerateExcel = async (url: string, request: Types.GetV1RentalDeliveryOrdersGenerateExcelRequest): Promise<Types.GetV1RentalDeliveryOrdersGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1RentalDeliveryOrdersGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalDeliveryOrdersGenerateExcel: Api['getV1RentalDeliveryOrdersGenerateExcel'] = async (request: Types.GetV1RentalDeliveryOrdersGenerateExcelRequest): Promise<Types.GetV1RentalDeliveryOrdersGenerateExcelResponses> => {
  return await _getV1RentalDeliveryOrdersGenerateExcel(baseUrl, request)
}
const _postV1RentalDeliveryOrdersIdGrn = async (url: string, request: Types.PostV1RentalDeliveryOrdersIdGrnRequest): Promise<Types.PostV1RentalDeliveryOrdersIdGrnResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}/grn`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDeliveryOrdersIdGrn: Api['postV1RentalDeliveryOrdersIdGrn'] = async (request: Types.PostV1RentalDeliveryOrdersIdGrnRequest): Promise<Types.PostV1RentalDeliveryOrdersIdGrnResponses> => {
  return await _postV1RentalDeliveryOrdersIdGrn(baseUrl, request)
}
const _getV1RentalDeliveryOrdersIdGrn = async (url: string, request: Types.GetV1RentalDeliveryOrdersIdGrnRequest): Promise<Types.GetV1RentalDeliveryOrdersIdGrnResponses> => {
  const queryParameters: (keyof Types.GetV1RentalDeliveryOrdersIdGrnRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}/grn?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalDeliveryOrdersIdGrn: Api['getV1RentalDeliveryOrdersIdGrn'] = async (request: Types.GetV1RentalDeliveryOrdersIdGrnRequest): Promise<Types.GetV1RentalDeliveryOrdersIdGrnResponses> => {
  return await _getV1RentalDeliveryOrdersIdGrn(baseUrl, request)
}
const _getV1RentalDeliveryOrdersIdGrnGrnId = async (url: string, request: Types.GetV1RentalDeliveryOrdersIdGrnGrnIdRequest): Promise<Types.GetV1RentalDeliveryOrdersIdGrnGrnIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalDeliveryOrdersIdGrnGrnIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}/grn/${request['grnId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalDeliveryOrdersIdGrnGrnId: Api['getV1RentalDeliveryOrdersIdGrnGrnId'] = async (request: Types.GetV1RentalDeliveryOrdersIdGrnGrnIdRequest): Promise<Types.GetV1RentalDeliveryOrdersIdGrnGrnIdResponses> => {
  return await _getV1RentalDeliveryOrdersIdGrnGrnId(baseUrl, request)
}
const _deleteV1RentalDeliveryOrdersIdGrnGrnId = async (url: string, request: Types.DeleteV1RentalDeliveryOrdersIdGrnGrnIdRequest): Promise<Types.DeleteV1RentalDeliveryOrdersIdGrnGrnIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}/grn/${request['grnId']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalDeliveryOrdersIdGrnGrnId: Api['deleteV1RentalDeliveryOrdersIdGrnGrnId'] = async (request: Types.DeleteV1RentalDeliveryOrdersIdGrnGrnIdRequest): Promise<Types.DeleteV1RentalDeliveryOrdersIdGrnGrnIdResponses> => {
  return await _deleteV1RentalDeliveryOrdersIdGrnGrnId(baseUrl, request)
}
const _putV1RentalDeliveryOrdersIdGrnGrnId = async (url: string, request: Types.PutV1RentalDeliveryOrdersIdGrnGrnIdRequest): Promise<Types.PutV1RentalDeliveryOrdersIdGrnGrnIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}/grn/${request['grnId']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalDeliveryOrdersIdGrnGrnId: Api['putV1RentalDeliveryOrdersIdGrnGrnId'] = async (request: Types.PutV1RentalDeliveryOrdersIdGrnGrnIdRequest): Promise<Types.PutV1RentalDeliveryOrdersIdGrnGrnIdResponses> => {
  return await _putV1RentalDeliveryOrdersIdGrnGrnId(baseUrl, request)
}
const _getV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId = async (url: string, request: Types.GetV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdRequest): Promise<Types.GetV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdResponses> => {
  const queryParameters: (keyof Types.GetV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}/grn/${request['grnId']}/items/${request['itemId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId: Api['getV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId'] = async (request: Types.GetV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdRequest): Promise<Types.GetV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdResponses> => {
  return await _getV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId(baseUrl, request)
}
const _putV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId = async (url: string, request: Types.PutV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdRequest): Promise<Types.PutV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}/grn/${request['grnId']}/items/${request['itemId']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId: Api['putV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId'] = async (request: Types.PutV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdRequest): Promise<Types.PutV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdResponses> => {
  return await _putV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId(baseUrl, request)
}
const _deleteV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId = async (url: string, request: Types.DeleteV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdRequest): Promise<Types.DeleteV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}/grn/${request['grnId']}/items/${request['itemId']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId: Api['deleteV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId'] = async (request: Types.DeleteV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdRequest): Promise<Types.DeleteV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdResponses> => {
  return await _deleteV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId(baseUrl, request)
}
const _postV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdTracking = async (url: string, request: Types.PostV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdTrackingRequest): Promise<Types.PostV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdTrackingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}/grn/${request['grnId']}/items/${request['itemId']}/tracking`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdTracking: Api['postV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdTracking'] = async (request: Types.PostV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdTrackingRequest): Promise<Types.PostV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdTrackingResponses> => {
  return await _postV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdTracking(baseUrl, request)
}
const _postV1RentalDeliveryOrdersIdGrnGrnIdInventoryAdjustment = async (url: string, request: Types.PostV1RentalDeliveryOrdersIdGrnGrnIdInventoryAdjustmentRequest): Promise<Types.PostV1RentalDeliveryOrdersIdGrnGrnIdInventoryAdjustmentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['id']}/grn/${request['grnId']}/inventory-adjustment`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDeliveryOrdersIdGrnGrnIdInventoryAdjustment: Api['postV1RentalDeliveryOrdersIdGrnGrnIdInventoryAdjustment'] = async (request: Types.PostV1RentalDeliveryOrdersIdGrnGrnIdInventoryAdjustmentRequest): Promise<Types.PostV1RentalDeliveryOrdersIdGrnGrnIdInventoryAdjustmentResponses> => {
  return await _postV1RentalDeliveryOrdersIdGrnGrnIdInventoryAdjustment(baseUrl, request)
}
const _postV1RentalDeliveryOrdersDeliveryIdItemsItemIdVendorReturnTracking = async (url: string, request: Types.PostV1RentalDeliveryOrdersDeliveryIdItemsItemIdVendorReturnTrackingRequest): Promise<Types.PostV1RentalDeliveryOrdersDeliveryIdItemsItemIdVendorReturnTrackingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['deliveryId']}/items/${request['itemId']}/vendor-return/tracking`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDeliveryOrdersDeliveryIdItemsItemIdVendorReturnTracking: Api['postV1RentalDeliveryOrdersDeliveryIdItemsItemIdVendorReturnTracking'] = async (request: Types.PostV1RentalDeliveryOrdersDeliveryIdItemsItemIdVendorReturnTrackingRequest): Promise<Types.PostV1RentalDeliveryOrdersDeliveryIdItemsItemIdVendorReturnTrackingResponses> => {
  return await _postV1RentalDeliveryOrdersDeliveryIdItemsItemIdVendorReturnTracking(baseUrl, request)
}
const _postV1RentalDeliveryOrdersDeliveryIdVendorReturnInventoryAdjustment = async (url: string, request: Types.PostV1RentalDeliveryOrdersDeliveryIdVendorReturnInventoryAdjustmentRequest): Promise<Types.PostV1RentalDeliveryOrdersDeliveryIdVendorReturnInventoryAdjustmentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/rental-delivery-orders/${request['deliveryId']}/vendor-return/inventory-adjustment`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1RentalDeliveryOrdersDeliveryIdVendorReturnInventoryAdjustment: Api['postV1RentalDeliveryOrdersDeliveryIdVendorReturnInventoryAdjustment'] = async (request: Types.PostV1RentalDeliveryOrdersDeliveryIdVendorReturnInventoryAdjustmentRequest): Promise<Types.PostV1RentalDeliveryOrdersDeliveryIdVendorReturnInventoryAdjustmentResponses> => {
  return await _postV1RentalDeliveryOrdersDeliveryIdVendorReturnInventoryAdjustment(baseUrl, request)
}
const _postV1CrossHireRequests = async (url: string, request: Types.PostV1CrossHireRequestsRequest): Promise<Types.PostV1CrossHireRequestsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireRequests: Api['postV1CrossHireRequests'] = async (request: Types.PostV1CrossHireRequestsRequest): Promise<Types.PostV1CrossHireRequestsResponses> => {
  return await _postV1CrossHireRequests(baseUrl, request)
}
const _getV1CrossHireRequests = async (url: string, request: Types.GetV1CrossHireRequestsRequest): Promise<Types.GetV1CrossHireRequestsResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRequestsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRequests: Api['getV1CrossHireRequests'] = async (request: Types.GetV1CrossHireRequestsRequest): Promise<Types.GetV1CrossHireRequestsResponses> => {
  return await _getV1CrossHireRequests(baseUrl, request)
}
const _postV1CrossHireRequestsSaveDraft = async (url: string, request: Types.PostV1CrossHireRequestsSaveDraftRequest): Promise<Types.PostV1CrossHireRequestsSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireRequestsSaveDraft: Api['postV1CrossHireRequestsSaveDraft'] = async (request: Types.PostV1CrossHireRequestsSaveDraftRequest): Promise<Types.PostV1CrossHireRequestsSaveDraftResponses> => {
  return await _postV1CrossHireRequestsSaveDraft(baseUrl, request)
}
const _getV1CrossHireRequestsId = async (url: string, request: Types.GetV1CrossHireRequestsIdRequest): Promise<Types.GetV1CrossHireRequestsIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRequestsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRequestsId: Api['getV1CrossHireRequestsId'] = async (request: Types.GetV1CrossHireRequestsIdRequest): Promise<Types.GetV1CrossHireRequestsIdResponses> => {
  return await _getV1CrossHireRequestsId(baseUrl, request)
}
const _putV1CrossHireRequestsId = async (url: string, request: Types.PutV1CrossHireRequestsIdRequest): Promise<Types.PutV1CrossHireRequestsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireRequestsId: Api['putV1CrossHireRequestsId'] = async (request: Types.PutV1CrossHireRequestsIdRequest): Promise<Types.PutV1CrossHireRequestsIdResponses> => {
  return await _putV1CrossHireRequestsId(baseUrl, request)
}
const _deleteV1CrossHireRequestsId = async (url: string, request: Types.DeleteV1CrossHireRequestsIdRequest): Promise<Types.DeleteV1CrossHireRequestsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireRequestsId: Api['deleteV1CrossHireRequestsId'] = async (request: Types.DeleteV1CrossHireRequestsIdRequest): Promise<Types.DeleteV1CrossHireRequestsIdResponses> => {
  return await _deleteV1CrossHireRequestsId(baseUrl, request)
}
const _patchV1CrossHireRequestsStatusId = async (url: string, request: Types.PatchV1CrossHireRequestsStatusIdRequest): Promise<Types.PatchV1CrossHireRequestsStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1CrossHireRequestsStatusId: Api['patchV1CrossHireRequestsStatusId'] = async (request: Types.PatchV1CrossHireRequestsStatusIdRequest): Promise<Types.PatchV1CrossHireRequestsStatusIdResponses> => {
  return await _patchV1CrossHireRequestsStatusId(baseUrl, request)
}
const _postV1CrossHireRequestsAddApprover = async (url: string, request: Types.PostV1CrossHireRequestsAddApproverRequest): Promise<Types.PostV1CrossHireRequestsAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireRequestsAddApprover: Api['postV1CrossHireRequestsAddApprover'] = async (request: Types.PostV1CrossHireRequestsAddApproverRequest): Promise<Types.PostV1CrossHireRequestsAddApproverResponses> => {
  return await _postV1CrossHireRequestsAddApprover(baseUrl, request)
}
const _putV1CrossHireRequestsApprovalStatusId = async (url: string, request: Types.PutV1CrossHireRequestsApprovalStatusIdRequest): Promise<Types.PutV1CrossHireRequestsApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireRequestsApprovalStatusId: Api['putV1CrossHireRequestsApprovalStatusId'] = async (request: Types.PutV1CrossHireRequestsApprovalStatusIdRequest): Promise<Types.PutV1CrossHireRequestsApprovalStatusIdResponses> => {
  return await _putV1CrossHireRequestsApprovalStatusId(baseUrl, request)
}
const _postV1CrossHireRequestsItems = async (url: string, request: Types.PostV1CrossHireRequestsItemsRequest): Promise<Types.PostV1CrossHireRequestsItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireRequestsItems: Api['postV1CrossHireRequestsItems'] = async (request: Types.PostV1CrossHireRequestsItemsRequest): Promise<Types.PostV1CrossHireRequestsItemsResponses> => {
  return await _postV1CrossHireRequestsItems(baseUrl, request)
}
const _getV1CrossHireRequestsItemsId = async (url: string, request: Types.GetV1CrossHireRequestsItemsIdRequest): Promise<Types.GetV1CrossHireRequestsItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRequestsItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRequestsItemsId: Api['getV1CrossHireRequestsItemsId'] = async (request: Types.GetV1CrossHireRequestsItemsIdRequest): Promise<Types.GetV1CrossHireRequestsItemsIdResponses> => {
  return await _getV1CrossHireRequestsItemsId(baseUrl, request)
}
const _putV1CrossHireRequestsItemsId = async (url: string, request: Types.PutV1CrossHireRequestsItemsIdRequest): Promise<Types.PutV1CrossHireRequestsItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireRequestsItemsId: Api['putV1CrossHireRequestsItemsId'] = async (request: Types.PutV1CrossHireRequestsItemsIdRequest): Promise<Types.PutV1CrossHireRequestsItemsIdResponses> => {
  return await _putV1CrossHireRequestsItemsId(baseUrl, request)
}
const _deleteV1CrossHireRequestsItemsId = async (url: string, request: Types.DeleteV1CrossHireRequestsItemsIdRequest): Promise<Types.DeleteV1CrossHireRequestsItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireRequestsItemsId: Api['deleteV1CrossHireRequestsItemsId'] = async (request: Types.DeleteV1CrossHireRequestsItemsIdRequest): Promise<Types.DeleteV1CrossHireRequestsItemsIdResponses> => {
  return await _deleteV1CrossHireRequestsItemsId(baseUrl, request)
}
const _getV1CrossHireRequestsGenerateExcel = async (url: string, request: Types.GetV1CrossHireRequestsGenerateExcelRequest): Promise<Types.GetV1CrossHireRequestsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRequestsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRequestsGenerateExcel: Api['getV1CrossHireRequestsGenerateExcel'] = async (request: Types.GetV1CrossHireRequestsGenerateExcelRequest): Promise<Types.GetV1CrossHireRequestsGenerateExcelResponses> => {
  return await _getV1CrossHireRequestsGenerateExcel(baseUrl, request)
}
const _postV1CrossHireRequestsImport = async (url: string, request: Types.PostV1CrossHireRequestsImportRequest): Promise<Types.PostV1CrossHireRequestsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireRequestsImport: Api['postV1CrossHireRequestsImport'] = async (request: Types.PostV1CrossHireRequestsImportRequest): Promise<Types.PostV1CrossHireRequestsImportResponses> => {
  return await _postV1CrossHireRequestsImport(baseUrl, request)
}
const _getV1CrossHireRequestsIdProvideDetails = async (url: string, request: Types.GetV1CrossHireRequestsIdProvideDetailsRequest): Promise<Types.GetV1CrossHireRequestsIdProvideDetailsResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRequestsIdProvideDetailsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-requests/${request['id']}/provide-details?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRequestsIdProvideDetails: Api['getV1CrossHireRequestsIdProvideDetails'] = async (request: Types.GetV1CrossHireRequestsIdProvideDetailsRequest): Promise<Types.GetV1CrossHireRequestsIdProvideDetailsResponses> => {
  return await _getV1CrossHireRequestsIdProvideDetails(baseUrl, request)
}
const _postV1CrossHireRfq = async (url: string, request: Types.PostV1CrossHireRfqRequest): Promise<Types.PostV1CrossHireRfqResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireRfq: Api['postV1CrossHireRfq'] = async (request: Types.PostV1CrossHireRfqRequest): Promise<Types.PostV1CrossHireRfqResponses> => {
  return await _postV1CrossHireRfq(baseUrl, request)
}
const _getV1CrossHireRfq = async (url: string, request: Types.GetV1CrossHireRfqRequest): Promise<Types.GetV1CrossHireRfqResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRfqRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRfq: Api['getV1CrossHireRfq'] = async (request: Types.GetV1CrossHireRfqRequest): Promise<Types.GetV1CrossHireRfqResponses> => {
  return await _getV1CrossHireRfq(baseUrl, request)
}
const _postV1CrossHireRfqSaveDraft = async (url: string, request: Types.PostV1CrossHireRfqSaveDraftRequest): Promise<Types.PostV1CrossHireRfqSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireRfqSaveDraft: Api['postV1CrossHireRfqSaveDraft'] = async (request: Types.PostV1CrossHireRfqSaveDraftRequest): Promise<Types.PostV1CrossHireRfqSaveDraftResponses> => {
  return await _postV1CrossHireRfqSaveDraft(baseUrl, request)
}
const _getV1CrossHireRfqResponseItems = async (url: string, request: Types.GetV1CrossHireRfqResponseItemsRequest): Promise<Types.GetV1CrossHireRfqResponseItemsResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRfqResponseItemsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/response-items?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRfqResponseItems: Api['getV1CrossHireRfqResponseItems'] = async (request: Types.GetV1CrossHireRfqResponseItemsRequest): Promise<Types.GetV1CrossHireRfqResponseItemsResponses> => {
  return await _getV1CrossHireRfqResponseItems(baseUrl, request)
}
const _putV1CrossHireRfqId = async (url: string, request: Types.PutV1CrossHireRfqIdRequest): Promise<Types.PutV1CrossHireRfqIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireRfqId: Api['putV1CrossHireRfqId'] = async (request: Types.PutV1CrossHireRfqIdRequest): Promise<Types.PutV1CrossHireRfqIdResponses> => {
  return await _putV1CrossHireRfqId(baseUrl, request)
}
const _getV1CrossHireRfqId = async (url: string, request: Types.GetV1CrossHireRfqIdRequest): Promise<Types.GetV1CrossHireRfqIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRfqIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRfqId: Api['getV1CrossHireRfqId'] = async (request: Types.GetV1CrossHireRfqIdRequest): Promise<Types.GetV1CrossHireRfqIdResponses> => {
  return await _getV1CrossHireRfqId(baseUrl, request)
}
const _deleteV1CrossHireRfqId = async (url: string, request: Types.DeleteV1CrossHireRfqIdRequest): Promise<Types.DeleteV1CrossHireRfqIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireRfqId: Api['deleteV1CrossHireRfqId'] = async (request: Types.DeleteV1CrossHireRfqIdRequest): Promise<Types.DeleteV1CrossHireRfqIdResponses> => {
  return await _deleteV1CrossHireRfqId(baseUrl, request)
}
const _patchV1CrossHireRfqIdStatus = async (url: string, request: Types.PatchV1CrossHireRfqIdStatusRequest): Promise<Types.PatchV1CrossHireRfqIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1CrossHireRfqIdStatus: Api['patchV1CrossHireRfqIdStatus'] = async (request: Types.PatchV1CrossHireRfqIdStatusRequest): Promise<Types.PatchV1CrossHireRfqIdStatusResponses> => {
  return await _patchV1CrossHireRfqIdStatus(baseUrl, request)
}
const _postV1CrossHireRfqItems = async (url: string, request: Types.PostV1CrossHireRfqItemsRequest): Promise<Types.PostV1CrossHireRfqItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireRfqItems: Api['postV1CrossHireRfqItems'] = async (request: Types.PostV1CrossHireRfqItemsRequest): Promise<Types.PostV1CrossHireRfqItemsResponses> => {
  return await _postV1CrossHireRfqItems(baseUrl, request)
}
const _getV1CrossHireRfqItemsId = async (url: string, request: Types.GetV1CrossHireRfqItemsIdRequest): Promise<Types.GetV1CrossHireRfqItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRfqItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRfqItemsId: Api['getV1CrossHireRfqItemsId'] = async (request: Types.GetV1CrossHireRfqItemsIdRequest): Promise<Types.GetV1CrossHireRfqItemsIdResponses> => {
  return await _getV1CrossHireRfqItemsId(baseUrl, request)
}
const _putV1CrossHireRfqItemsId = async (url: string, request: Types.PutV1CrossHireRfqItemsIdRequest): Promise<Types.PutV1CrossHireRfqItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireRfqItemsId: Api['putV1CrossHireRfqItemsId'] = async (request: Types.PutV1CrossHireRfqItemsIdRequest): Promise<Types.PutV1CrossHireRfqItemsIdResponses> => {
  return await _putV1CrossHireRfqItemsId(baseUrl, request)
}
const _deleteV1CrossHireRfqItemsId = async (url: string, request: Types.DeleteV1CrossHireRfqItemsIdRequest): Promise<Types.DeleteV1CrossHireRfqItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireRfqItemsId: Api['deleteV1CrossHireRfqItemsId'] = async (request: Types.DeleteV1CrossHireRfqItemsIdRequest): Promise<Types.DeleteV1CrossHireRfqItemsIdResponses> => {
  return await _deleteV1CrossHireRfqItemsId(baseUrl, request)
}
const _postV1CrossHireRfqTender = async (url: string, request: Types.PostV1CrossHireRfqTenderRequest): Promise<Types.PostV1CrossHireRfqTenderResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/tender/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireRfqTender: Api['postV1CrossHireRfqTender'] = async (request: Types.PostV1CrossHireRfqTenderRequest): Promise<Types.PostV1CrossHireRfqTenderResponses> => {
  return await _postV1CrossHireRfqTender(baseUrl, request)
}
const _deleteV1CrossHireRfqTenderId = async (url: string, request: Types.DeleteV1CrossHireRfqTenderIdRequest): Promise<Types.DeleteV1CrossHireRfqTenderIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/tender/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireRfqTenderId: Api['deleteV1CrossHireRfqTenderId'] = async (request: Types.DeleteV1CrossHireRfqTenderIdRequest): Promise<Types.DeleteV1CrossHireRfqTenderIdResponses> => {
  return await _deleteV1CrossHireRfqTenderId(baseUrl, request)
}
const _postV1CrossHireRfqIdResponse = async (url: string, request: Types.PostV1CrossHireRfqIdResponseRequest): Promise<Types.PostV1CrossHireRfqIdResponseResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/response`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireRfqIdResponse: Api['postV1CrossHireRfqIdResponse'] = async (request: Types.PostV1CrossHireRfqIdResponseRequest): Promise<Types.PostV1CrossHireRfqIdResponseResponses> => {
  return await _postV1CrossHireRfqIdResponse(baseUrl, request)
}
const _getV1CrossHireRfqIdResponse = async (url: string, request: Types.GetV1CrossHireRfqIdResponseRequest): Promise<Types.GetV1CrossHireRfqIdResponseResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRfqIdResponseRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/response?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRfqIdResponse: Api['getV1CrossHireRfqIdResponse'] = async (request: Types.GetV1CrossHireRfqIdResponseRequest): Promise<Types.GetV1CrossHireRfqIdResponseResponses> => {
  return await _getV1CrossHireRfqIdResponse(baseUrl, request)
}
const _postV1CrossHireRfqIdResponseSaveDraft = async (url: string, request: Types.PostV1CrossHireRfqIdResponseSaveDraftRequest): Promise<Types.PostV1CrossHireRfqIdResponseSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/response/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireRfqIdResponseSaveDraft: Api['postV1CrossHireRfqIdResponseSaveDraft'] = async (request: Types.PostV1CrossHireRfqIdResponseSaveDraftRequest): Promise<Types.PostV1CrossHireRfqIdResponseSaveDraftResponses> => {
  return await _postV1CrossHireRfqIdResponseSaveDraft(baseUrl, request)
}
const _putV1CrossHireRfqIdResponseResponseId = async (url: string, request: Types.PutV1CrossHireRfqIdResponseResponseIdRequest): Promise<Types.PutV1CrossHireRfqIdResponseResponseIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/response/${request['responseId']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireRfqIdResponseResponseId: Api['putV1CrossHireRfqIdResponseResponseId'] = async (request: Types.PutV1CrossHireRfqIdResponseResponseIdRequest): Promise<Types.PutV1CrossHireRfqIdResponseResponseIdResponses> => {
  return await _putV1CrossHireRfqIdResponseResponseId(baseUrl, request)
}
const _getV1CrossHireRfqIdResponseResponseId = async (url: string, request: Types.GetV1CrossHireRfqIdResponseResponseIdRequest): Promise<Types.GetV1CrossHireRfqIdResponseResponseIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRfqIdResponseResponseIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/response/${request['responseId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRfqIdResponseResponseId: Api['getV1CrossHireRfqIdResponseResponseId'] = async (request: Types.GetV1CrossHireRfqIdResponseResponseIdRequest): Promise<Types.GetV1CrossHireRfqIdResponseResponseIdResponses> => {
  return await _getV1CrossHireRfqIdResponseResponseId(baseUrl, request)
}
const _deleteV1CrossHireRfqIdResponseResponseId = async (url: string, request: Types.DeleteV1CrossHireRfqIdResponseResponseIdRequest): Promise<Types.DeleteV1CrossHireRfqIdResponseResponseIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/response/${request['responseId']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireRfqIdResponseResponseId: Api['deleteV1CrossHireRfqIdResponseResponseId'] = async (request: Types.DeleteV1CrossHireRfqIdResponseResponseIdRequest): Promise<Types.DeleteV1CrossHireRfqIdResponseResponseIdResponses> => {
  return await _deleteV1CrossHireRfqIdResponseResponseId(baseUrl, request)
}
const _getV1CrossHireRfqIdResponseResponseIdItemsItemId = async (url: string, request: Types.GetV1CrossHireRfqIdResponseResponseIdItemsItemIdRequest): Promise<Types.GetV1CrossHireRfqIdResponseResponseIdItemsItemIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRfqIdResponseResponseIdItemsItemIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/response/${request['responseId']}/items/${request['itemId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRfqIdResponseResponseIdItemsItemId: Api['getV1CrossHireRfqIdResponseResponseIdItemsItemId'] = async (request: Types.GetV1CrossHireRfqIdResponseResponseIdItemsItemIdRequest): Promise<Types.GetV1CrossHireRfqIdResponseResponseIdItemsItemIdResponses> => {
  return await _getV1CrossHireRfqIdResponseResponseIdItemsItemId(baseUrl, request)
}
const _putV1CrossHireRfqIdResponseResponseIdItemsItemId = async (url: string, request: Types.PutV1CrossHireRfqIdResponseResponseIdItemsItemIdRequest): Promise<Types.PutV1CrossHireRfqIdResponseResponseIdItemsItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/response/${request['responseId']}/items/${request['itemId']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireRfqIdResponseResponseIdItemsItemId: Api['putV1CrossHireRfqIdResponseResponseIdItemsItemId'] = async (request: Types.PutV1CrossHireRfqIdResponseResponseIdItemsItemIdRequest): Promise<Types.PutV1CrossHireRfqIdResponseResponseIdItemsItemIdResponses> => {
  return await _putV1CrossHireRfqIdResponseResponseIdItemsItemId(baseUrl, request)
}
const _deleteV1CrossHireRfqIdResponseResponseIdItemsItemId = async (url: string, request: Types.DeleteV1CrossHireRfqIdResponseResponseIdItemsItemIdRequest): Promise<Types.DeleteV1CrossHireRfqIdResponseResponseIdItemsItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/response/${request['responseId']}/items/${request['itemId']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireRfqIdResponseResponseIdItemsItemId: Api['deleteV1CrossHireRfqIdResponseResponseIdItemsItemId'] = async (request: Types.DeleteV1CrossHireRfqIdResponseResponseIdItemsItemIdRequest): Promise<Types.DeleteV1CrossHireRfqIdResponseResponseIdItemsItemIdResponses> => {
  return await _deleteV1CrossHireRfqIdResponseResponseIdItemsItemId(baseUrl, request)
}
const _postV1CrossHireRfqIdAnalyze = async (url: string, request: Types.PostV1CrossHireRfqIdAnalyzeRequest): Promise<Types.PostV1CrossHireRfqIdAnalyzeResponses> => {
  const queryParameters: (keyof Types.PostV1CrossHireRfqIdAnalyzeRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/analyze?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireRfqIdAnalyze: Api['postV1CrossHireRfqIdAnalyze'] = async (request: Types.PostV1CrossHireRfqIdAnalyzeRequest): Promise<Types.PostV1CrossHireRfqIdAnalyzeResponses> => {
  return await _postV1CrossHireRfqIdAnalyze(baseUrl, request)
}
const _postV1CrossHireRfqIdAnalyzePreviousPrices = async (url: string, request: Types.PostV1CrossHireRfqIdAnalyzePreviousPricesRequest): Promise<Types.PostV1CrossHireRfqIdAnalyzePreviousPricesResponses> => {
  const queryParameters: (keyof Types.PostV1CrossHireRfqIdAnalyzePreviousPricesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/analyze/previous-prices?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireRfqIdAnalyzePreviousPrices: Api['postV1CrossHireRfqIdAnalyzePreviousPrices'] = async (request: Types.PostV1CrossHireRfqIdAnalyzePreviousPricesRequest): Promise<Types.PostV1CrossHireRfqIdAnalyzePreviousPricesResponses> => {
  return await _postV1CrossHireRfqIdAnalyzePreviousPrices(baseUrl, request)
}
const _postV1CrossHireRfqIdAward = async (url: string, request: Types.PostV1CrossHireRfqIdAwardRequest): Promise<Types.PostV1CrossHireRfqIdAwardResponses> => {
  const queryParameters: (keyof Types.PostV1CrossHireRfqIdAwardRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/award?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireRfqIdAward: Api['postV1CrossHireRfqIdAward'] = async (request: Types.PostV1CrossHireRfqIdAwardRequest): Promise<Types.PostV1CrossHireRfqIdAwardResponses> => {
  return await _postV1CrossHireRfqIdAward(baseUrl, request)
}
const _getV1CrossHireRfqIdSendEmail = async (url: string, request: Types.GetV1CrossHireRfqIdSendEmailRequest): Promise<Types.GetV1CrossHireRfqIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRfqIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRfqIdSendEmail: Api['getV1CrossHireRfqIdSendEmail'] = async (request: Types.GetV1CrossHireRfqIdSendEmailRequest): Promise<Types.GetV1CrossHireRfqIdSendEmailResponses> => {
  return await _getV1CrossHireRfqIdSendEmail(baseUrl, request)
}
const _getV1CrossHireRfqIdDownload = async (url: string, request: Types.GetV1CrossHireRfqIdDownloadRequest): Promise<Types.GetV1CrossHireRfqIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRfqIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRfqIdDownload: Api['getV1CrossHireRfqIdDownload'] = async (request: Types.GetV1CrossHireRfqIdDownloadRequest): Promise<Types.GetV1CrossHireRfqIdDownloadResponses> => {
  return await _getV1CrossHireRfqIdDownload(baseUrl, request)
}
const _getV1CrossHireRfqIdProvidePoDetails = async (url: string, request: Types.GetV1CrossHireRfqIdProvidePoDetailsRequest): Promise<Types.GetV1CrossHireRfqIdProvidePoDetailsResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRfqIdProvidePoDetailsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/provide-po-details?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRfqIdProvidePoDetails: Api['getV1CrossHireRfqIdProvidePoDetails'] = async (request: Types.GetV1CrossHireRfqIdProvidePoDetailsRequest): Promise<Types.GetV1CrossHireRfqIdProvidePoDetailsResponses> => {
  return await _getV1CrossHireRfqIdProvidePoDetails(baseUrl, request)
}
const _getV1CrossHireRfqGenerateExcel = async (url: string, request: Types.GetV1CrossHireRfqGenerateExcelRequest): Promise<Types.GetV1CrossHireRfqGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRfqGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRfqGenerateExcel: Api['getV1CrossHireRfqGenerateExcel'] = async (request: Types.GetV1CrossHireRfqGenerateExcelRequest): Promise<Types.GetV1CrossHireRfqGenerateExcelResponses> => {
  return await _getV1CrossHireRfqGenerateExcel(baseUrl, request)
}
const _postV1CrossHireRfqImport = async (url: string, request: Types.PostV1CrossHireRfqImportRequest): Promise<Types.PostV1CrossHireRfqImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireRfqImport: Api['postV1CrossHireRfqImport'] = async (request: Types.PostV1CrossHireRfqImportRequest): Promise<Types.PostV1CrossHireRfqImportResponses> => {
  return await _postV1CrossHireRfqImport(baseUrl, request)
}
const _getV1CrossHireRfqIdProvideAgreementDetails = async (url: string, request: Types.GetV1CrossHireRfqIdProvideAgreementDetailsRequest): Promise<Types.GetV1CrossHireRfqIdProvideAgreementDetailsResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireRfqIdProvideAgreementDetailsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-rfq/${request['id']}/provide-agreement-details?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireRfqIdProvideAgreementDetails: Api['getV1CrossHireRfqIdProvideAgreementDetails'] = async (request: Types.GetV1CrossHireRfqIdProvideAgreementDetailsRequest): Promise<Types.GetV1CrossHireRfqIdProvideAgreementDetailsResponses> => {
  return await _getV1CrossHireRfqIdProvideAgreementDetails(baseUrl, request)
}
const _postV1CrossHireOrders = async (url: string, request: Types.PostV1CrossHireOrdersRequest): Promise<Types.PostV1CrossHireOrdersResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrders: Api['postV1CrossHireOrders'] = async (request: Types.PostV1CrossHireOrdersRequest): Promise<Types.PostV1CrossHireOrdersResponses> => {
  return await _postV1CrossHireOrders(baseUrl, request)
}
const _getV1CrossHireOrders = async (url: string, request: Types.GetV1CrossHireOrdersRequest): Promise<Types.GetV1CrossHireOrdersResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrders: Api['getV1CrossHireOrders'] = async (request: Types.GetV1CrossHireOrdersRequest): Promise<Types.GetV1CrossHireOrdersResponses> => {
  return await _getV1CrossHireOrders(baseUrl, request)
}
const _postV1CrossHireOrdersSaveDraft = async (url: string, request: Types.PostV1CrossHireOrdersSaveDraftRequest): Promise<Types.PostV1CrossHireOrdersSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersSaveDraft: Api['postV1CrossHireOrdersSaveDraft'] = async (request: Types.PostV1CrossHireOrdersSaveDraftRequest): Promise<Types.PostV1CrossHireOrdersSaveDraftResponses> => {
  return await _postV1CrossHireOrdersSaveDraft(baseUrl, request)
}
const _getV1CrossHireOrdersId = async (url: string, request: Types.GetV1CrossHireOrdersIdRequest): Promise<Types.GetV1CrossHireOrdersIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersId: Api['getV1CrossHireOrdersId'] = async (request: Types.GetV1CrossHireOrdersIdRequest): Promise<Types.GetV1CrossHireOrdersIdResponses> => {
  return await _getV1CrossHireOrdersId(baseUrl, request)
}
const _putV1CrossHireOrdersId = async (url: string, request: Types.PutV1CrossHireOrdersIdRequest): Promise<Types.PutV1CrossHireOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireOrdersId: Api['putV1CrossHireOrdersId'] = async (request: Types.PutV1CrossHireOrdersIdRequest): Promise<Types.PutV1CrossHireOrdersIdResponses> => {
  return await _putV1CrossHireOrdersId(baseUrl, request)
}
const _deleteV1CrossHireOrdersId = async (url: string, request: Types.DeleteV1CrossHireOrdersIdRequest): Promise<Types.DeleteV1CrossHireOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireOrdersId: Api['deleteV1CrossHireOrdersId'] = async (request: Types.DeleteV1CrossHireOrdersIdRequest): Promise<Types.DeleteV1CrossHireOrdersIdResponses> => {
  return await _deleteV1CrossHireOrdersId(baseUrl, request)
}
const _patchV1CrossHireOrdersIdStatus = async (url: string, request: Types.PatchV1CrossHireOrdersIdStatusRequest): Promise<Types.PatchV1CrossHireOrdersIdStatusResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/status`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1CrossHireOrdersIdStatus: Api['patchV1CrossHireOrdersIdStatus'] = async (request: Types.PatchV1CrossHireOrdersIdStatusRequest): Promise<Types.PatchV1CrossHireOrdersIdStatusResponses> => {
  return await _patchV1CrossHireOrdersIdStatus(baseUrl, request)
}
const _postV1CrossHireOrdersAddApprover = async (url: string, request: Types.PostV1CrossHireOrdersAddApproverRequest): Promise<Types.PostV1CrossHireOrdersAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersAddApprover: Api['postV1CrossHireOrdersAddApprover'] = async (request: Types.PostV1CrossHireOrdersAddApproverRequest): Promise<Types.PostV1CrossHireOrdersAddApproverResponses> => {
  return await _postV1CrossHireOrdersAddApprover(baseUrl, request)
}
const _putV1CrossHireOrdersApprovalStatusId = async (url: string, request: Types.PutV1CrossHireOrdersApprovalStatusIdRequest): Promise<Types.PutV1CrossHireOrdersApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireOrdersApprovalStatusId: Api['putV1CrossHireOrdersApprovalStatusId'] = async (request: Types.PutV1CrossHireOrdersApprovalStatusIdRequest): Promise<Types.PutV1CrossHireOrdersApprovalStatusIdResponses> => {
  return await _putV1CrossHireOrdersApprovalStatusId(baseUrl, request)
}
const _postV1CrossHireOrdersItems = async (url: string, request: Types.PostV1CrossHireOrdersItemsRequest): Promise<Types.PostV1CrossHireOrdersItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersItems: Api['postV1CrossHireOrdersItems'] = async (request: Types.PostV1CrossHireOrdersItemsRequest): Promise<Types.PostV1CrossHireOrdersItemsResponses> => {
  return await _postV1CrossHireOrdersItems(baseUrl, request)
}
const _getV1CrossHireOrdersItemsId = async (url: string, request: Types.GetV1CrossHireOrdersItemsIdRequest): Promise<Types.GetV1CrossHireOrdersItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersItemsId: Api['getV1CrossHireOrdersItemsId'] = async (request: Types.GetV1CrossHireOrdersItemsIdRequest): Promise<Types.GetV1CrossHireOrdersItemsIdResponses> => {
  return await _getV1CrossHireOrdersItemsId(baseUrl, request)
}
const _putV1CrossHireOrdersItemsId = async (url: string, request: Types.PutV1CrossHireOrdersItemsIdRequest): Promise<Types.PutV1CrossHireOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireOrdersItemsId: Api['putV1CrossHireOrdersItemsId'] = async (request: Types.PutV1CrossHireOrdersItemsIdRequest): Promise<Types.PutV1CrossHireOrdersItemsIdResponses> => {
  return await _putV1CrossHireOrdersItemsId(baseUrl, request)
}
const _deleteV1CrossHireOrdersItemsId = async (url: string, request: Types.DeleteV1CrossHireOrdersItemsIdRequest): Promise<Types.DeleteV1CrossHireOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireOrdersItemsId: Api['deleteV1CrossHireOrdersItemsId'] = async (request: Types.DeleteV1CrossHireOrdersItemsIdRequest): Promise<Types.DeleteV1CrossHireOrdersItemsIdResponses> => {
  return await _deleteV1CrossHireOrdersItemsId(baseUrl, request)
}
const _postV1CrossHireOrdersExpenses = async (url: string, request: Types.PostV1CrossHireOrdersExpensesRequest): Promise<Types.PostV1CrossHireOrdersExpensesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/expenses/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersExpenses: Api['postV1CrossHireOrdersExpenses'] = async (request: Types.PostV1CrossHireOrdersExpensesRequest): Promise<Types.PostV1CrossHireOrdersExpensesResponses> => {
  return await _postV1CrossHireOrdersExpenses(baseUrl, request)
}
const _getV1CrossHireOrdersExpensesId = async (url: string, request: Types.GetV1CrossHireOrdersExpensesIdRequest): Promise<Types.GetV1CrossHireOrdersExpensesIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersExpensesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/expenses/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersExpensesId: Api['getV1CrossHireOrdersExpensesId'] = async (request: Types.GetV1CrossHireOrdersExpensesIdRequest): Promise<Types.GetV1CrossHireOrdersExpensesIdResponses> => {
  return await _getV1CrossHireOrdersExpensesId(baseUrl, request)
}
const _putV1CrossHireOrdersExpensesId = async (url: string, request: Types.PutV1CrossHireOrdersExpensesIdRequest): Promise<Types.PutV1CrossHireOrdersExpensesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/expenses/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireOrdersExpensesId: Api['putV1CrossHireOrdersExpensesId'] = async (request: Types.PutV1CrossHireOrdersExpensesIdRequest): Promise<Types.PutV1CrossHireOrdersExpensesIdResponses> => {
  return await _putV1CrossHireOrdersExpensesId(baseUrl, request)
}
const _deleteV1CrossHireOrdersExpensesId = async (url: string, request: Types.DeleteV1CrossHireOrdersExpensesIdRequest): Promise<Types.DeleteV1CrossHireOrdersExpensesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/expenses/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireOrdersExpensesId: Api['deleteV1CrossHireOrdersExpensesId'] = async (request: Types.DeleteV1CrossHireOrdersExpensesIdRequest): Promise<Types.DeleteV1CrossHireOrdersExpensesIdResponses> => {
  return await _deleteV1CrossHireOrdersExpensesId(baseUrl, request)
}
const _postV1CrossHireOrdersIdGrn = async (url: string, request: Types.PostV1CrossHireOrdersIdGrnRequest): Promise<Types.PostV1CrossHireOrdersIdGrnResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/grn`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersIdGrn: Api['postV1CrossHireOrdersIdGrn'] = async (request: Types.PostV1CrossHireOrdersIdGrnRequest): Promise<Types.PostV1CrossHireOrdersIdGrnResponses> => {
  return await _postV1CrossHireOrdersIdGrn(baseUrl, request)
}
const _getV1CrossHireOrdersIdGrn = async (url: string, request: Types.GetV1CrossHireOrdersIdGrnRequest): Promise<Types.GetV1CrossHireOrdersIdGrnResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersIdGrnRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/grn?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersIdGrn: Api['getV1CrossHireOrdersIdGrn'] = async (request: Types.GetV1CrossHireOrdersIdGrnRequest): Promise<Types.GetV1CrossHireOrdersIdGrnResponses> => {
  return await _getV1CrossHireOrdersIdGrn(baseUrl, request)
}
const _putV1CrossHireOrdersIdGrnGrnId = async (url: string, request: Types.PutV1CrossHireOrdersIdGrnGrnIdRequest): Promise<Types.PutV1CrossHireOrdersIdGrnGrnIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/grn/${request['grnId']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireOrdersIdGrnGrnId: Api['putV1CrossHireOrdersIdGrnGrnId'] = async (request: Types.PutV1CrossHireOrdersIdGrnGrnIdRequest): Promise<Types.PutV1CrossHireOrdersIdGrnGrnIdResponses> => {
  return await _putV1CrossHireOrdersIdGrnGrnId(baseUrl, request)
}
const _getV1CrossHireOrdersIdGrnGrnId = async (url: string, request: Types.GetV1CrossHireOrdersIdGrnGrnIdRequest): Promise<Types.GetV1CrossHireOrdersIdGrnGrnIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersIdGrnGrnIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/grn/${request['grnId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersIdGrnGrnId: Api['getV1CrossHireOrdersIdGrnGrnId'] = async (request: Types.GetV1CrossHireOrdersIdGrnGrnIdRequest): Promise<Types.GetV1CrossHireOrdersIdGrnGrnIdResponses> => {
  return await _getV1CrossHireOrdersIdGrnGrnId(baseUrl, request)
}
const _deleteV1CrossHireOrdersIdGrnGrnId = async (url: string, request: Types.DeleteV1CrossHireOrdersIdGrnGrnIdRequest): Promise<Types.DeleteV1CrossHireOrdersIdGrnGrnIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/grn/${request['grnId']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireOrdersIdGrnGrnId: Api['deleteV1CrossHireOrdersIdGrnGrnId'] = async (request: Types.DeleteV1CrossHireOrdersIdGrnGrnIdRequest): Promise<Types.DeleteV1CrossHireOrdersIdGrnGrnIdResponses> => {
  return await _deleteV1CrossHireOrdersIdGrnGrnId(baseUrl, request)
}
const _getV1CrossHireOrdersIdGrnGrnIdDownload = async (url: string, request: Types.GetV1CrossHireOrdersIdGrnGrnIdDownloadRequest): Promise<Types.GetV1CrossHireOrdersIdGrnGrnIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersIdGrnGrnIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/grn/${request['grnId']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersIdGrnGrnIdDownload: Api['getV1CrossHireOrdersIdGrnGrnIdDownload'] = async (request: Types.GetV1CrossHireOrdersIdGrnGrnIdDownloadRequest): Promise<Types.GetV1CrossHireOrdersIdGrnGrnIdDownloadResponses> => {
  return await _getV1CrossHireOrdersIdGrnGrnIdDownload(baseUrl, request)
}
const _getV1CrossHireOrdersIdGrnGrnIdItemItemId = async (url: string, request: Types.GetV1CrossHireOrdersIdGrnGrnIdItemItemIdRequest): Promise<Types.GetV1CrossHireOrdersIdGrnGrnIdItemItemIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersIdGrnGrnIdItemItemIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/grn/${request['grnId']}/item/${request['itemId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersIdGrnGrnIdItemItemId: Api['getV1CrossHireOrdersIdGrnGrnIdItemItemId'] = async (request: Types.GetV1CrossHireOrdersIdGrnGrnIdItemItemIdRequest): Promise<Types.GetV1CrossHireOrdersIdGrnGrnIdItemItemIdResponses> => {
  return await _getV1CrossHireOrdersIdGrnGrnIdItemItemId(baseUrl, request)
}
const _putV1CrossHireOrdersIdGrnGrnIdItemItemId = async (url: string, request: Types.PutV1CrossHireOrdersIdGrnGrnIdItemItemIdRequest): Promise<Types.PutV1CrossHireOrdersIdGrnGrnIdItemItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/grn/${request['grnId']}/item/${request['itemId']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireOrdersIdGrnGrnIdItemItemId: Api['putV1CrossHireOrdersIdGrnGrnIdItemItemId'] = async (request: Types.PutV1CrossHireOrdersIdGrnGrnIdItemItemIdRequest): Promise<Types.PutV1CrossHireOrdersIdGrnGrnIdItemItemIdResponses> => {
  return await _putV1CrossHireOrdersIdGrnGrnIdItemItemId(baseUrl, request)
}
const _deleteV1CrossHireOrdersIdGrnGrnIdItemItemId = async (url: string, request: Types.DeleteV1CrossHireOrdersIdGrnGrnIdItemItemIdRequest): Promise<Types.DeleteV1CrossHireOrdersIdGrnGrnIdItemItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/grn/${request['grnId']}/item/${request['itemId']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireOrdersIdGrnGrnIdItemItemId: Api['deleteV1CrossHireOrdersIdGrnGrnIdItemItemId'] = async (request: Types.DeleteV1CrossHireOrdersIdGrnGrnIdItemItemIdRequest): Promise<Types.DeleteV1CrossHireOrdersIdGrnGrnIdItemItemIdResponses> => {
  return await _deleteV1CrossHireOrdersIdGrnGrnIdItemItemId(baseUrl, request)
}
const _postV1CrossHireOrdersIdGrnGrnIdItemsItemIdTracking = async (url: string, request: Types.PostV1CrossHireOrdersIdGrnGrnIdItemsItemIdTrackingRequest): Promise<Types.PostV1CrossHireOrdersIdGrnGrnIdItemsItemIdTrackingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/grn/${request['grnId']}/items/${request['itemId']}/tracking`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersIdGrnGrnIdItemsItemIdTracking: Api['postV1CrossHireOrdersIdGrnGrnIdItemsItemIdTracking'] = async (request: Types.PostV1CrossHireOrdersIdGrnGrnIdItemsItemIdTrackingRequest): Promise<Types.PostV1CrossHireOrdersIdGrnGrnIdItemsItemIdTrackingResponses> => {
  return await _postV1CrossHireOrdersIdGrnGrnIdItemsItemIdTracking(baseUrl, request)
}
const _postV1CrossHireOrdersIdGrnGrnIdInventoryAdjustment = async (url: string, request: Types.PostV1CrossHireOrdersIdGrnGrnIdInventoryAdjustmentRequest): Promise<Types.PostV1CrossHireOrdersIdGrnGrnIdInventoryAdjustmentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/grn/${request['grnId']}/inventory-adjustment`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersIdGrnGrnIdInventoryAdjustment: Api['postV1CrossHireOrdersIdGrnGrnIdInventoryAdjustment'] = async (request: Types.PostV1CrossHireOrdersIdGrnGrnIdInventoryAdjustmentRequest): Promise<Types.PostV1CrossHireOrdersIdGrnGrnIdInventoryAdjustmentResponses> => {
  return await _postV1CrossHireOrdersIdGrnGrnIdInventoryAdjustment(baseUrl, request)
}
const _getV1CrossHireOrdersIdCreateBill = async (url: string, request: Types.GetV1CrossHireOrdersIdCreateBillRequest): Promise<Types.GetV1CrossHireOrdersIdCreateBillResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersIdCreateBillRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/create-bill?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersIdCreateBill: Api['getV1CrossHireOrdersIdCreateBill'] = async (request: Types.GetV1CrossHireOrdersIdCreateBillRequest): Promise<Types.GetV1CrossHireOrdersIdCreateBillResponses> => {
  return await _getV1CrossHireOrdersIdCreateBill(baseUrl, request)
}
const _getV1CrossHireOrdersReceipts = async (url: string, request: Types.GetV1CrossHireOrdersReceiptsRequest): Promise<Types.GetV1CrossHireOrdersReceiptsResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersReceiptsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/receipts?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersReceipts: Api['getV1CrossHireOrdersReceipts'] = async (request: Types.GetV1CrossHireOrdersReceiptsRequest): Promise<Types.GetV1CrossHireOrdersReceiptsResponses> => {
  return await _getV1CrossHireOrdersReceipts(baseUrl, request)
}
const _getV1CrossHireOrdersIdSendEmail = async (url: string, request: Types.GetV1CrossHireOrdersIdSendEmailRequest): Promise<Types.GetV1CrossHireOrdersIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersIdSendEmail: Api['getV1CrossHireOrdersIdSendEmail'] = async (request: Types.GetV1CrossHireOrdersIdSendEmailRequest): Promise<Types.GetV1CrossHireOrdersIdSendEmailResponses> => {
  return await _getV1CrossHireOrdersIdSendEmail(baseUrl, request)
}
const _getV1CrossHireOrdersIdDownload = async (url: string, request: Types.GetV1CrossHireOrdersIdDownloadRequest): Promise<Types.GetV1CrossHireOrdersIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersIdDownload: Api['getV1CrossHireOrdersIdDownload'] = async (request: Types.GetV1CrossHireOrdersIdDownloadRequest): Promise<Types.GetV1CrossHireOrdersIdDownloadResponses> => {
  return await _getV1CrossHireOrdersIdDownload(baseUrl, request)
}
const _getV1CrossHireOrdersOrderIdGrnIdScrap = async (url: string, request: Types.GetV1CrossHireOrdersOrderIdGrnIdScrapRequest): Promise<Types.GetV1CrossHireOrdersOrderIdGrnIdScrapResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersOrderIdGrnIdScrapRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['orderId']}/grn/${request['id']}/scrap?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersOrderIdGrnIdScrap: Api['getV1CrossHireOrdersOrderIdGrnIdScrap'] = async (request: Types.GetV1CrossHireOrdersOrderIdGrnIdScrapRequest): Promise<Types.GetV1CrossHireOrdersOrderIdGrnIdScrapResponses> => {
  return await _getV1CrossHireOrdersOrderIdGrnIdScrap(baseUrl, request)
}
const _getV1CrossHireOrdersGenerateExcel = async (url: string, request: Types.GetV1CrossHireOrdersGenerateExcelRequest): Promise<Types.GetV1CrossHireOrdersGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersGenerateExcel: Api['getV1CrossHireOrdersGenerateExcel'] = async (request: Types.GetV1CrossHireOrdersGenerateExcelRequest): Promise<Types.GetV1CrossHireOrdersGenerateExcelResponses> => {
  return await _getV1CrossHireOrdersGenerateExcel(baseUrl, request)
}
const _postV1CrossHireOrdersImport = async (url: string, request: Types.PostV1CrossHireOrdersImportRequest): Promise<Types.PostV1CrossHireOrdersImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersImport: Api['postV1CrossHireOrdersImport'] = async (request: Types.PostV1CrossHireOrdersImportRequest): Promise<Types.PostV1CrossHireOrdersImportResponses> => {
  return await _postV1CrossHireOrdersImport(baseUrl, request)
}
const _postV1CrossHireOrdersDeliveryOrder = async (url: string, request: Types.PostV1CrossHireOrdersDeliveryOrderRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersDeliveryOrder: Api['postV1CrossHireOrdersDeliveryOrder'] = async (request: Types.PostV1CrossHireOrdersDeliveryOrderRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderResponses> => {
  return await _postV1CrossHireOrdersDeliveryOrder(baseUrl, request)
}
const _postV1CrossHireOrdersDeliveryOrderSaveDraft = async (url: string, request: Types.PostV1CrossHireOrdersDeliveryOrderSaveDraftRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersDeliveryOrderSaveDraft: Api['postV1CrossHireOrdersDeliveryOrderSaveDraft'] = async (request: Types.PostV1CrossHireOrdersDeliveryOrderSaveDraftRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderSaveDraftResponses> => {
  return await _postV1CrossHireOrdersDeliveryOrderSaveDraft(baseUrl, request)
}
const _getV1CrossHireOrdersDeliveryOrder = async (url: string, request: Types.GetV1CrossHireOrdersDeliveryOrderRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersDeliveryOrderRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersDeliveryOrder: Api['getV1CrossHireOrdersDeliveryOrder'] = async (request: Types.GetV1CrossHireOrdersDeliveryOrderRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderResponses> => {
  return await _getV1CrossHireOrdersDeliveryOrder(baseUrl, request)
}
const _getV1CrossHireOrdersDeliveryOrderId = async (url: string, request: Types.GetV1CrossHireOrdersDeliveryOrderIdRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersDeliveryOrderIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersDeliveryOrderId: Api['getV1CrossHireOrdersDeliveryOrderId'] = async (request: Types.GetV1CrossHireOrdersDeliveryOrderIdRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdResponses> => {
  return await _getV1CrossHireOrdersDeliveryOrderId(baseUrl, request)
}
const _deleteV1CrossHireOrdersDeliveryOrderId = async (url: string, request: Types.DeleteV1CrossHireOrdersDeliveryOrderIdRequest): Promise<Types.DeleteV1CrossHireOrdersDeliveryOrderIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireOrdersDeliveryOrderId: Api['deleteV1CrossHireOrdersDeliveryOrderId'] = async (request: Types.DeleteV1CrossHireOrdersDeliveryOrderIdRequest): Promise<Types.DeleteV1CrossHireOrdersDeliveryOrderIdResponses> => {
  return await _deleteV1CrossHireOrdersDeliveryOrderId(baseUrl, request)
}
const _putV1CrossHireOrdersDeliveryOrderId = async (url: string, request: Types.PutV1CrossHireOrdersDeliveryOrderIdRequest): Promise<Types.PutV1CrossHireOrdersDeliveryOrderIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireOrdersDeliveryOrderId: Api['putV1CrossHireOrdersDeliveryOrderId'] = async (request: Types.PutV1CrossHireOrdersDeliveryOrderIdRequest): Promise<Types.PutV1CrossHireOrdersDeliveryOrderIdResponses> => {
  return await _putV1CrossHireOrdersDeliveryOrderId(baseUrl, request)
}
const _patchV1CrossHireOrdersDeliveryOrderStatusId = async (url: string, request: Types.PatchV1CrossHireOrdersDeliveryOrderStatusIdRequest): Promise<Types.PatchV1CrossHireOrdersDeliveryOrderStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1CrossHireOrdersDeliveryOrderStatusId: Api['patchV1CrossHireOrdersDeliveryOrderStatusId'] = async (request: Types.PatchV1CrossHireOrdersDeliveryOrderStatusIdRequest): Promise<Types.PatchV1CrossHireOrdersDeliveryOrderStatusIdResponses> => {
  return await _patchV1CrossHireOrdersDeliveryOrderStatusId(baseUrl, request)
}
const _getV1CrossHireOrdersDeliveryOrderItemsId = async (url: string, request: Types.GetV1CrossHireOrdersDeliveryOrderItemsIdRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersDeliveryOrderItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersDeliveryOrderItemsId: Api['getV1CrossHireOrdersDeliveryOrderItemsId'] = async (request: Types.GetV1CrossHireOrdersDeliveryOrderItemsIdRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderItemsIdResponses> => {
  return await _getV1CrossHireOrdersDeliveryOrderItemsId(baseUrl, request)
}
const _putV1CrossHireOrdersDeliveryOrderItemsId = async (url: string, request: Types.PutV1CrossHireOrdersDeliveryOrderItemsIdRequest): Promise<Types.PutV1CrossHireOrdersDeliveryOrderItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireOrdersDeliveryOrderItemsId: Api['putV1CrossHireOrdersDeliveryOrderItemsId'] = async (request: Types.PutV1CrossHireOrdersDeliveryOrderItemsIdRequest): Promise<Types.PutV1CrossHireOrdersDeliveryOrderItemsIdResponses> => {
  return await _putV1CrossHireOrdersDeliveryOrderItemsId(baseUrl, request)
}
const _deleteV1CrossHireOrdersDeliveryOrderItemsId = async (url: string, request: Types.DeleteV1CrossHireOrdersDeliveryOrderItemsIdRequest): Promise<Types.DeleteV1CrossHireOrdersDeliveryOrderItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireOrdersDeliveryOrderItemsId: Api['deleteV1CrossHireOrdersDeliveryOrderItemsId'] = async (request: Types.DeleteV1CrossHireOrdersDeliveryOrderItemsIdRequest): Promise<Types.DeleteV1CrossHireOrdersDeliveryOrderItemsIdResponses> => {
  return await _deleteV1CrossHireOrdersDeliveryOrderItemsId(baseUrl, request)
}
const _postV1CrossHireOrdersDeliveryOrderPackages = async (url: string, request: Types.PostV1CrossHireOrdersDeliveryOrderPackagesRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderPackagesResponses> => {
  const queryParameters: (keyof Types.PostV1CrossHireOrdersDeliveryOrderPackagesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/packages/?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersDeliveryOrderPackages: Api['postV1CrossHireOrdersDeliveryOrderPackages'] = async (request: Types.PostV1CrossHireOrdersDeliveryOrderPackagesRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderPackagesResponses> => {
  return await _postV1CrossHireOrdersDeliveryOrderPackages(baseUrl, request)
}
const _getV1CrossHireOrdersDeliveryOrderPackagesId = async (url: string, request: Types.GetV1CrossHireOrdersDeliveryOrderPackagesIdRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderPackagesIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersDeliveryOrderPackagesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/packages/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersDeliveryOrderPackagesId: Api['getV1CrossHireOrdersDeliveryOrderPackagesId'] = async (request: Types.GetV1CrossHireOrdersDeliveryOrderPackagesIdRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderPackagesIdResponses> => {
  return await _getV1CrossHireOrdersDeliveryOrderPackagesId(baseUrl, request)
}
const _putV1CrossHireOrdersDeliveryOrderPackagesId = async (url: string, request: Types.PutV1CrossHireOrdersDeliveryOrderPackagesIdRequest): Promise<Types.PutV1CrossHireOrdersDeliveryOrderPackagesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/packages/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireOrdersDeliveryOrderPackagesId: Api['putV1CrossHireOrdersDeliveryOrderPackagesId'] = async (request: Types.PutV1CrossHireOrdersDeliveryOrderPackagesIdRequest): Promise<Types.PutV1CrossHireOrdersDeliveryOrderPackagesIdResponses> => {
  return await _putV1CrossHireOrdersDeliveryOrderPackagesId(baseUrl, request)
}
const _deleteV1CrossHireOrdersDeliveryOrderPackagesId = async (url: string, request: Types.DeleteV1CrossHireOrdersDeliveryOrderPackagesIdRequest): Promise<Types.DeleteV1CrossHireOrdersDeliveryOrderPackagesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/packages/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireOrdersDeliveryOrderPackagesId: Api['deleteV1CrossHireOrdersDeliveryOrderPackagesId'] = async (request: Types.DeleteV1CrossHireOrdersDeliveryOrderPackagesIdRequest): Promise<Types.DeleteV1CrossHireOrdersDeliveryOrderPackagesIdResponses> => {
  return await _deleteV1CrossHireOrdersDeliveryOrderPackagesId(baseUrl, request)
}
const _getV1CrossHireOrdersDeliveryOrderIdPackages = async (url: string, request: Types.GetV1CrossHireOrdersDeliveryOrderIdPackagesRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdPackagesResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersDeliveryOrderIdPackagesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}/packages/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersDeliveryOrderIdPackages: Api['getV1CrossHireOrdersDeliveryOrderIdPackages'] = async (request: Types.GetV1CrossHireOrdersDeliveryOrderIdPackagesRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdPackagesResponses> => {
  return await _getV1CrossHireOrdersDeliveryOrderIdPackages(baseUrl, request)
}
const _postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackages = async (url: string, request: Types.PostV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesResponses> => {
  const queryParameters: (keyof Types.PostV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['deliveryId']}/items/${request['itemId']}/packages/?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackages: Api['postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackages'] = async (request: Types.PostV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesResponses> => {
  return await _postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackages(baseUrl, request)
}
const _getV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackages = async (url: string, request: Types.GetV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['deliveryId']}/items/${request['itemId']}/packages/`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackages: Api['getV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackages'] = async (request: Types.GetV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesResponses> => {
  return await _getV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackages(baseUrl, request)
}
const _deleteV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesId = async (url: string, request: Types.DeleteV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesIdRequest): Promise<Types.DeleteV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['deliveryId']}/items/${request['itemId']}/packages/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesId: Api['deleteV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesId'] = async (request: Types.DeleteV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesIdRequest): Promise<Types.DeleteV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesIdResponses> => {
  return await _deleteV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesId(baseUrl, request)
}
const _postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdTracking = async (url: string, request: Types.PostV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdTrackingRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdTrackingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['deliveryId']}/items/${request['itemId']}/tracking`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdTracking: Api['postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdTracking'] = async (request: Types.PostV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdTrackingRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdTrackingResponses> => {
  return await _postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdTracking(baseUrl, request)
}
const _postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdInventoryAdjustment = async (url: string, request: Types.PostV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdInventoryAdjustmentRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdInventoryAdjustmentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['deliveryId']}/items/${request['itemId']}/inventory-adjustment`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdInventoryAdjustment: Api['postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdInventoryAdjustment'] = async (request: Types.PostV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdInventoryAdjustmentRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdInventoryAdjustmentResponses> => {
  return await _postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdInventoryAdjustment(baseUrl, request)
}
const _getV1CrossHireOrdersDeliveryOrderIdCreateInvoice = async (url: string, request: Types.GetV1CrossHireOrdersDeliveryOrderIdCreateInvoiceRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdCreateInvoiceResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersDeliveryOrderIdCreateInvoiceRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}/create-invoice?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersDeliveryOrderIdCreateInvoice: Api['getV1CrossHireOrdersDeliveryOrderIdCreateInvoice'] = async (request: Types.GetV1CrossHireOrdersDeliveryOrderIdCreateInvoiceRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdCreateInvoiceResponses> => {
  return await _getV1CrossHireOrdersDeliveryOrderIdCreateInvoice(baseUrl, request)
}
const _getV1CrossHireOrdersDeliveryOrderIdSendEmail = async (url: string, request: Types.GetV1CrossHireOrdersDeliveryOrderIdSendEmailRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersDeliveryOrderIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersDeliveryOrderIdSendEmail: Api['getV1CrossHireOrdersDeliveryOrderIdSendEmail'] = async (request: Types.GetV1CrossHireOrdersDeliveryOrderIdSendEmailRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdSendEmailResponses> => {
  return await _getV1CrossHireOrdersDeliveryOrderIdSendEmail(baseUrl, request)
}
const _getV1CrossHireOrdersDeliveryOrderIdDownload = async (url: string, request: Types.GetV1CrossHireOrdersDeliveryOrderIdDownloadRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersDeliveryOrderIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersDeliveryOrderIdDownload: Api['getV1CrossHireOrdersDeliveryOrderIdDownload'] = async (request: Types.GetV1CrossHireOrdersDeliveryOrderIdDownloadRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdDownloadResponses> => {
  return await _getV1CrossHireOrdersDeliveryOrderIdDownload(baseUrl, request)
}
const _getV1CrossHireOrdersDeliveryOrderGenerateExcel = async (url: string, request: Types.GetV1CrossHireOrdersDeliveryOrderGenerateExcelRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersDeliveryOrderGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersDeliveryOrderGenerateExcel: Api['getV1CrossHireOrdersDeliveryOrderGenerateExcel'] = async (request: Types.GetV1CrossHireOrdersDeliveryOrderGenerateExcelRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderGenerateExcelResponses> => {
  return await _getV1CrossHireOrdersDeliveryOrderGenerateExcel(baseUrl, request)
}
const _getV1CrossHireOrdersIdMarkShippedRentalOrderId = async (url: string, request: Types.GetV1CrossHireOrdersIdMarkShippedRentalOrderIdRequest): Promise<Types.GetV1CrossHireOrdersIdMarkShippedRentalOrderIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersIdMarkShippedRentalOrderIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/${request['id']}/mark-shipped/${request['rental_order_id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersIdMarkShippedRentalOrderId: Api['getV1CrossHireOrdersIdMarkShippedRentalOrderId'] = async (request: Types.GetV1CrossHireOrdersIdMarkShippedRentalOrderIdRequest): Promise<Types.GetV1CrossHireOrdersIdMarkShippedRentalOrderIdResponses> => {
  return await _getV1CrossHireOrdersIdMarkShippedRentalOrderId(baseUrl, request)
}
const _postV1CrossHireOrdersDeliveryOrderIdGrn = async (url: string, request: Types.PostV1CrossHireOrdersDeliveryOrderIdGrnRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderIdGrnResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}/grn`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersDeliveryOrderIdGrn: Api['postV1CrossHireOrdersDeliveryOrderIdGrn'] = async (request: Types.PostV1CrossHireOrdersDeliveryOrderIdGrnRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderIdGrnResponses> => {
  return await _postV1CrossHireOrdersDeliveryOrderIdGrn(baseUrl, request)
}
const _getV1CrossHireOrdersDeliveryOrderIdGrn = async (url: string, request: Types.GetV1CrossHireOrdersDeliveryOrderIdGrnRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdGrnResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersDeliveryOrderIdGrnRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}/grn?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersDeliveryOrderIdGrn: Api['getV1CrossHireOrdersDeliveryOrderIdGrn'] = async (request: Types.GetV1CrossHireOrdersDeliveryOrderIdGrnRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdGrnResponses> => {
  return await _getV1CrossHireOrdersDeliveryOrderIdGrn(baseUrl, request)
}
const _getV1CrossHireOrdersDeliveryOrderIdGrnGrnId = async (url: string, request: Types.GetV1CrossHireOrdersDeliveryOrderIdGrnGrnIdRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdGrnGrnIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersDeliveryOrderIdGrnGrnIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}/grn/${request['grnId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersDeliveryOrderIdGrnGrnId: Api['getV1CrossHireOrdersDeliveryOrderIdGrnGrnId'] = async (request: Types.GetV1CrossHireOrdersDeliveryOrderIdGrnGrnIdRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdGrnGrnIdResponses> => {
  return await _getV1CrossHireOrdersDeliveryOrderIdGrnGrnId(baseUrl, request)
}
const _deleteV1CrossHireOrdersDeliveryOrderIdGrnGrnId = async (url: string, request: Types.DeleteV1CrossHireOrdersDeliveryOrderIdGrnGrnIdRequest): Promise<Types.DeleteV1CrossHireOrdersDeliveryOrderIdGrnGrnIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}/grn/${request['grnId']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireOrdersDeliveryOrderIdGrnGrnId: Api['deleteV1CrossHireOrdersDeliveryOrderIdGrnGrnId'] = async (request: Types.DeleteV1CrossHireOrdersDeliveryOrderIdGrnGrnIdRequest): Promise<Types.DeleteV1CrossHireOrdersDeliveryOrderIdGrnGrnIdResponses> => {
  return await _deleteV1CrossHireOrdersDeliveryOrderIdGrnGrnId(baseUrl, request)
}
const _putV1CrossHireOrdersDeliveryOrderIdGrnGrnId = async (url: string, request: Types.PutV1CrossHireOrdersDeliveryOrderIdGrnGrnIdRequest): Promise<Types.PutV1CrossHireOrdersDeliveryOrderIdGrnGrnIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}/grn/${request['grnId']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireOrdersDeliveryOrderIdGrnGrnId: Api['putV1CrossHireOrdersDeliveryOrderIdGrnGrnId'] = async (request: Types.PutV1CrossHireOrdersDeliveryOrderIdGrnGrnIdRequest): Promise<Types.PutV1CrossHireOrdersDeliveryOrderIdGrnGrnIdResponses> => {
  return await _putV1CrossHireOrdersDeliveryOrderIdGrnGrnId(baseUrl, request)
}
const _getV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId = async (url: string, request: Types.GetV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdResponses> => {
  const queryParameters: (keyof Types.GetV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}/grn/${request['grnId']}/items/${request['itemId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId: Api['getV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId'] = async (request: Types.GetV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdRequest): Promise<Types.GetV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdResponses> => {
  return await _getV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId(baseUrl, request)
}
const _putV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId = async (url: string, request: Types.PutV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdRequest): Promise<Types.PutV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}/grn/${request['grnId']}/items/${request['itemId']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId: Api['putV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId'] = async (request: Types.PutV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdRequest): Promise<Types.PutV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdResponses> => {
  return await _putV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId(baseUrl, request)
}
const _deleteV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId = async (url: string, request: Types.DeleteV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdRequest): Promise<Types.DeleteV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}/grn/${request['grnId']}/items/${request['itemId']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId: Api['deleteV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId'] = async (request: Types.DeleteV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdRequest): Promise<Types.DeleteV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdResponses> => {
  return await _deleteV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId(baseUrl, request)
}
const _postV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdTracking = async (url: string, request: Types.PostV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdTrackingRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdTrackingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}/grn/${request['grnId']}/items/${request['itemId']}/tracking`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdTracking: Api['postV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdTracking'] = async (request: Types.PostV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdTrackingRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdTrackingResponses> => {
  return await _postV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdTracking(baseUrl, request)
}
const _postV1CrossHireOrdersDeliveryOrderIdGrnGrnIdInventoryAdjustment = async (url: string, request: Types.PostV1CrossHireOrdersDeliveryOrderIdGrnGrnIdInventoryAdjustmentRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderIdGrnGrnIdInventoryAdjustmentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/cross-hire-orders/delivery-order/${request['id']}/grn/${request['grnId']}/inventory-adjustment`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CrossHireOrdersDeliveryOrderIdGrnGrnIdInventoryAdjustment: Api['postV1CrossHireOrdersDeliveryOrderIdGrnGrnIdInventoryAdjustment'] = async (request: Types.PostV1CrossHireOrdersDeliveryOrderIdGrnGrnIdInventoryAdjustmentRequest): Promise<Types.PostV1CrossHireOrdersDeliveryOrderIdGrnGrnIdInventoryAdjustmentResponses> => {
  return await _postV1CrossHireOrdersDeliveryOrderIdGrnGrnIdInventoryAdjustment(baseUrl, request)
}
const _getV1InvoiceRentalJobs = async (url: string, request: Types.GetV1InvoiceRentalJobsRequest): Promise<Types.GetV1InvoiceRentalJobsResponses> => {
  const queryParameters: (keyof Types.GetV1InvoiceRentalJobsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/invoice-rental-jobs/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InvoiceRentalJobs: Api['getV1InvoiceRentalJobs'] = async (request: Types.GetV1InvoiceRentalJobsRequest): Promise<Types.GetV1InvoiceRentalJobsResponses> => {
  return await _getV1InvoiceRentalJobs(baseUrl, request)
}
const _getV1InvoiceRentalJobsId = async (url: string, request: Types.GetV1InvoiceRentalJobsIdRequest): Promise<Types.GetV1InvoiceRentalJobsIdResponses> => {
  const queryParameters: (keyof Types.GetV1InvoiceRentalJobsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/invoice-rental-jobs/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InvoiceRentalJobsId: Api['getV1InvoiceRentalJobsId'] = async (request: Types.GetV1InvoiceRentalJobsIdRequest): Promise<Types.GetV1InvoiceRentalJobsIdResponses> => {
  return await _getV1InvoiceRentalJobsId(baseUrl, request)
}
const _getV1InvoiceRentalJobsIdRetryOrderId = async (url: string, request: Types.GetV1InvoiceRentalJobsIdRetryOrderIdRequest): Promise<Types.GetV1InvoiceRentalJobsIdRetryOrderIdResponses> => {
  const queryParameters: (keyof Types.GetV1InvoiceRentalJobsIdRetryOrderIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/invoice-rental-jobs/${request['id']}/retry/${request['order_id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1InvoiceRentalJobsIdRetryOrderId: Api['getV1InvoiceRentalJobsIdRetryOrderId'] = async (request: Types.GetV1InvoiceRentalJobsIdRetryOrderIdRequest): Promise<Types.GetV1InvoiceRentalJobsIdRetryOrderIdResponses> => {
  return await _getV1InvoiceRentalJobsIdRetryOrderId(baseUrl, request)
}
const _postV1ProcessCrossHire = async (url: string, request: Types.PostV1ProcessCrossHireRequest): Promise<Types.PostV1ProcessCrossHireResponses> => {
  const queryParameters: (keyof Types.PostV1ProcessCrossHireRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/process-cross-hire/?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ProcessCrossHire: Api['postV1ProcessCrossHire'] = async (request: Types.PostV1ProcessCrossHireRequest): Promise<Types.PostV1ProcessCrossHireResponses> => {
  return await _postV1ProcessCrossHire(baseUrl, request)
}
const _postV1ProcessCrossHireSaveRfq = async (url: string, request: Types.PostV1ProcessCrossHireSaveRfqRequest): Promise<Types.PostV1ProcessCrossHireSaveRfqResponses> => {
  const queryParameters: (keyof Types.PostV1ProcessCrossHireSaveRfqRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/process-cross-hire/save-rfq?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ProcessCrossHireSaveRfq: Api['postV1ProcessCrossHireSaveRfq'] = async (request: Types.PostV1ProcessCrossHireSaveRfqRequest): Promise<Types.PostV1ProcessCrossHireSaveRfqResponses> => {
  return await _postV1ProcessCrossHireSaveRfq(baseUrl, request)
}
const _postV1ProcessCrossHireSaveOrders = async (url: string, request: Types.PostV1ProcessCrossHireSaveOrdersRequest): Promise<Types.PostV1ProcessCrossHireSaveOrdersResponses> => {
  const queryParameters: (keyof Types.PostV1ProcessCrossHireSaveOrdersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/process-cross-hire/save-orders?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ProcessCrossHireSaveOrders: Api['postV1ProcessCrossHireSaveOrders'] = async (request: Types.PostV1ProcessCrossHireSaveOrdersRequest): Promise<Types.PostV1ProcessCrossHireSaveOrdersResponses> => {
  return await _postV1ProcessCrossHireSaveOrders(baseUrl, request)
}
const _getV1ReplacementQuotationsId = async (url: string, request: Types.GetV1ReplacementQuotationsIdRequest): Promise<Types.GetV1ReplacementQuotationsIdResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementQuotationsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementQuotationsId: Api['getV1ReplacementQuotationsId'] = async (request: Types.GetV1ReplacementQuotationsIdRequest): Promise<Types.GetV1ReplacementQuotationsIdResponses> => {
  return await _getV1ReplacementQuotationsId(baseUrl, request)
}
const _putV1ReplacementQuotationsId = async (url: string, request: Types.PutV1ReplacementQuotationsIdRequest): Promise<Types.PutV1ReplacementQuotationsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ReplacementQuotationsId: Api['putV1ReplacementQuotationsId'] = async (request: Types.PutV1ReplacementQuotationsIdRequest): Promise<Types.PutV1ReplacementQuotationsIdResponses> => {
  return await _putV1ReplacementQuotationsId(baseUrl, request)
}
const _deleteV1ReplacementQuotationsId = async (url: string, request: Types.DeleteV1ReplacementQuotationsIdRequest): Promise<Types.DeleteV1ReplacementQuotationsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ReplacementQuotationsId: Api['deleteV1ReplacementQuotationsId'] = async (request: Types.DeleteV1ReplacementQuotationsIdRequest): Promise<Types.DeleteV1ReplacementQuotationsIdResponses> => {
  return await _deleteV1ReplacementQuotationsId(baseUrl, request)
}
const _getV1ReplacementQuotations = async (url: string, request: Types.GetV1ReplacementQuotationsRequest): Promise<Types.GetV1ReplacementQuotationsResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementQuotationsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementQuotations: Api['getV1ReplacementQuotations'] = async (request: Types.GetV1ReplacementQuotationsRequest): Promise<Types.GetV1ReplacementQuotationsResponses> => {
  return await _getV1ReplacementQuotations(baseUrl, request)
}
const _postV1ReplacementQuotationsSaveAsDraft = async (url: string, request: Types.PostV1ReplacementQuotationsSaveAsDraftRequest): Promise<Types.PostV1ReplacementQuotationsSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReplacementQuotationsSaveAsDraft: Api['postV1ReplacementQuotationsSaveAsDraft'] = async (request: Types.PostV1ReplacementQuotationsSaveAsDraftRequest): Promise<Types.PostV1ReplacementQuotationsSaveAsDraftResponses> => {
  return await _postV1ReplacementQuotationsSaveAsDraft(baseUrl, request)
}
const _patchV1ReplacementQuotationsStatusId = async (url: string, request: Types.PatchV1ReplacementQuotationsStatusIdRequest): Promise<Types.PatchV1ReplacementQuotationsStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1ReplacementQuotationsStatusId: Api['patchV1ReplacementQuotationsStatusId'] = async (request: Types.PatchV1ReplacementQuotationsStatusIdRequest): Promise<Types.PatchV1ReplacementQuotationsStatusIdResponses> => {
  return await _patchV1ReplacementQuotationsStatusId(baseUrl, request)
}
const _postV1ReplacementQuotationsPromotionCheck = async (url: string, request: Types.PostV1ReplacementQuotationsPromotionCheckRequest): Promise<Types.PostV1ReplacementQuotationsPromotionCheckResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/promotion/check`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReplacementQuotationsPromotionCheck: Api['postV1ReplacementQuotationsPromotionCheck'] = async (request: Types.PostV1ReplacementQuotationsPromotionCheckRequest): Promise<Types.PostV1ReplacementQuotationsPromotionCheckResponses> => {
  return await _postV1ReplacementQuotationsPromotionCheck(baseUrl, request)
}
const _postV1ReplacementQuotationsPromotionApply = async (url: string, request: Types.PostV1ReplacementQuotationsPromotionApplyRequest): Promise<Types.PostV1ReplacementQuotationsPromotionApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/promotion/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReplacementQuotationsPromotionApply: Api['postV1ReplacementQuotationsPromotionApply'] = async (request: Types.PostV1ReplacementQuotationsPromotionApplyRequest): Promise<Types.PostV1ReplacementQuotationsPromotionApplyResponses> => {
  return await _postV1ReplacementQuotationsPromotionApply(baseUrl, request)
}
const _postV1ReplacementQuotationsPromotionCouponApply = async (url: string, request: Types.PostV1ReplacementQuotationsPromotionCouponApplyRequest): Promise<Types.PostV1ReplacementQuotationsPromotionCouponApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/promotion/coupon/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReplacementQuotationsPromotionCouponApply: Api['postV1ReplacementQuotationsPromotionCouponApply'] = async (request: Types.PostV1ReplacementQuotationsPromotionCouponApplyRequest): Promise<Types.PostV1ReplacementQuotationsPromotionCouponApplyResponses> => {
  return await _postV1ReplacementQuotationsPromotionCouponApply(baseUrl, request)
}
const _postV1ReplacementQuotationsPromotionItemApply = async (url: string, request: Types.PostV1ReplacementQuotationsPromotionItemApplyRequest): Promise<Types.PostV1ReplacementQuotationsPromotionItemApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/promotion/item/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReplacementQuotationsPromotionItemApply: Api['postV1ReplacementQuotationsPromotionItemApply'] = async (request: Types.PostV1ReplacementQuotationsPromotionItemApplyRequest): Promise<Types.PostV1ReplacementQuotationsPromotionItemApplyResponses> => {
  return await _postV1ReplacementQuotationsPromotionItemApply(baseUrl, request)
}
const _deleteV1ReplacementQuotationsPromotionId = async (url: string, request: Types.DeleteV1ReplacementQuotationsPromotionIdRequest): Promise<Types.DeleteV1ReplacementQuotationsPromotionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/promotion/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ReplacementQuotationsPromotionId: Api['deleteV1ReplacementQuotationsPromotionId'] = async (request: Types.DeleteV1ReplacementQuotationsPromotionIdRequest): Promise<Types.DeleteV1ReplacementQuotationsPromotionIdResponses> => {
  return await _deleteV1ReplacementQuotationsPromotionId(baseUrl, request)
}
const _postV1ReplacementQuotationsItem = async (url: string, request: Types.PostV1ReplacementQuotationsItemRequest): Promise<Types.PostV1ReplacementQuotationsItemResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/item/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReplacementQuotationsItem: Api['postV1ReplacementQuotationsItem'] = async (request: Types.PostV1ReplacementQuotationsItemRequest): Promise<Types.PostV1ReplacementQuotationsItemResponses> => {
  return await _postV1ReplacementQuotationsItem(baseUrl, request)
}
const _getV1ReplacementQuotationsItem = async (url: string, request: Types.GetV1ReplacementQuotationsItemRequest): Promise<Types.GetV1ReplacementQuotationsItemResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementQuotationsItemRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/item/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementQuotationsItem: Api['getV1ReplacementQuotationsItem'] = async (request: Types.GetV1ReplacementQuotationsItemRequest): Promise<Types.GetV1ReplacementQuotationsItemResponses> => {
  return await _getV1ReplacementQuotationsItem(baseUrl, request)
}
const _getV1ReplacementQuotationsItemId = async (url: string, request: Types.GetV1ReplacementQuotationsItemIdRequest): Promise<Types.GetV1ReplacementQuotationsItemIdResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementQuotationsItemIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/item/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementQuotationsItemId: Api['getV1ReplacementQuotationsItemId'] = async (request: Types.GetV1ReplacementQuotationsItemIdRequest): Promise<Types.GetV1ReplacementQuotationsItemIdResponses> => {
  return await _getV1ReplacementQuotationsItemId(baseUrl, request)
}
const _deleteV1ReplacementQuotationsItemId = async (url: string, request: Types.DeleteV1ReplacementQuotationsItemIdRequest): Promise<Types.DeleteV1ReplacementQuotationsItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/item/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ReplacementQuotationsItemId: Api['deleteV1ReplacementQuotationsItemId'] = async (request: Types.DeleteV1ReplacementQuotationsItemIdRequest): Promise<Types.DeleteV1ReplacementQuotationsItemIdResponses> => {
  return await _deleteV1ReplacementQuotationsItemId(baseUrl, request)
}
const _putV1ReplacementQuotationsItemId = async (url: string, request: Types.PutV1ReplacementQuotationsItemIdRequest): Promise<Types.PutV1ReplacementQuotationsItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/item/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ReplacementQuotationsItemId: Api['putV1ReplacementQuotationsItemId'] = async (request: Types.PutV1ReplacementQuotationsItemIdRequest): Promise<Types.PutV1ReplacementQuotationsItemIdResponses> => {
  return await _putV1ReplacementQuotationsItemId(baseUrl, request)
}
const _getV1ReplacementQuotationsIdPromotions = async (url: string, request: Types.GetV1ReplacementQuotationsIdPromotionsRequest): Promise<Types.GetV1ReplacementQuotationsIdPromotionsResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementQuotationsIdPromotionsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/${request['id']}/promotions?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementQuotationsIdPromotions: Api['getV1ReplacementQuotationsIdPromotions'] = async (request: Types.GetV1ReplacementQuotationsIdPromotionsRequest): Promise<Types.GetV1ReplacementQuotationsIdPromotionsResponses> => {
  return await _getV1ReplacementQuotationsIdPromotions(baseUrl, request)
}
const _getV1ReplacementQuotationsIdDownload = async (url: string, request: Types.GetV1ReplacementQuotationsIdDownloadRequest): Promise<Types.GetV1ReplacementQuotationsIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementQuotationsIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementQuotationsIdDownload: Api['getV1ReplacementQuotationsIdDownload'] = async (request: Types.GetV1ReplacementQuotationsIdDownloadRequest): Promise<Types.GetV1ReplacementQuotationsIdDownloadResponses> => {
  return await _getV1ReplacementQuotationsIdDownload(baseUrl, request)
}
const _getV1ReplacementQuotationsIdSendEmail = async (url: string, request: Types.GetV1ReplacementQuotationsIdSendEmailRequest): Promise<Types.GetV1ReplacementQuotationsIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementQuotationsIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementQuotationsIdSendEmail: Api['getV1ReplacementQuotationsIdSendEmail'] = async (request: Types.GetV1ReplacementQuotationsIdSendEmailRequest): Promise<Types.GetV1ReplacementQuotationsIdSendEmailResponses> => {
  return await _getV1ReplacementQuotationsIdSendEmail(baseUrl, request)
}
const _getV1ReplacementQuotationsGenerateExcel = async (url: string, request: Types.GetV1ReplacementQuotationsGenerateExcelRequest): Promise<Types.GetV1ReplacementQuotationsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementQuotationsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementQuotationsGenerateExcel: Api['getV1ReplacementQuotationsGenerateExcel'] = async (request: Types.GetV1ReplacementQuotationsGenerateExcelRequest): Promise<Types.GetV1ReplacementQuotationsGenerateExcelResponses> => {
  return await _getV1ReplacementQuotationsGenerateExcel(baseUrl, request)
}
const _postV1ReplacementQuotationsImport = async (url: string, request: Types.PostV1ReplacementQuotationsImportRequest): Promise<Types.PostV1ReplacementQuotationsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReplacementQuotationsImport: Api['postV1ReplacementQuotationsImport'] = async (request: Types.PostV1ReplacementQuotationsImportRequest): Promise<Types.PostV1ReplacementQuotationsImportResponses> => {
  return await _postV1ReplacementQuotationsImport(baseUrl, request)
}
const _getV1ReplacementQuotationsOpportunityId = async (url: string, request: Types.GetV1ReplacementQuotationsOpportunityIdRequest): Promise<Types.GetV1ReplacementQuotationsOpportunityIdResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementQuotationsOpportunityIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/opportunity/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementQuotationsOpportunityId: Api['getV1ReplacementQuotationsOpportunityId'] = async (request: Types.GetV1ReplacementQuotationsOpportunityIdRequest): Promise<Types.GetV1ReplacementQuotationsOpportunityIdResponses> => {
  return await _getV1ReplacementQuotationsOpportunityId(baseUrl, request)
}
const _getV1ReplacementQuotationsFetchItemsPartyId = async (url: string, request: Types.GetV1ReplacementQuotationsFetchItemsPartyIdRequest): Promise<Types.GetV1ReplacementQuotationsFetchItemsPartyIdResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementQuotationsFetchItemsPartyIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/fetch-items/${request['partyId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementQuotationsFetchItemsPartyId: Api['getV1ReplacementQuotationsFetchItemsPartyId'] = async (request: Types.GetV1ReplacementQuotationsFetchItemsPartyIdRequest): Promise<Types.GetV1ReplacementQuotationsFetchItemsPartyIdResponses> => {
  return await _getV1ReplacementQuotationsFetchItemsPartyId(baseUrl, request)
}
const _getV1ReplacementQuotationsProvideRqDetailsGrnId = async (url: string, request: Types.GetV1ReplacementQuotationsProvideRqDetailsGrnIdRequest): Promise<Types.GetV1ReplacementQuotationsProvideRqDetailsGrnIdResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementQuotationsProvideRqDetailsGrnIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-quotations/provide-rq-details/${request['grnId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementQuotationsProvideRqDetailsGrnId: Api['getV1ReplacementQuotationsProvideRqDetailsGrnId'] = async (request: Types.GetV1ReplacementQuotationsProvideRqDetailsGrnIdRequest): Promise<Types.GetV1ReplacementQuotationsProvideRqDetailsGrnIdResponses> => {
  return await _getV1ReplacementQuotationsProvideRqDetailsGrnId(baseUrl, request)
}
const _postV1ReplacementOrders = async (url: string, request: Types.PostV1ReplacementOrdersRequest): Promise<Types.PostV1ReplacementOrdersResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReplacementOrders: Api['postV1ReplacementOrders'] = async (request: Types.PostV1ReplacementOrdersRequest): Promise<Types.PostV1ReplacementOrdersResponses> => {
  return await _postV1ReplacementOrders(baseUrl, request)
}
const _getV1ReplacementOrders = async (url: string, request: Types.GetV1ReplacementOrdersRequest): Promise<Types.GetV1ReplacementOrdersResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementOrdersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementOrders: Api['getV1ReplacementOrders'] = async (request: Types.GetV1ReplacementOrdersRequest): Promise<Types.GetV1ReplacementOrdersResponses> => {
  return await _getV1ReplacementOrders(baseUrl, request)
}
const _postV1ReplacementOrdersSaveDraft = async (url: string, request: Types.PostV1ReplacementOrdersSaveDraftRequest): Promise<Types.PostV1ReplacementOrdersSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReplacementOrdersSaveDraft: Api['postV1ReplacementOrdersSaveDraft'] = async (request: Types.PostV1ReplacementOrdersSaveDraftRequest): Promise<Types.PostV1ReplacementOrdersSaveDraftResponses> => {
  return await _postV1ReplacementOrdersSaveDraft(baseUrl, request)
}
const _getV1ReplacementOrdersId = async (url: string, request: Types.GetV1ReplacementOrdersIdRequest): Promise<Types.GetV1ReplacementOrdersIdResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementOrdersIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementOrdersId: Api['getV1ReplacementOrdersId'] = async (request: Types.GetV1ReplacementOrdersIdRequest): Promise<Types.GetV1ReplacementOrdersIdResponses> => {
  return await _getV1ReplacementOrdersId(baseUrl, request)
}
const _putV1ReplacementOrdersId = async (url: string, request: Types.PutV1ReplacementOrdersIdRequest): Promise<Types.PutV1ReplacementOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ReplacementOrdersId: Api['putV1ReplacementOrdersId'] = async (request: Types.PutV1ReplacementOrdersIdRequest): Promise<Types.PutV1ReplacementOrdersIdResponses> => {
  return await _putV1ReplacementOrdersId(baseUrl, request)
}
const _deleteV1ReplacementOrdersId = async (url: string, request: Types.DeleteV1ReplacementOrdersIdRequest): Promise<Types.DeleteV1ReplacementOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ReplacementOrdersId: Api['deleteV1ReplacementOrdersId'] = async (request: Types.DeleteV1ReplacementOrdersIdRequest): Promise<Types.DeleteV1ReplacementOrdersIdResponses> => {
  return await _deleteV1ReplacementOrdersId(baseUrl, request)
}
const _patchV1ReplacementOrdersStatusId = async (url: string, request: Types.PatchV1ReplacementOrdersStatusIdRequest): Promise<Types.PatchV1ReplacementOrdersStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1ReplacementOrdersStatusId: Api['patchV1ReplacementOrdersStatusId'] = async (request: Types.PatchV1ReplacementOrdersStatusIdRequest): Promise<Types.PatchV1ReplacementOrdersStatusIdResponses> => {
  return await _patchV1ReplacementOrdersStatusId(baseUrl, request)
}
const _postV1ReplacementOrdersAddApprover = async (url: string, request: Types.PostV1ReplacementOrdersAddApproverRequest): Promise<Types.PostV1ReplacementOrdersAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReplacementOrdersAddApprover: Api['postV1ReplacementOrdersAddApprover'] = async (request: Types.PostV1ReplacementOrdersAddApproverRequest): Promise<Types.PostV1ReplacementOrdersAddApproverResponses> => {
  return await _postV1ReplacementOrdersAddApprover(baseUrl, request)
}
const _putV1ReplacementOrdersApprovalStatusId = async (url: string, request: Types.PutV1ReplacementOrdersApprovalStatusIdRequest): Promise<Types.PutV1ReplacementOrdersApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ReplacementOrdersApprovalStatusId: Api['putV1ReplacementOrdersApprovalStatusId'] = async (request: Types.PutV1ReplacementOrdersApprovalStatusIdRequest): Promise<Types.PutV1ReplacementOrdersApprovalStatusIdResponses> => {
  return await _putV1ReplacementOrdersApprovalStatusId(baseUrl, request)
}
const _postV1ReplacementOrdersItems = async (url: string, request: Types.PostV1ReplacementOrdersItemsRequest): Promise<Types.PostV1ReplacementOrdersItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReplacementOrdersItems: Api['postV1ReplacementOrdersItems'] = async (request: Types.PostV1ReplacementOrdersItemsRequest): Promise<Types.PostV1ReplacementOrdersItemsResponses> => {
  return await _postV1ReplacementOrdersItems(baseUrl, request)
}
const _getV1ReplacementOrdersItemsId = async (url: string, request: Types.GetV1ReplacementOrdersItemsIdRequest): Promise<Types.GetV1ReplacementOrdersItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementOrdersItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementOrdersItemsId: Api['getV1ReplacementOrdersItemsId'] = async (request: Types.GetV1ReplacementOrdersItemsIdRequest): Promise<Types.GetV1ReplacementOrdersItemsIdResponses> => {
  return await _getV1ReplacementOrdersItemsId(baseUrl, request)
}
const _putV1ReplacementOrdersItemsId = async (url: string, request: Types.PutV1ReplacementOrdersItemsIdRequest): Promise<Types.PutV1ReplacementOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ReplacementOrdersItemsId: Api['putV1ReplacementOrdersItemsId'] = async (request: Types.PutV1ReplacementOrdersItemsIdRequest): Promise<Types.PutV1ReplacementOrdersItemsIdResponses> => {
  return await _putV1ReplacementOrdersItemsId(baseUrl, request)
}
const _deleteV1ReplacementOrdersItemsId = async (url: string, request: Types.DeleteV1ReplacementOrdersItemsIdRequest): Promise<Types.DeleteV1ReplacementOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ReplacementOrdersItemsId: Api['deleteV1ReplacementOrdersItemsId'] = async (request: Types.DeleteV1ReplacementOrdersItemsIdRequest): Promise<Types.DeleteV1ReplacementOrdersItemsIdResponses> => {
  return await _deleteV1ReplacementOrdersItemsId(baseUrl, request)
}
const _postV1ReplacementOrdersPromotionCheck = async (url: string, request: Types.PostV1ReplacementOrdersPromotionCheckRequest): Promise<Types.PostV1ReplacementOrdersPromotionCheckResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/promotion/check`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReplacementOrdersPromotionCheck: Api['postV1ReplacementOrdersPromotionCheck'] = async (request: Types.PostV1ReplacementOrdersPromotionCheckRequest): Promise<Types.PostV1ReplacementOrdersPromotionCheckResponses> => {
  return await _postV1ReplacementOrdersPromotionCheck(baseUrl, request)
}
const _postV1ReplacementOrdersPromotionApply = async (url: string, request: Types.PostV1ReplacementOrdersPromotionApplyRequest): Promise<Types.PostV1ReplacementOrdersPromotionApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/promotion/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReplacementOrdersPromotionApply: Api['postV1ReplacementOrdersPromotionApply'] = async (request: Types.PostV1ReplacementOrdersPromotionApplyRequest): Promise<Types.PostV1ReplacementOrdersPromotionApplyResponses> => {
  return await _postV1ReplacementOrdersPromotionApply(baseUrl, request)
}
const _postV1ReplacementOrdersPromotionItemApply = async (url: string, request: Types.PostV1ReplacementOrdersPromotionItemApplyRequest): Promise<Types.PostV1ReplacementOrdersPromotionItemApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/promotion/item/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReplacementOrdersPromotionItemApply: Api['postV1ReplacementOrdersPromotionItemApply'] = async (request: Types.PostV1ReplacementOrdersPromotionItemApplyRequest): Promise<Types.PostV1ReplacementOrdersPromotionItemApplyResponses> => {
  return await _postV1ReplacementOrdersPromotionItemApply(baseUrl, request)
}
const _deleteV1ReplacementOrdersPromotionId = async (url: string, request: Types.DeleteV1ReplacementOrdersPromotionIdRequest): Promise<Types.DeleteV1ReplacementOrdersPromotionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/promotion/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ReplacementOrdersPromotionId: Api['deleteV1ReplacementOrdersPromotionId'] = async (request: Types.DeleteV1ReplacementOrdersPromotionIdRequest): Promise<Types.DeleteV1ReplacementOrdersPromotionIdResponses> => {
  return await _deleteV1ReplacementOrdersPromotionId(baseUrl, request)
}
const _getV1ReplacementOrdersIdCreateInvoice = async (url: string, request: Types.GetV1ReplacementOrdersIdCreateInvoiceRequest): Promise<Types.GetV1ReplacementOrdersIdCreateInvoiceResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementOrdersIdCreateInvoiceRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/${request['id']}/create-invoice?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementOrdersIdCreateInvoice: Api['getV1ReplacementOrdersIdCreateInvoice'] = async (request: Types.GetV1ReplacementOrdersIdCreateInvoiceRequest): Promise<Types.GetV1ReplacementOrdersIdCreateInvoiceResponses> => {
  return await _getV1ReplacementOrdersIdCreateInvoice(baseUrl, request)
}
const _getV1ReplacementOrdersIdPromotions = async (url: string, request: Types.GetV1ReplacementOrdersIdPromotionsRequest): Promise<Types.GetV1ReplacementOrdersIdPromotionsResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementOrdersIdPromotionsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/${request['id']}/promotions?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementOrdersIdPromotions: Api['getV1ReplacementOrdersIdPromotions'] = async (request: Types.GetV1ReplacementOrdersIdPromotionsRequest): Promise<Types.GetV1ReplacementOrdersIdPromotionsResponses> => {
  return await _getV1ReplacementOrdersIdPromotions(baseUrl, request)
}
const _getV1ReplacementOrdersIdDownload = async (url: string, request: Types.GetV1ReplacementOrdersIdDownloadRequest): Promise<Types.GetV1ReplacementOrdersIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementOrdersIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementOrdersIdDownload: Api['getV1ReplacementOrdersIdDownload'] = async (request: Types.GetV1ReplacementOrdersIdDownloadRequest): Promise<Types.GetV1ReplacementOrdersIdDownloadResponses> => {
  return await _getV1ReplacementOrdersIdDownload(baseUrl, request)
}
const _getV1ReplacementOrdersIdSendEmail = async (url: string, request: Types.GetV1ReplacementOrdersIdSendEmailRequest): Promise<Types.GetV1ReplacementOrdersIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementOrdersIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementOrdersIdSendEmail: Api['getV1ReplacementOrdersIdSendEmail'] = async (request: Types.GetV1ReplacementOrdersIdSendEmailRequest): Promise<Types.GetV1ReplacementOrdersIdSendEmailResponses> => {
  return await _getV1ReplacementOrdersIdSendEmail(baseUrl, request)
}
const _getV1ReplacementOrdersTypeId = async (url: string, request: Types.GetV1ReplacementOrdersTypeIdRequest): Promise<Types.GetV1ReplacementOrdersTypeIdResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementOrdersTypeIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/${request['type']}/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementOrdersTypeId: Api['getV1ReplacementOrdersTypeId'] = async (request: Types.GetV1ReplacementOrdersTypeIdRequest): Promise<Types.GetV1ReplacementOrdersTypeIdResponses> => {
  return await _getV1ReplacementOrdersTypeId(baseUrl, request)
}
const _getV1ReplacementOrdersGenerateExcel = async (url: string, request: Types.GetV1ReplacementOrdersGenerateExcelRequest): Promise<Types.GetV1ReplacementOrdersGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1ReplacementOrdersGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReplacementOrdersGenerateExcel: Api['getV1ReplacementOrdersGenerateExcel'] = async (request: Types.GetV1ReplacementOrdersGenerateExcelRequest): Promise<Types.GetV1ReplacementOrdersGenerateExcelResponses> => {
  return await _getV1ReplacementOrdersGenerateExcel(baseUrl, request)
}
const _postV1ReplacementOrdersImport = async (url: string, request: Types.PostV1ReplacementOrdersImportRequest): Promise<Types.PostV1ReplacementOrdersImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/replacement-orders/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReplacementOrdersImport: Api['postV1ReplacementOrdersImport'] = async (request: Types.PostV1ReplacementOrdersImportRequest): Promise<Types.PostV1ReplacementOrdersImportResponses> => {
  return await _postV1ReplacementOrdersImport(baseUrl, request)
}
type BuildOptions = {
  headers?: Object
}
export default function build (url: string, options?: BuildOptions) {
  url = sanitizeUrl(url)
  if (options?.headers) {
    defaultHeaders = options.headers
  }
  return {
    getV1FileUpload: _getV1FileUpload.bind(url, ...arguments),
    postV1FileUploadMarkComplete: _postV1FileUploadMarkComplete.bind(url, ...arguments),
    getV1RentalSettings: _getV1RentalSettings.bind(url, ...arguments),
    patchV1RentalSettingsId: _patchV1RentalSettingsId.bind(url, ...arguments),
    postV1RentalBillingCycles: _postV1RentalBillingCycles.bind(url, ...arguments),
    getV1RentalBillingCycles: _getV1RentalBillingCycles.bind(url, ...arguments),
    getV1RentalBillingCyclesId: _getV1RentalBillingCyclesId.bind(url, ...arguments),
    putV1RentalBillingCyclesId: _putV1RentalBillingCyclesId.bind(url, ...arguments),
    deleteV1RentalBillingCyclesId: _deleteV1RentalBillingCyclesId.bind(url, ...arguments),
    getV1RentalBillingCyclesGenerateExcel: _getV1RentalBillingCyclesGenerateExcel.bind(url, ...arguments),
    postV1RentalBillingCyclesImport: _postV1RentalBillingCyclesImport.bind(url, ...arguments),
    postV1RentalTermsConditions: _postV1RentalTermsConditions.bind(url, ...arguments),
    getV1RentalTermsConditions: _getV1RentalTermsConditions.bind(url, ...arguments),
    getV1RentalTermsConditionsId: _getV1RentalTermsConditionsId.bind(url, ...arguments),
    putV1RentalTermsConditionsId: _putV1RentalTermsConditionsId.bind(url, ...arguments),
    deleteV1RentalTermsConditionsId: _deleteV1RentalTermsConditionsId.bind(url, ...arguments),
    patchV1RentalTermsConditionsStatusId: _patchV1RentalTermsConditionsStatusId.bind(url, ...arguments),
    getV1RentalTermsConditionsGenerateExcel: _getV1RentalTermsConditionsGenerateExcel.bind(url, ...arguments),
    postV1RentalTermsConditionsImport: _postV1RentalTermsConditionsImport.bind(url, ...arguments),
    getV1RentalLead: _getV1RentalLead.bind(url, ...arguments),
    postV1RentalLead: _postV1RentalLead.bind(url, ...arguments),
    postV1RentalLeadSaveAsDraft: _postV1RentalLeadSaveAsDraft.bind(url, ...arguments),
    getV1RentalLeadId: _getV1RentalLeadId.bind(url, ...arguments),
    putV1RentalLeadId: _putV1RentalLeadId.bind(url, ...arguments),
    deleteV1RentalLeadId: _deleteV1RentalLeadId.bind(url, ...arguments),
    patchV1RentalLeadLeadStatusId: _patchV1RentalLeadLeadStatusId.bind(url, ...arguments),
    patchV1RentalLeadLeadToOpportunityId: _patchV1RentalLeadLeadToOpportunityId.bind(url, ...arguments),
    postV1RentalLeadFollowup: _postV1RentalLeadFollowup.bind(url, ...arguments),
    getV1RentalLeadFollowup: _getV1RentalLeadFollowup.bind(url, ...arguments),
    getV1RentalLeadFollowupId: _getV1RentalLeadFollowupId.bind(url, ...arguments),
    deleteV1RentalLeadFollowupId: _deleteV1RentalLeadFollowupId.bind(url, ...arguments),
    putV1RentalLeadFollowupId: _putV1RentalLeadFollowupId.bind(url, ...arguments),
    postV1RentalLeadCommunicationLog: _postV1RentalLeadCommunicationLog.bind(url, ...arguments),
    getV1RentalLeadCommunicationLog: _getV1RentalLeadCommunicationLog.bind(url, ...arguments),
    getV1RentalLeadCommunicationLogId: _getV1RentalLeadCommunicationLogId.bind(url, ...arguments),
    deleteV1RentalLeadCommunicationLogId: _deleteV1RentalLeadCommunicationLogId.bind(url, ...arguments),
    putV1RentalLeadCommunicationLogId: _putV1RentalLeadCommunicationLogId.bind(url, ...arguments),
    postV1RentalLeadAddress: _postV1RentalLeadAddress.bind(url, ...arguments),
    getV1RentalLeadAddress: _getV1RentalLeadAddress.bind(url, ...arguments),
    getV1RentalLeadAddressId: _getV1RentalLeadAddressId.bind(url, ...arguments),
    deleteV1RentalLeadAddressId: _deleteV1RentalLeadAddressId.bind(url, ...arguments),
    putV1RentalLeadAddressId: _putV1RentalLeadAddressId.bind(url, ...arguments),
    postV1RentalLeadContact: _postV1RentalLeadContact.bind(url, ...arguments),
    getV1RentalLeadContact: _getV1RentalLeadContact.bind(url, ...arguments),
    getV1RentalLeadContactId: _getV1RentalLeadContactId.bind(url, ...arguments),
    deleteV1RentalLeadContactId: _deleteV1RentalLeadContactId.bind(url, ...arguments),
    putV1RentalLeadContactId: _putV1RentalLeadContactId.bind(url, ...arguments),
    getV1RentalLeadIdDownload: _getV1RentalLeadIdDownload.bind(url, ...arguments),
    getV1RentalLeadIdSendEmail: _getV1RentalLeadIdSendEmail.bind(url, ...arguments),
    getV1RentalLeadGenerateExcel: _getV1RentalLeadGenerateExcel.bind(url, ...arguments),
    postV1RentalLeadImport: _postV1RentalLeadImport.bind(url, ...arguments),
    postV1RentalOpportunityPromotionCheck: _postV1RentalOpportunityPromotionCheck.bind(url, ...arguments),
    postV1RentalOpportunityPromotionApply: _postV1RentalOpportunityPromotionApply.bind(url, ...arguments),
    postV1RentalOpportunityPromotionItemApply: _postV1RentalOpportunityPromotionItemApply.bind(url, ...arguments),
    deleteV1RentalOpportunityPromotionId: _deleteV1RentalOpportunityPromotionId.bind(url, ...arguments),
    getV1RentalOpportunity: _getV1RentalOpportunity.bind(url, ...arguments),
    postV1RentalOpportunity: _postV1RentalOpportunity.bind(url, ...arguments),
    postV1RentalOpportunitySaveAsDraft: _postV1RentalOpportunitySaveAsDraft.bind(url, ...arguments),
    getV1RentalOpportunityId: _getV1RentalOpportunityId.bind(url, ...arguments),
    putV1RentalOpportunityId: _putV1RentalOpportunityId.bind(url, ...arguments),
    deleteV1RentalOpportunityId: _deleteV1RentalOpportunityId.bind(url, ...arguments),
    patchV1RentalOpportunityStageId: _patchV1RentalOpportunityStageId.bind(url, ...arguments),
    postV1RentalOpportunityFollowup: _postV1RentalOpportunityFollowup.bind(url, ...arguments),
    getV1RentalOpportunityFollowup: _getV1RentalOpportunityFollowup.bind(url, ...arguments),
    getV1RentalOpportunityFollowupId: _getV1RentalOpportunityFollowupId.bind(url, ...arguments),
    deleteV1RentalOpportunityFollowupId: _deleteV1RentalOpportunityFollowupId.bind(url, ...arguments),
    putV1RentalOpportunityFollowupId: _putV1RentalOpportunityFollowupId.bind(url, ...arguments),
    postV1RentalOpportunityCommunicationLog: _postV1RentalOpportunityCommunicationLog.bind(url, ...arguments),
    getV1RentalOpportunityCommunicationLog: _getV1RentalOpportunityCommunicationLog.bind(url, ...arguments),
    getV1RentalOpportunityCommunicationLogId: _getV1RentalOpportunityCommunicationLogId.bind(url, ...arguments),
    deleteV1RentalOpportunityCommunicationLogId: _deleteV1RentalOpportunityCommunicationLogId.bind(url, ...arguments),
    putV1RentalOpportunityCommunicationLogId: _putV1RentalOpportunityCommunicationLogId.bind(url, ...arguments),
    postV1RentalOpportunityAddress: _postV1RentalOpportunityAddress.bind(url, ...arguments),
    getV1RentalOpportunityAddress: _getV1RentalOpportunityAddress.bind(url, ...arguments),
    getV1RentalOpportunityAddressId: _getV1RentalOpportunityAddressId.bind(url, ...arguments),
    deleteV1RentalOpportunityAddressId: _deleteV1RentalOpportunityAddressId.bind(url, ...arguments),
    putV1RentalOpportunityAddressId: _putV1RentalOpportunityAddressId.bind(url, ...arguments),
    postV1RentalOpportunityContact: _postV1RentalOpportunityContact.bind(url, ...arguments),
    getV1RentalOpportunityContact: _getV1RentalOpportunityContact.bind(url, ...arguments),
    getV1RentalOpportunityContactId: _getV1RentalOpportunityContactId.bind(url, ...arguments),
    deleteV1RentalOpportunityContactId: _deleteV1RentalOpportunityContactId.bind(url, ...arguments),
    putV1RentalOpportunityContactId: _putV1RentalOpportunityContactId.bind(url, ...arguments),
    postV1RentalOpportunityItem: _postV1RentalOpportunityItem.bind(url, ...arguments),
    getV1RentalOpportunityItem: _getV1RentalOpportunityItem.bind(url, ...arguments),
    getV1RentalOpportunityItemId: _getV1RentalOpportunityItemId.bind(url, ...arguments),
    deleteV1RentalOpportunityItemId: _deleteV1RentalOpportunityItemId.bind(url, ...arguments),
    putV1RentalOpportunityItemId: _putV1RentalOpportunityItemId.bind(url, ...arguments),
    getV1RentalOpportunitySalesPipeline: _getV1RentalOpportunitySalesPipeline.bind(url, ...arguments),
    getV1RentalOpportunityIdPromotions: _getV1RentalOpportunityIdPromotions.bind(url, ...arguments),
    getV1RentalOpportunityGenerateExcel: _getV1RentalOpportunityGenerateExcel.bind(url, ...arguments),
    postV1RentalOpportunityImport: _postV1RentalOpportunityImport.bind(url, ...arguments),
    getV1RentalQuotationsId: _getV1RentalQuotationsId.bind(url, ...arguments),
    putV1RentalQuotationsId: _putV1RentalQuotationsId.bind(url, ...arguments),
    deleteV1RentalQuotationsId: _deleteV1RentalQuotationsId.bind(url, ...arguments),
    getV1RentalQuotations: _getV1RentalQuotations.bind(url, ...arguments),
    postV1RentalQuotationsSaveAsDraft: _postV1RentalQuotationsSaveAsDraft.bind(url, ...arguments),
    patchV1RentalQuotationsStatusId: _patchV1RentalQuotationsStatusId.bind(url, ...arguments),
    postV1RentalQuotationsPromotionCheck: _postV1RentalQuotationsPromotionCheck.bind(url, ...arguments),
    postV1RentalQuotationsPromotionApply: _postV1RentalQuotationsPromotionApply.bind(url, ...arguments),
    postV1RentalQuotationsPromotionCouponApply: _postV1RentalQuotationsPromotionCouponApply.bind(url, ...arguments),
    postV1RentalQuotationsPromotionItemApply: _postV1RentalQuotationsPromotionItemApply.bind(url, ...arguments),
    deleteV1RentalQuotationsPromotionId: _deleteV1RentalQuotationsPromotionId.bind(url, ...arguments),
    postV1RentalQuotationsItem: _postV1RentalQuotationsItem.bind(url, ...arguments),
    getV1RentalQuotationsItem: _getV1RentalQuotationsItem.bind(url, ...arguments),
    getV1RentalQuotationsItemId: _getV1RentalQuotationsItemId.bind(url, ...arguments),
    deleteV1RentalQuotationsItemId: _deleteV1RentalQuotationsItemId.bind(url, ...arguments),
    putV1RentalQuotationsItemId: _putV1RentalQuotationsItemId.bind(url, ...arguments),
    getV1RentalQuotationsIdPromotions: _getV1RentalQuotationsIdPromotions.bind(url, ...arguments),
    getV1RentalQuotationsIdDownload: _getV1RentalQuotationsIdDownload.bind(url, ...arguments),
    getV1RentalQuotationsIdSendEmail: _getV1RentalQuotationsIdSendEmail.bind(url, ...arguments),
    getV1RentalQuotationsGenerateExcel: _getV1RentalQuotationsGenerateExcel.bind(url, ...arguments),
    postV1RentalQuotationsImport: _postV1RentalQuotationsImport.bind(url, ...arguments),
    getV1RentalQuotationsOpportunityId: _getV1RentalQuotationsOpportunityId.bind(url, ...arguments),
    getV1RentalQuotationsFetchItemsPartyId: _getV1RentalQuotationsFetchItemsPartyId.bind(url, ...arguments),
    postV1RentalOrders: _postV1RentalOrders.bind(url, ...arguments),
    getV1RentalOrders: _getV1RentalOrders.bind(url, ...arguments),
    postV1RentalOrdersSaveDraft: _postV1RentalOrdersSaveDraft.bind(url, ...arguments),
    getV1RentalOrdersId: _getV1RentalOrdersId.bind(url, ...arguments),
    putV1RentalOrdersId: _putV1RentalOrdersId.bind(url, ...arguments),
    deleteV1RentalOrdersId: _deleteV1RentalOrdersId.bind(url, ...arguments),
    patchV1RentalOrdersStatusId: _patchV1RentalOrdersStatusId.bind(url, ...arguments),
    postV1RentalOrdersAddApprover: _postV1RentalOrdersAddApprover.bind(url, ...arguments),
    putV1RentalOrdersApprovalStatusId: _putV1RentalOrdersApprovalStatusId.bind(url, ...arguments),
    postV1RentalOrdersItems: _postV1RentalOrdersItems.bind(url, ...arguments),
    getV1RentalOrdersItemsId: _getV1RentalOrdersItemsId.bind(url, ...arguments),
    putV1RentalOrdersItemsId: _putV1RentalOrdersItemsId.bind(url, ...arguments),
    deleteV1RentalOrdersItemsId: _deleteV1RentalOrdersItemsId.bind(url, ...arguments),
    postV1RentalOrdersPromotionCheck: _postV1RentalOrdersPromotionCheck.bind(url, ...arguments),
    postV1RentalOrdersPromotionApply: _postV1RentalOrdersPromotionApply.bind(url, ...arguments),
    postV1RentalOrdersPromotionItemApply: _postV1RentalOrdersPromotionItemApply.bind(url, ...arguments),
    deleteV1RentalOrdersPromotionId: _deleteV1RentalOrdersPromotionId.bind(url, ...arguments),
    getV1RentalOrdersIdCreateInvoice: _getV1RentalOrdersIdCreateInvoice.bind(url, ...arguments),
    getV1RentalOrdersIdPromotions: _getV1RentalOrdersIdPromotions.bind(url, ...arguments),
    getV1RentalOrdersIdDownload: _getV1RentalOrdersIdDownload.bind(url, ...arguments),
    getV1RentalOrdersIdGeneratePickingList: _getV1RentalOrdersIdGeneratePickingList.bind(url, ...arguments),
    getV1RentalOrdersIdSendEmail: _getV1RentalOrdersIdSendEmail.bind(url, ...arguments),
    getV1RentalOrdersTypeId: _getV1RentalOrdersTypeId.bind(url, ...arguments),
    getV1RentalOrdersGenerateExcel: _getV1RentalOrdersGenerateExcel.bind(url, ...arguments),
    postV1RentalOrdersImport: _postV1RentalOrdersImport.bind(url, ...arguments),
    getV1RentalOrdersIdGrn: _getV1RentalOrdersIdGrn.bind(url, ...arguments),
    postV1RentalAgreements: _postV1RentalAgreements.bind(url, ...arguments),
    getV1RentalAgreements: _getV1RentalAgreements.bind(url, ...arguments),
    postV1RentalAgreementsSaveDraft: _postV1RentalAgreementsSaveDraft.bind(url, ...arguments),
    getV1RentalAgreementsId: _getV1RentalAgreementsId.bind(url, ...arguments),
    putV1RentalAgreementsId: _putV1RentalAgreementsId.bind(url, ...arguments),
    deleteV1RentalAgreementsId: _deleteV1RentalAgreementsId.bind(url, ...arguments),
    patchV1RentalAgreementsStatusId: _patchV1RentalAgreementsStatusId.bind(url, ...arguments),
    postV1RentalAgreementsAddApprover: _postV1RentalAgreementsAddApprover.bind(url, ...arguments),
    putV1RentalAgreementsApprovalStatusId: _putV1RentalAgreementsApprovalStatusId.bind(url, ...arguments),
    postV1RentalAgreementsItems: _postV1RentalAgreementsItems.bind(url, ...arguments),
    getV1RentalAgreementsItemsId: _getV1RentalAgreementsItemsId.bind(url, ...arguments),
    putV1RentalAgreementsItemsId: _putV1RentalAgreementsItemsId.bind(url, ...arguments),
    deleteV1RentalAgreementsItemsId: _deleteV1RentalAgreementsItemsId.bind(url, ...arguments),
    getV1RentalAgreementsGenerateExcel: _getV1RentalAgreementsGenerateExcel.bind(url, ...arguments),
    postV1RentalAgreementsImport: _postV1RentalAgreementsImport.bind(url, ...arguments),
    postV1RentalDemandPlanningSummary: _postV1RentalDemandPlanningSummary.bind(url, ...arguments),
    postV1RentalDemandPlanningDetail: _postV1RentalDemandPlanningDetail.bind(url, ...arguments),
    postV1RentalDemandPlanningDemand: _postV1RentalDemandPlanningDemand.bind(url, ...arguments),
    postV1RentalDemandPlanningMaterials: _postV1RentalDemandPlanningMaterials.bind(url, ...arguments),
    postV1RentalDemandPlanningGenerateExcel: _postV1RentalDemandPlanningGenerateExcel.bind(url, ...arguments),
    postV1InvoiceRentalOrders: _postV1InvoiceRentalOrders.bind(url, ...arguments),
    postV1InvoiceRentalOrdersGenerateInvoice: _postV1InvoiceRentalOrdersGenerateInvoice.bind(url, ...arguments),
    postV1InvoiceRentalOrdersAccumulateOrders: _postV1InvoiceRentalOrdersAccumulateOrders.bind(url, ...arguments),
    postV1RentalDeliveryOrders: _postV1RentalDeliveryOrders.bind(url, ...arguments),
    getV1RentalDeliveryOrders: _getV1RentalDeliveryOrders.bind(url, ...arguments),
    postV1RentalDeliveryOrdersSaveDraft: _postV1RentalDeliveryOrdersSaveDraft.bind(url, ...arguments),
    getV1RentalDeliveryOrdersId: _getV1RentalDeliveryOrdersId.bind(url, ...arguments),
    deleteV1RentalDeliveryOrdersId: _deleteV1RentalDeliveryOrdersId.bind(url, ...arguments),
    putV1RentalDeliveryOrdersId: _putV1RentalDeliveryOrdersId.bind(url, ...arguments),
    patchV1RentalDeliveryOrdersStatusId: _patchV1RentalDeliveryOrdersStatusId.bind(url, ...arguments),
    getV1RentalDeliveryOrdersItemsId: _getV1RentalDeliveryOrdersItemsId.bind(url, ...arguments),
    putV1RentalDeliveryOrdersItemsId: _putV1RentalDeliveryOrdersItemsId.bind(url, ...arguments),
    deleteV1RentalDeliveryOrdersItemsId: _deleteV1RentalDeliveryOrdersItemsId.bind(url, ...arguments),
    postV1RentalDeliveryOrdersPackages: _postV1RentalDeliveryOrdersPackages.bind(url, ...arguments),
    getV1RentalDeliveryOrdersPackagesId: _getV1RentalDeliveryOrdersPackagesId.bind(url, ...arguments),
    putV1RentalDeliveryOrdersPackagesId: _putV1RentalDeliveryOrdersPackagesId.bind(url, ...arguments),
    deleteV1RentalDeliveryOrdersPackagesId: _deleteV1RentalDeliveryOrdersPackagesId.bind(url, ...arguments),
    getV1RentalDeliveryOrdersIdPackages: _getV1RentalDeliveryOrdersIdPackages.bind(url, ...arguments),
    postV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackages: _postV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackages.bind(url, ...arguments),
    getV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackages: _getV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackages.bind(url, ...arguments),
    deleteV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesId: _deleteV1RentalDeliveryOrdersDeliveryIdItemsItemIdPackagesId.bind(url, ...arguments),
    postV1RentalDeliveryOrdersDeliveryIdItemsItemIdTracking: _postV1RentalDeliveryOrdersDeliveryIdItemsItemIdTracking.bind(url, ...arguments),
    postV1RentalDeliveryOrdersDeliveryIdInventoryAdjustment: _postV1RentalDeliveryOrdersDeliveryIdInventoryAdjustment.bind(url, ...arguments),
    getV1RentalDeliveryOrdersIdCreateInvoice: _getV1RentalDeliveryOrdersIdCreateInvoice.bind(url, ...arguments),
    getV1RentalDeliveryOrdersIdSendEmail: _getV1RentalDeliveryOrdersIdSendEmail.bind(url, ...arguments),
    getV1RentalDeliveryOrdersIdDownload: _getV1RentalDeliveryOrdersIdDownload.bind(url, ...arguments),
    getV1RentalDeliveryOrdersGenerateExcel: _getV1RentalDeliveryOrdersGenerateExcel.bind(url, ...arguments),
    postV1RentalDeliveryOrdersIdGrn: _postV1RentalDeliveryOrdersIdGrn.bind(url, ...arguments),
    getV1RentalDeliveryOrdersIdGrn: _getV1RentalDeliveryOrdersIdGrn.bind(url, ...arguments),
    getV1RentalDeliveryOrdersIdGrnGrnId: _getV1RentalDeliveryOrdersIdGrnGrnId.bind(url, ...arguments),
    deleteV1RentalDeliveryOrdersIdGrnGrnId: _deleteV1RentalDeliveryOrdersIdGrnGrnId.bind(url, ...arguments),
    putV1RentalDeliveryOrdersIdGrnGrnId: _putV1RentalDeliveryOrdersIdGrnGrnId.bind(url, ...arguments),
    getV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId: _getV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId.bind(url, ...arguments),
    putV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId: _putV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId.bind(url, ...arguments),
    deleteV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId: _deleteV1RentalDeliveryOrdersIdGrnGrnIdItemsItemId.bind(url, ...arguments),
    postV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdTracking: _postV1RentalDeliveryOrdersIdGrnGrnIdItemsItemIdTracking.bind(url, ...arguments),
    postV1RentalDeliveryOrdersIdGrnGrnIdInventoryAdjustment: _postV1RentalDeliveryOrdersIdGrnGrnIdInventoryAdjustment.bind(url, ...arguments),
    postV1RentalDeliveryOrdersDeliveryIdItemsItemIdVendorReturnTracking: _postV1RentalDeliveryOrdersDeliveryIdItemsItemIdVendorReturnTracking.bind(url, ...arguments),
    postV1RentalDeliveryOrdersDeliveryIdVendorReturnInventoryAdjustment: _postV1RentalDeliveryOrdersDeliveryIdVendorReturnInventoryAdjustment.bind(url, ...arguments),
    postV1CrossHireRequests: _postV1CrossHireRequests.bind(url, ...arguments),
    getV1CrossHireRequests: _getV1CrossHireRequests.bind(url, ...arguments),
    postV1CrossHireRequestsSaveDraft: _postV1CrossHireRequestsSaveDraft.bind(url, ...arguments),
    getV1CrossHireRequestsId: _getV1CrossHireRequestsId.bind(url, ...arguments),
    putV1CrossHireRequestsId: _putV1CrossHireRequestsId.bind(url, ...arguments),
    deleteV1CrossHireRequestsId: _deleteV1CrossHireRequestsId.bind(url, ...arguments),
    patchV1CrossHireRequestsStatusId: _patchV1CrossHireRequestsStatusId.bind(url, ...arguments),
    postV1CrossHireRequestsAddApprover: _postV1CrossHireRequestsAddApprover.bind(url, ...arguments),
    putV1CrossHireRequestsApprovalStatusId: _putV1CrossHireRequestsApprovalStatusId.bind(url, ...arguments),
    postV1CrossHireRequestsItems: _postV1CrossHireRequestsItems.bind(url, ...arguments),
    getV1CrossHireRequestsItemsId: _getV1CrossHireRequestsItemsId.bind(url, ...arguments),
    putV1CrossHireRequestsItemsId: _putV1CrossHireRequestsItemsId.bind(url, ...arguments),
    deleteV1CrossHireRequestsItemsId: _deleteV1CrossHireRequestsItemsId.bind(url, ...arguments),
    getV1CrossHireRequestsGenerateExcel: _getV1CrossHireRequestsGenerateExcel.bind(url, ...arguments),
    postV1CrossHireRequestsImport: _postV1CrossHireRequestsImport.bind(url, ...arguments),
    getV1CrossHireRequestsIdProvideDetails: _getV1CrossHireRequestsIdProvideDetails.bind(url, ...arguments),
    postV1CrossHireRfq: _postV1CrossHireRfq.bind(url, ...arguments),
    getV1CrossHireRfq: _getV1CrossHireRfq.bind(url, ...arguments),
    postV1CrossHireRfqSaveDraft: _postV1CrossHireRfqSaveDraft.bind(url, ...arguments),
    getV1CrossHireRfqResponseItems: _getV1CrossHireRfqResponseItems.bind(url, ...arguments),
    putV1CrossHireRfqId: _putV1CrossHireRfqId.bind(url, ...arguments),
    getV1CrossHireRfqId: _getV1CrossHireRfqId.bind(url, ...arguments),
    deleteV1CrossHireRfqId: _deleteV1CrossHireRfqId.bind(url, ...arguments),
    patchV1CrossHireRfqIdStatus: _patchV1CrossHireRfqIdStatus.bind(url, ...arguments),
    postV1CrossHireRfqItems: _postV1CrossHireRfqItems.bind(url, ...arguments),
    getV1CrossHireRfqItemsId: _getV1CrossHireRfqItemsId.bind(url, ...arguments),
    putV1CrossHireRfqItemsId: _putV1CrossHireRfqItemsId.bind(url, ...arguments),
    deleteV1CrossHireRfqItemsId: _deleteV1CrossHireRfqItemsId.bind(url, ...arguments),
    postV1CrossHireRfqTender: _postV1CrossHireRfqTender.bind(url, ...arguments),
    deleteV1CrossHireRfqTenderId: _deleteV1CrossHireRfqTenderId.bind(url, ...arguments),
    postV1CrossHireRfqIdResponse: _postV1CrossHireRfqIdResponse.bind(url, ...arguments),
    getV1CrossHireRfqIdResponse: _getV1CrossHireRfqIdResponse.bind(url, ...arguments),
    postV1CrossHireRfqIdResponseSaveDraft: _postV1CrossHireRfqIdResponseSaveDraft.bind(url, ...arguments),
    putV1CrossHireRfqIdResponseResponseId: _putV1CrossHireRfqIdResponseResponseId.bind(url, ...arguments),
    getV1CrossHireRfqIdResponseResponseId: _getV1CrossHireRfqIdResponseResponseId.bind(url, ...arguments),
    deleteV1CrossHireRfqIdResponseResponseId: _deleteV1CrossHireRfqIdResponseResponseId.bind(url, ...arguments),
    getV1CrossHireRfqIdResponseResponseIdItemsItemId: _getV1CrossHireRfqIdResponseResponseIdItemsItemId.bind(url, ...arguments),
    putV1CrossHireRfqIdResponseResponseIdItemsItemId: _putV1CrossHireRfqIdResponseResponseIdItemsItemId.bind(url, ...arguments),
    deleteV1CrossHireRfqIdResponseResponseIdItemsItemId: _deleteV1CrossHireRfqIdResponseResponseIdItemsItemId.bind(url, ...arguments),
    postV1CrossHireRfqIdAnalyze: _postV1CrossHireRfqIdAnalyze.bind(url, ...arguments),
    postV1CrossHireRfqIdAnalyzePreviousPrices: _postV1CrossHireRfqIdAnalyzePreviousPrices.bind(url, ...arguments),
    postV1CrossHireRfqIdAward: _postV1CrossHireRfqIdAward.bind(url, ...arguments),
    getV1CrossHireRfqIdSendEmail: _getV1CrossHireRfqIdSendEmail.bind(url, ...arguments),
    getV1CrossHireRfqIdDownload: _getV1CrossHireRfqIdDownload.bind(url, ...arguments),
    getV1CrossHireRfqIdProvidePoDetails: _getV1CrossHireRfqIdProvidePoDetails.bind(url, ...arguments),
    getV1CrossHireRfqGenerateExcel: _getV1CrossHireRfqGenerateExcel.bind(url, ...arguments),
    postV1CrossHireRfqImport: _postV1CrossHireRfqImport.bind(url, ...arguments),
    getV1CrossHireRfqIdProvideAgreementDetails: _getV1CrossHireRfqIdProvideAgreementDetails.bind(url, ...arguments),
    postV1CrossHireOrders: _postV1CrossHireOrders.bind(url, ...arguments),
    getV1CrossHireOrders: _getV1CrossHireOrders.bind(url, ...arguments),
    postV1CrossHireOrdersSaveDraft: _postV1CrossHireOrdersSaveDraft.bind(url, ...arguments),
    getV1CrossHireOrdersId: _getV1CrossHireOrdersId.bind(url, ...arguments),
    putV1CrossHireOrdersId: _putV1CrossHireOrdersId.bind(url, ...arguments),
    deleteV1CrossHireOrdersId: _deleteV1CrossHireOrdersId.bind(url, ...arguments),
    patchV1CrossHireOrdersIdStatus: _patchV1CrossHireOrdersIdStatus.bind(url, ...arguments),
    postV1CrossHireOrdersAddApprover: _postV1CrossHireOrdersAddApprover.bind(url, ...arguments),
    putV1CrossHireOrdersApprovalStatusId: _putV1CrossHireOrdersApprovalStatusId.bind(url, ...arguments),
    postV1CrossHireOrdersItems: _postV1CrossHireOrdersItems.bind(url, ...arguments),
    getV1CrossHireOrdersItemsId: _getV1CrossHireOrdersItemsId.bind(url, ...arguments),
    putV1CrossHireOrdersItemsId: _putV1CrossHireOrdersItemsId.bind(url, ...arguments),
    deleteV1CrossHireOrdersItemsId: _deleteV1CrossHireOrdersItemsId.bind(url, ...arguments),
    postV1CrossHireOrdersExpenses: _postV1CrossHireOrdersExpenses.bind(url, ...arguments),
    getV1CrossHireOrdersExpensesId: _getV1CrossHireOrdersExpensesId.bind(url, ...arguments),
    putV1CrossHireOrdersExpensesId: _putV1CrossHireOrdersExpensesId.bind(url, ...arguments),
    deleteV1CrossHireOrdersExpensesId: _deleteV1CrossHireOrdersExpensesId.bind(url, ...arguments),
    postV1CrossHireOrdersIdGrn: _postV1CrossHireOrdersIdGrn.bind(url, ...arguments),
    getV1CrossHireOrdersIdGrn: _getV1CrossHireOrdersIdGrn.bind(url, ...arguments),
    putV1CrossHireOrdersIdGrnGrnId: _putV1CrossHireOrdersIdGrnGrnId.bind(url, ...arguments),
    getV1CrossHireOrdersIdGrnGrnId: _getV1CrossHireOrdersIdGrnGrnId.bind(url, ...arguments),
    deleteV1CrossHireOrdersIdGrnGrnId: _deleteV1CrossHireOrdersIdGrnGrnId.bind(url, ...arguments),
    getV1CrossHireOrdersIdGrnGrnIdDownload: _getV1CrossHireOrdersIdGrnGrnIdDownload.bind(url, ...arguments),
    getV1CrossHireOrdersIdGrnGrnIdItemItemId: _getV1CrossHireOrdersIdGrnGrnIdItemItemId.bind(url, ...arguments),
    putV1CrossHireOrdersIdGrnGrnIdItemItemId: _putV1CrossHireOrdersIdGrnGrnIdItemItemId.bind(url, ...arguments),
    deleteV1CrossHireOrdersIdGrnGrnIdItemItemId: _deleteV1CrossHireOrdersIdGrnGrnIdItemItemId.bind(url, ...arguments),
    postV1CrossHireOrdersIdGrnGrnIdItemsItemIdTracking: _postV1CrossHireOrdersIdGrnGrnIdItemsItemIdTracking.bind(url, ...arguments),
    postV1CrossHireOrdersIdGrnGrnIdInventoryAdjustment: _postV1CrossHireOrdersIdGrnGrnIdInventoryAdjustment.bind(url, ...arguments),
    getV1CrossHireOrdersIdCreateBill: _getV1CrossHireOrdersIdCreateBill.bind(url, ...arguments),
    getV1CrossHireOrdersReceipts: _getV1CrossHireOrdersReceipts.bind(url, ...arguments),
    getV1CrossHireOrdersIdSendEmail: _getV1CrossHireOrdersIdSendEmail.bind(url, ...arguments),
    getV1CrossHireOrdersIdDownload: _getV1CrossHireOrdersIdDownload.bind(url, ...arguments),
    getV1CrossHireOrdersOrderIdGrnIdScrap: _getV1CrossHireOrdersOrderIdGrnIdScrap.bind(url, ...arguments),
    getV1CrossHireOrdersGenerateExcel: _getV1CrossHireOrdersGenerateExcel.bind(url, ...arguments),
    postV1CrossHireOrdersImport: _postV1CrossHireOrdersImport.bind(url, ...arguments),
    postV1CrossHireOrdersDeliveryOrder: _postV1CrossHireOrdersDeliveryOrder.bind(url, ...arguments),
    postV1CrossHireOrdersDeliveryOrderSaveDraft: _postV1CrossHireOrdersDeliveryOrderSaveDraft.bind(url, ...arguments),
    getV1CrossHireOrdersDeliveryOrder: _getV1CrossHireOrdersDeliveryOrder.bind(url, ...arguments),
    getV1CrossHireOrdersDeliveryOrderId: _getV1CrossHireOrdersDeliveryOrderId.bind(url, ...arguments),
    deleteV1CrossHireOrdersDeliveryOrderId: _deleteV1CrossHireOrdersDeliveryOrderId.bind(url, ...arguments),
    putV1CrossHireOrdersDeliveryOrderId: _putV1CrossHireOrdersDeliveryOrderId.bind(url, ...arguments),
    patchV1CrossHireOrdersDeliveryOrderStatusId: _patchV1CrossHireOrdersDeliveryOrderStatusId.bind(url, ...arguments),
    getV1CrossHireOrdersDeliveryOrderItemsId: _getV1CrossHireOrdersDeliveryOrderItemsId.bind(url, ...arguments),
    putV1CrossHireOrdersDeliveryOrderItemsId: _putV1CrossHireOrdersDeliveryOrderItemsId.bind(url, ...arguments),
    deleteV1CrossHireOrdersDeliveryOrderItemsId: _deleteV1CrossHireOrdersDeliveryOrderItemsId.bind(url, ...arguments),
    postV1CrossHireOrdersDeliveryOrderPackages: _postV1CrossHireOrdersDeliveryOrderPackages.bind(url, ...arguments),
    getV1CrossHireOrdersDeliveryOrderPackagesId: _getV1CrossHireOrdersDeliveryOrderPackagesId.bind(url, ...arguments),
    putV1CrossHireOrdersDeliveryOrderPackagesId: _putV1CrossHireOrdersDeliveryOrderPackagesId.bind(url, ...arguments),
    deleteV1CrossHireOrdersDeliveryOrderPackagesId: _deleteV1CrossHireOrdersDeliveryOrderPackagesId.bind(url, ...arguments),
    getV1CrossHireOrdersDeliveryOrderIdPackages: _getV1CrossHireOrdersDeliveryOrderIdPackages.bind(url, ...arguments),
    postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackages: _postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackages.bind(url, ...arguments),
    getV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackages: _getV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackages.bind(url, ...arguments),
    deleteV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesId: _deleteV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdPackagesId.bind(url, ...arguments),
    postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdTracking: _postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdTracking.bind(url, ...arguments),
    postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdInventoryAdjustment: _postV1CrossHireOrdersDeliveryOrderDeliveryIdItemsItemIdInventoryAdjustment.bind(url, ...arguments),
    getV1CrossHireOrdersDeliveryOrderIdCreateInvoice: _getV1CrossHireOrdersDeliveryOrderIdCreateInvoice.bind(url, ...arguments),
    getV1CrossHireOrdersDeliveryOrderIdSendEmail: _getV1CrossHireOrdersDeliveryOrderIdSendEmail.bind(url, ...arguments),
    getV1CrossHireOrdersDeliveryOrderIdDownload: _getV1CrossHireOrdersDeliveryOrderIdDownload.bind(url, ...arguments),
    getV1CrossHireOrdersDeliveryOrderGenerateExcel: _getV1CrossHireOrdersDeliveryOrderGenerateExcel.bind(url, ...arguments),
    getV1CrossHireOrdersIdMarkShippedRentalOrderId: _getV1CrossHireOrdersIdMarkShippedRentalOrderId.bind(url, ...arguments),
    postV1CrossHireOrdersDeliveryOrderIdGrn: _postV1CrossHireOrdersDeliveryOrderIdGrn.bind(url, ...arguments),
    getV1CrossHireOrdersDeliveryOrderIdGrn: _getV1CrossHireOrdersDeliveryOrderIdGrn.bind(url, ...arguments),
    getV1CrossHireOrdersDeliveryOrderIdGrnGrnId: _getV1CrossHireOrdersDeliveryOrderIdGrnGrnId.bind(url, ...arguments),
    deleteV1CrossHireOrdersDeliveryOrderIdGrnGrnId: _deleteV1CrossHireOrdersDeliveryOrderIdGrnGrnId.bind(url, ...arguments),
    putV1CrossHireOrdersDeliveryOrderIdGrnGrnId: _putV1CrossHireOrdersDeliveryOrderIdGrnGrnId.bind(url, ...arguments),
    getV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId: _getV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId.bind(url, ...arguments),
    putV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId: _putV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId.bind(url, ...arguments),
    deleteV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId: _deleteV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemId.bind(url, ...arguments),
    postV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdTracking: _postV1CrossHireOrdersDeliveryOrderIdGrnGrnIdItemsItemIdTracking.bind(url, ...arguments),
    postV1CrossHireOrdersDeliveryOrderIdGrnGrnIdInventoryAdjustment: _postV1CrossHireOrdersDeliveryOrderIdGrnGrnIdInventoryAdjustment.bind(url, ...arguments),
    getV1InvoiceRentalJobs: _getV1InvoiceRentalJobs.bind(url, ...arguments),
    getV1InvoiceRentalJobsId: _getV1InvoiceRentalJobsId.bind(url, ...arguments),
    getV1InvoiceRentalJobsIdRetryOrderId: _getV1InvoiceRentalJobsIdRetryOrderId.bind(url, ...arguments),
    postV1ProcessCrossHire: _postV1ProcessCrossHire.bind(url, ...arguments),
    postV1ProcessCrossHireSaveRfq: _postV1ProcessCrossHireSaveRfq.bind(url, ...arguments),
    postV1ProcessCrossHireSaveOrders: _postV1ProcessCrossHireSaveOrders.bind(url, ...arguments),
    getV1ReplacementQuotationsId: _getV1ReplacementQuotationsId.bind(url, ...arguments),
    putV1ReplacementQuotationsId: _putV1ReplacementQuotationsId.bind(url, ...arguments),
    deleteV1ReplacementQuotationsId: _deleteV1ReplacementQuotationsId.bind(url, ...arguments),
    getV1ReplacementQuotations: _getV1ReplacementQuotations.bind(url, ...arguments),
    postV1ReplacementQuotationsSaveAsDraft: _postV1ReplacementQuotationsSaveAsDraft.bind(url, ...arguments),
    patchV1ReplacementQuotationsStatusId: _patchV1ReplacementQuotationsStatusId.bind(url, ...arguments),
    postV1ReplacementQuotationsPromotionCheck: _postV1ReplacementQuotationsPromotionCheck.bind(url, ...arguments),
    postV1ReplacementQuotationsPromotionApply: _postV1ReplacementQuotationsPromotionApply.bind(url, ...arguments),
    postV1ReplacementQuotationsPromotionCouponApply: _postV1ReplacementQuotationsPromotionCouponApply.bind(url, ...arguments),
    postV1ReplacementQuotationsPromotionItemApply: _postV1ReplacementQuotationsPromotionItemApply.bind(url, ...arguments),
    deleteV1ReplacementQuotationsPromotionId: _deleteV1ReplacementQuotationsPromotionId.bind(url, ...arguments),
    postV1ReplacementQuotationsItem: _postV1ReplacementQuotationsItem.bind(url, ...arguments),
    getV1ReplacementQuotationsItem: _getV1ReplacementQuotationsItem.bind(url, ...arguments),
    getV1ReplacementQuotationsItemId: _getV1ReplacementQuotationsItemId.bind(url, ...arguments),
    deleteV1ReplacementQuotationsItemId: _deleteV1ReplacementQuotationsItemId.bind(url, ...arguments),
    putV1ReplacementQuotationsItemId: _putV1ReplacementQuotationsItemId.bind(url, ...arguments),
    getV1ReplacementQuotationsIdPromotions: _getV1ReplacementQuotationsIdPromotions.bind(url, ...arguments),
    getV1ReplacementQuotationsIdDownload: _getV1ReplacementQuotationsIdDownload.bind(url, ...arguments),
    getV1ReplacementQuotationsIdSendEmail: _getV1ReplacementQuotationsIdSendEmail.bind(url, ...arguments),
    getV1ReplacementQuotationsGenerateExcel: _getV1ReplacementQuotationsGenerateExcel.bind(url, ...arguments),
    postV1ReplacementQuotationsImport: _postV1ReplacementQuotationsImport.bind(url, ...arguments),
    getV1ReplacementQuotationsOpportunityId: _getV1ReplacementQuotationsOpportunityId.bind(url, ...arguments),
    getV1ReplacementQuotationsFetchItemsPartyId: _getV1ReplacementQuotationsFetchItemsPartyId.bind(url, ...arguments),
    getV1ReplacementQuotationsProvideRqDetailsGrnId: _getV1ReplacementQuotationsProvideRqDetailsGrnId.bind(url, ...arguments),
    postV1ReplacementOrders: _postV1ReplacementOrders.bind(url, ...arguments),
    getV1ReplacementOrders: _getV1ReplacementOrders.bind(url, ...arguments),
    postV1ReplacementOrdersSaveDraft: _postV1ReplacementOrdersSaveDraft.bind(url, ...arguments),
    getV1ReplacementOrdersId: _getV1ReplacementOrdersId.bind(url, ...arguments),
    putV1ReplacementOrdersId: _putV1ReplacementOrdersId.bind(url, ...arguments),
    deleteV1ReplacementOrdersId: _deleteV1ReplacementOrdersId.bind(url, ...arguments),
    patchV1ReplacementOrdersStatusId: _patchV1ReplacementOrdersStatusId.bind(url, ...arguments),
    postV1ReplacementOrdersAddApprover: _postV1ReplacementOrdersAddApprover.bind(url, ...arguments),
    putV1ReplacementOrdersApprovalStatusId: _putV1ReplacementOrdersApprovalStatusId.bind(url, ...arguments),
    postV1ReplacementOrdersItems: _postV1ReplacementOrdersItems.bind(url, ...arguments),
    getV1ReplacementOrdersItemsId: _getV1ReplacementOrdersItemsId.bind(url, ...arguments),
    putV1ReplacementOrdersItemsId: _putV1ReplacementOrdersItemsId.bind(url, ...arguments),
    deleteV1ReplacementOrdersItemsId: _deleteV1ReplacementOrdersItemsId.bind(url, ...arguments),
    postV1ReplacementOrdersPromotionCheck: _postV1ReplacementOrdersPromotionCheck.bind(url, ...arguments),
    postV1ReplacementOrdersPromotionApply: _postV1ReplacementOrdersPromotionApply.bind(url, ...arguments),
    postV1ReplacementOrdersPromotionItemApply: _postV1ReplacementOrdersPromotionItemApply.bind(url, ...arguments),
    deleteV1ReplacementOrdersPromotionId: _deleteV1ReplacementOrdersPromotionId.bind(url, ...arguments),
    getV1ReplacementOrdersIdCreateInvoice: _getV1ReplacementOrdersIdCreateInvoice.bind(url, ...arguments),
    getV1ReplacementOrdersIdPromotions: _getV1ReplacementOrdersIdPromotions.bind(url, ...arguments),
    getV1ReplacementOrdersIdDownload: _getV1ReplacementOrdersIdDownload.bind(url, ...arguments),
    getV1ReplacementOrdersIdSendEmail: _getV1ReplacementOrdersIdSendEmail.bind(url, ...arguments),
    getV1ReplacementOrdersTypeId: _getV1ReplacementOrdersTypeId.bind(url, ...arguments),
    getV1ReplacementOrdersGenerateExcel: _getV1ReplacementOrdersGenerateExcel.bind(url, ...arguments),
    postV1ReplacementOrdersImport: _postV1ReplacementOrdersImport.bind(url, ...arguments)
  }
}